// Auto-generated chronological chat history dataset
// Strict chronological record between Ratnadwip Sarkar and Ankita Aich

export type MessageSender = 'Ratnadwip' | 'Ankita';

export type MessageType =
  | 'text'
  | 'image'
  | 'video'
  | 'audio'
  | 'voice_note'
  | 'sticker'
  | 'document'
  | 'contact'
  | 'link'
  | 'call';

export interface ChatMessage {
  id: string;
  sender: MessageSender;
  time: string;
  date: string;
  dateLabel: string;
  text: string;
  type: MessageType;
  platform?: 'whatsapp' | 'instagram';
  mediaName?: string;
  linkUrl?: string;
  milestone?: string;
}

export interface ChatMilestone {
  id: string;
  title: string;
  subtitle: string;
  badge: string;
  startDate: string;
  endDate: string;
  description: string;
}

export const CHAT_MILESTONES: ChatMilestone[] = [
  {
    "id": "all",
    "title": "Full Archive",
    "subtitle": "All 2,515 messages",
    "badge": "Chronological",
    "startDate": "2026-06-22",
    "endDate": "2026-10-23",
    "description": "Complete record of communications between Ratnadwip and Ankita."
  },
  {
    "id": "early",
    "title": "First Connection",
    "subtitle": "June 2026",
    "badge": "Inception",
    "startDate": "2026-06-22",
    "endDate": "2026-06-30",
    "description": "Early college exchanges, resume formatting, and bouquet web app sharing."
  },
  {
    "id": "birthday",
    "title": "Rakhi & Shared Birthday",
    "subtitle": "28-30 August 2026",
    "badge": "Emotional Shift",
    "startDate": "2026-08-26",
    "endDate": "2026-08-30",
    "description": "Shared birthday celebrations (29 August) and deepening emotional connection."
  },
  {
    "id": "teachers_day",
    "title": "Teacher's Day",
    "subtitle": "7-9 September 2026",
    "badge": "Affection & Fear",
    "startDate": "2026-09-07",
    "endDate": "2026-09-09",
    "description": "Matching outfits, physical closeness on the train, and initial verbal reservations."
  },
  {
    "id": "hackathon",
    "title": "Hackathon & Closeness",
    "subtitle": "Late September 2026",
    "badge": "Physical Intimacy",
    "startDate": "2026-09-18",
    "endDate": "2026-09-30",
    "description": "Collaborative projects, intense closeness, hand-holding, and kissing."
  },
  {
    "id": "durga_puja",
    "title": "Durga Puja Outing",
    "subtitle": "Early October 2026",
    "badge": "Peak Warmth",
    "startDate": "2026-10-01",
    "endDate": "2026-10-06",
    "description": "Outing together, drinks, bike ride, kissing, and affectionate romantic phone calls."
  },
  {
    "id": "kolkata",
    "title": "Kolkata Incident",
    "subtitle": "18-21 October 2026",
    "badge": "Conflict Trigger",
    "startDate": "2026-10-18",
    "endDate": "2026-10-21",
    "description": "Ratnadwip travels to Kolkata to meet Ankita; friction, miscommunication, and distress occur."
  },
  {
    "id": "breakdown",
    "title": "October 23 Breakdown",
    "subtitle": "22-23 October 2026",
    "badge": "Distance Statement",
    "startDate": "2026-10-22",
    "endDate": "2026-10-23",
    "description": "Ankita declares boundary (\"Ami tor theke durey thakte chai\"); silence ensues."
  }
];

export const CHAT_MESSAGES: ChatMessage[] = [
  {
    "id": "m_1",
    "sender": "Ankita",
    "time": "14:25",
    "date": "2026-06-22",
    "dateLabel": "22 June 2026",
    "text": "Ankita Aich\n​Kolkata, West Bengal, India\nPhone: +91 9038961709 | Email: aaich8036@gmail.com\nLinkedIn: linkedin.com/in/Ankita-Aich | GitHub: github.com/ankitaaichhh29 | X (Twitter): @Ankita_Aich29\n​Professional Summary\n​Enthusiastic and highly motivated first-year Computer Science and Engineering undergraduate with a solid foundation in programming paradigms, database management, and web technologies. Passionate about software development, problem-solving, and building efficient applications. Eager to leverage strong technical skills in C, C++, Python, and MySQL through collaborative projects, hackathons, and internship opportunities.\n​Education\n​Bachelor of Technology (B.Tech) in Computer Science & Engineering\n​Hooghly Engineering and Technology College (HETC) | 2025 – Present\n​Relevant Coursework: Programming for Problem Solving (C/C++), Engineering Mathematics, Digital Electronics.\n​Higher Secondary (Class XII)\n​Rahara Bhabanath Institution for Girls, Khardaha | Graduated: 2025\n​Stream: Science (Physics, Chemistry, Mathematics, Computer Science)\n​Technical Skills\n​Programming Languages: C, C++, C#, Python, Python Developer Ecosystem\n​Web Development: HTML5, CSS3\n​Database Management: Database Management Systems (DBMS), MySQL\n​Tools & Version Control: Git, GitHub, MS Office Suite (Word, Excel, PowerPoint)\n​Projects\n​Personal Portfolio Website\n​Technologies used: HTML5, CSS3, GitHub Pages\n​Developed a responsive personal portfolio website to showcase academic achievements, skills, and social profiles.\n​Optimized the layout for seamless viewing across mobile and desktop devices.\n​Database Management System (DBMS) Prototype\n​Technologies used: MySQL, Python/C++\n​Designed and executed a basic relational database structure utilizing SQL queries for data insertion, retrieval, and manipulation.\n​Handled schema design focusing on relational integrity and data normalization basics.\n​Key Academic Achievements\n​Actively participating in college tech communities and coding clubs to hone data structures and algorithms (DSA) skills.\n​Successfully managed academic technical reports and presentations during the initial semesters.\n​Soft Skills\n​Strong Analytical & Logical Thinking\n​Effective Verbal and Written Communication\n​Team Collaboration and Project Management\n​Quick Learner and Adaptable to New Technologies\n​💡 Tips for Customizing This Further:\n​GitHub Links: Make sure to hyperlink your GitHub username directly to your profile.\n​Projects: As you build small console applications (like a calculator in C++ or a basic web scraper in Python) over your first year, add them to the Projects section.\n​Formatting: When transferring this to a Word processor or Google Docs, keep the fonts clean (like Arial, Calibri, or Helvetica) and stick to a standard 1-page layout.",
    "type": "text",
    "milestone": "Early Connection"
  },
  {
    "id": "m_2",
    "sender": "Ratnadwip",
    "time": "14:35",
    "date": "2026-06-22",
    "dateLabel": "22 June 2026",
    "text": "<Media omitted>\nAA.pdf",
    "type": "document",
    "mediaName": "AA.pdf",
    "milestone": "Early Connection"
  },
  {
    "id": "m_3",
    "sender": "Ratnadwip",
    "time": "00:40",
    "date": "2026-06-28",
    "dateLabel": "28 June 2026",
    "text": "https://bouquet.745482.xyz/?exam",
    "type": "link",
    "linkUrl": "https://bouquet.745482.xyz/?exam",
    "milestone": "Early Connection"
  },
  {
    "id": "m_4",
    "sender": "Ankita",
    "time": "00:42",
    "date": "2026-06-28",
    "dateLabel": "28 June 2026",
    "text": "Kono meye pochondo holey clg er pathiye dee...",
    "type": "text",
    "milestone": "Early Connection"
  },
  {
    "id": "m_5",
    "sender": "Ankita",
    "time": "00:42",
    "date": "2026-06-28",
    "dateLabel": "28 June 2026",
    "text": "Potey jabe",
    "type": "text",
    "milestone": "Early Connection"
  },
  {
    "id": "m_6",
    "sender": "Ankita",
    "time": "00:43",
    "date": "2026-06-28",
    "dateLabel": "28 June 2026",
    "text": "😆😆😆🙏",
    "type": "text",
    "milestone": "Early Connection"
  },
  {
    "id": "m_7",
    "sender": "Ankita",
    "time": "00:43",
    "date": "2026-06-28",
    "dateLabel": "28 June 2026",
    "text": "I swear",
    "type": "text",
    "milestone": "Early Connection"
  },
  {
    "id": "m_8",
    "sender": "Ratnadwip",
    "time": "00:44",
    "date": "2026-06-28",
    "dateLabel": "28 June 2026",
    "text": "https://bouquet.745482.xyz/?sorry",
    "type": "link",
    "linkUrl": "https://bouquet.745482.xyz/?sorry",
    "milestone": "Early Connection"
  },
  {
    "id": "m_9",
    "sender": "Ankita",
    "time": "00:45",
    "date": "2026-06-28",
    "dateLabel": "28 June 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo",
    "milestone": "Early Connection"
  },
  {
    "id": "m_10",
    "sender": "Ratnadwip",
    "time": "00:32",
    "date": "2026-07-03",
    "dateLabel": "3 July 2026",
    "text": "🥲",
    "type": "text"
  },
  {
    "id": "m_11",
    "sender": "Ankita",
    "time": "00:34",
    "date": "2026-07-03",
    "dateLabel": "3 July 2026",
    "text": "🤧",
    "type": "text"
  },
  {
    "id": "m_12",
    "sender": "Ratnadwip",
    "time": "00:34",
    "date": "2026-07-03",
    "dateLabel": "3 July 2026",
    "text": "gaan ta ekta ache",
    "type": "text"
  },
  {
    "id": "m_13",
    "sender": "Ankita",
    "time": "00:34",
    "date": "2026-07-03",
    "dateLabel": "3 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_14",
    "sender": "Ankita",
    "time": "00:34",
    "date": "2026-07-03",
    "dateLabel": "3 July 2026",
    "text": "Ik ik",
    "type": "text"
  },
  {
    "id": "m_15",
    "sender": "Ratnadwip",
    "time": "00:35",
    "date": "2026-07-03",
    "dateLabel": "3 July 2026",
    "text": "crazy hit kore",
    "type": "text"
  },
  {
    "id": "m_16",
    "sender": "Ankita",
    "time": "00:35",
    "date": "2026-07-03",
    "dateLabel": "3 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_17",
    "sender": "Ankita",
    "time": "00:35",
    "date": "2026-07-03",
    "dateLabel": "3 July 2026",
    "text": "Khub bje bhabey",
    "type": "text"
  },
  {
    "id": "m_18",
    "sender": "Ratnadwip",
    "time": "00:36",
    "date": "2026-07-03",
    "dateLabel": "3 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_19",
    "sender": "Ankita",
    "time": "00:36",
    "date": "2026-07-03",
    "dateLabel": "3 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_20",
    "sender": "Ratnadwip",
    "time": "00:36",
    "date": "2026-07-03",
    "dateLabel": "3 July 2026",
    "text": "math korbo ebar 🫡",
    "type": "text"
  },
  {
    "id": "m_21",
    "sender": "Ankita",
    "time": "00:36",
    "date": "2026-07-03",
    "dateLabel": "3 July 2026",
    "text": "Kor",
    "type": "text"
  },
  {
    "id": "m_22",
    "sender": "Ratnadwip",
    "time": "00:36",
    "date": "2026-07-03",
    "dateLabel": "3 July 2026",
    "text": "bassline ta. 🫶🏻",
    "type": "text"
  },
  {
    "id": "m_23",
    "sender": "Ankita",
    "time": "00:36",
    "date": "2026-07-03",
    "dateLabel": "3 July 2026",
    "text": "Ami reels dekhi",
    "type": "text"
  },
  {
    "id": "m_24",
    "sender": "Ratnadwip",
    "time": "00:36",
    "date": "2026-07-03",
    "dateLabel": "3 July 2026",
    "text": "🫡🫡",
    "type": "text"
  },
  {
    "id": "m_25",
    "sender": "Ankita",
    "time": "00:37",
    "date": "2026-07-03",
    "dateLabel": "3 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_26",
    "sender": "Ankita",
    "time": "00:37",
    "date": "2026-07-03",
    "dateLabel": "3 July 2026",
    "text": "🤧",
    "type": "text"
  },
  {
    "id": "m_27",
    "sender": "Ratnadwip",
    "time": "09:40",
    "date": "2026-07-03",
    "dateLabel": "3 July 2026",
    "text": "https://share.gemini.google/Zd3Z0SpT2Gyd",
    "type": "link",
    "linkUrl": "https://share.gemini.google/Zd3Z0SpT2Gyd"
  },
  {
    "id": "m_28",
    "sender": "Ratnadwip",
    "time": "15:07",
    "date": "2026-07-06",
    "dateLabel": "6 July 2026",
    "text": "😂",
    "type": "text"
  },
  {
    "id": "m_29",
    "sender": "Ankita",
    "time": "16:01",
    "date": "2026-07-06",
    "dateLabel": "6 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_30",
    "sender": "Ankita",
    "time": "16:01",
    "date": "2026-07-06",
    "dateLabel": "6 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_31",
    "sender": "Ratnadwip",
    "time": "19:15",
    "date": "2026-07-08",
    "dateLabel": "8 July 2026",
    "text": "😂",
    "type": "text"
  },
  {
    "id": "m_32",
    "sender": "Ankita",
    "time": "19:15",
    "date": "2026-07-08",
    "dateLabel": "8 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_33",
    "sender": "Ratnadwip",
    "time": "19:17",
    "date": "2026-07-08",
    "dateLabel": "8 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_34",
    "sender": "Ratnadwip",
    "time": "19:47",
    "date": "2026-07-08",
    "dateLabel": "8 July 2026",
    "text": "",
    "type": "text"
  },
  {
    "id": "m_35",
    "sender": "Ankita",
    "time": "20:02",
    "date": "2026-07-08",
    "dateLabel": "8 July 2026",
    "text": "😂",
    "type": "text"
  },
  {
    "id": "m_36",
    "sender": "Ankita",
    "time": "20:03",
    "date": "2026-07-08",
    "dateLabel": "8 July 2026",
    "text": "Sus er full form ki re??🤔🙃",
    "type": "text"
  },
  {
    "id": "m_37",
    "sender": "Ratnadwip",
    "time": "20:03",
    "date": "2026-07-08",
    "dateLabel": "8 July 2026",
    "text": "suspected",
    "type": "text"
  },
  {
    "id": "m_38",
    "sender": "Ankita",
    "time": "20:04",
    "date": "2026-07-08",
    "dateLabel": "8 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_39",
    "sender": "Ratnadwip",
    "time": "19:05",
    "date": "2026-07-09",
    "dateLabel": "9 July 2026",
    "text": "https://bouquet.745482.xyz/?getwell",
    "type": "link",
    "linkUrl": "https://bouquet.745482.xyz/?getwell"
  },
  {
    "id": "m_40",
    "sender": "Ankita",
    "time": "19:06",
    "date": "2026-07-09",
    "dateLabel": "9 July 2026",
    "text": "🙏🤦🏻‍♀️🤣",
    "type": "text"
  },
  {
    "id": "m_41",
    "sender": "Ratnadwip",
    "time": "23:42",
    "date": "2026-07-10",
    "dateLabel": "10 July 2026",
    "text": "invite me. bhalo menu koris",
    "type": "text"
  },
  {
    "id": "m_42",
    "sender": "Ankita",
    "time": "00:01",
    "date": "2026-07-11",
    "dateLabel": "11 July 2026",
    "text": "AUD-20260711-WA0000.mp3 (file attached)",
    "type": "audio",
    "mediaName": "AUD-20260711-WA0000.mp3"
  },
  {
    "id": "m_43",
    "sender": "Ankita",
    "time": "01:01",
    "date": "2026-07-11",
    "dateLabel": "11 July 2026",
    "text": "Bye gng",
    "type": "text"
  },
  {
    "id": "m_44",
    "sender": "Ankita",
    "time": "01:02",
    "date": "2026-07-11",
    "dateLabel": "11 July 2026",
    "text": "Time to go scrolling my reels 🙃",
    "type": "text"
  },
  {
    "id": "m_45",
    "sender": "Ratnadwip",
    "time": "01:02",
    "date": "2026-07-11",
    "dateLabel": "11 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_46",
    "sender": "Ankita",
    "time": "01:02",
    "date": "2026-07-11",
    "dateLabel": "11 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_47",
    "sender": "Ratnadwip",
    "time": "01:02",
    "date": "2026-07-11",
    "dateLabel": "11 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_48",
    "sender": "Ankita",
    "time": "01:03",
    "date": "2026-07-11",
    "dateLabel": "11 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_49",
    "sender": "Ratnadwip",
    "time": "01:03",
    "date": "2026-07-11",
    "dateLabel": "11 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_50",
    "sender": "Ankita",
    "time": "01:03",
    "date": "2026-07-11",
    "dateLabel": "11 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_51",
    "sender": "Ankita",
    "time": "01:03",
    "date": "2026-07-11",
    "dateLabel": "11 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_52",
    "sender": "Ratnadwip",
    "time": "08:08",
    "date": "2026-07-11",
    "dateLabel": "11 July 2026",
    "text": "aschis ? <This message was edited>",
    "type": "text"
  },
  {
    "id": "m_53",
    "sender": "Ankita",
    "time": "12:08",
    "date": "2026-07-11",
    "dateLabel": "11 July 2026",
    "text": "Naa",
    "type": "text"
  },
  {
    "id": "m_54",
    "sender": "Ratnadwip",
    "time": "19:42",
    "date": "2026-07-11",
    "dateLabel": "11 July 2026",
    "text": "VID-20260711-WA0012.mp4 (file attached)",
    "type": "video",
    "mediaName": "VID-20260711-WA0012.mp4"
  },
  {
    "id": "m_55",
    "sender": "Ratnadwip",
    "time": "19:42",
    "date": "2026-07-11",
    "dateLabel": "11 July 2026",
    "text": "VID-20260711-WA0013.mp4 (file attached)",
    "type": "video",
    "mediaName": "VID-20260711-WA0013.mp4"
  },
  {
    "id": "m_56",
    "sender": "Ankita",
    "time": "19:43",
    "date": "2026-07-11",
    "dateLabel": "11 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_57",
    "sender": "Ratnadwip",
    "time": "23:05",
    "date": "2026-07-11",
    "dateLabel": "11 July 2026",
    "text": "re bara, ebar lift o lonely. mati mereche <This message was edited>",
    "type": "text"
  },
  {
    "id": "m_58",
    "sender": "Ankita",
    "time": "23:06",
    "date": "2026-07-11",
    "dateLabel": "11 July 2026",
    "text": "Mato mereche mne??🤣🤣",
    "type": "text"
  },
  {
    "id": "m_59",
    "sender": "Ratnadwip",
    "time": "23:06",
    "date": "2026-07-11",
    "dateLabel": "11 July 2026",
    "text": "*mati",
    "type": "text"
  },
  {
    "id": "m_60",
    "sender": "Ankita",
    "time": "23:06",
    "date": "2026-07-11",
    "dateLabel": "11 July 2026",
    "text": "Mati koreche ota 😑🤣🤌🏻🙄",
    "type": "text"
  },
  {
    "id": "m_61",
    "sender": "Ankita",
    "time": "23:07",
    "date": "2026-07-11",
    "dateLabel": "11 July 2026",
    "text": "0 civic sense 👏",
    "type": "text"
  },
  {
    "id": "m_62",
    "sender": "Ratnadwip",
    "time": "23:08",
    "date": "2026-07-11",
    "dateLabel": "11 July 2026",
    "text": "case koreche = mati koreche\ngaar mereche = mati mereche\nboro baal = boro mati\nsuor-er bachha = mati-er bachha",
    "type": "text"
  },
  {
    "id": "m_63",
    "sender": "Ratnadwip",
    "time": "23:08",
    "date": "2026-07-11",
    "dateLabel": "11 July 2026",
    "text": "and so on",
    "type": "text"
  },
  {
    "id": "m_64",
    "sender": "Ankita",
    "time": "23:08",
    "date": "2026-07-11",
    "dateLabel": "11 July 2026",
    "text": "Wahh what a unique gali'ssss",
    "type": "text"
  },
  {
    "id": "m_65",
    "sender": "Ankita",
    "time": "23:08",
    "date": "2026-07-11",
    "dateLabel": "11 July 2026",
    "text": "🤣👏",
    "type": "text"
  },
  {
    "id": "m_66",
    "sender": "Ratnadwip",
    "time": "23:08",
    "date": "2026-07-11",
    "dateLabel": "11 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_67",
    "sender": "Ratnadwip",
    "time": "16:23",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "bhaaaiii sugar daddy peye geli toh",
    "type": "text"
  },
  {
    "id": "m_68",
    "sender": "Ratnadwip",
    "time": "16:23",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "taka cheye ne",
    "type": "text"
  },
  {
    "id": "m_69",
    "sender": "Ratnadwip",
    "time": "16:24",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "cheye amake de",
    "type": "text"
  },
  {
    "id": "m_70",
    "sender": "Ankita",
    "time": "16:24",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "🤣🤣🤣",
    "type": "text"
  },
  {
    "id": "m_71",
    "sender": "Ankita",
    "time": "16:24",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "Arey fake account ig",
    "type": "text"
  },
  {
    "id": "m_72",
    "sender": "Ankita",
    "time": "16:24",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "Khali msg korey jalay",
    "type": "text"
  },
  {
    "id": "m_73",
    "sender": "Ratnadwip",
    "time": "16:24",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "toh ki, real taka toh dite pare.",
    "type": "text"
  },
  {
    "id": "m_74",
    "sender": "Ankita",
    "time": "16:24",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "Baccha chele",
    "type": "text"
  },
  {
    "id": "m_75",
    "sender": "Ankita",
    "time": "16:25",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "Kichu case a fasle?",
    "type": "text"
  },
  {
    "id": "m_76",
    "sender": "Ankita",
    "time": "16:25",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "Tor phone no. diye dbo?",
    "type": "text"
  },
  {
    "id": "m_77",
    "sender": "Ratnadwip",
    "time": "16:25",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "areh tui bhule jacchis, tui meye",
    "type": "text"
  },
  {
    "id": "m_78",
    "sender": "Ankita",
    "time": "16:25",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "😒ai na na seta",
    "type": "text"
  },
  {
    "id": "m_79",
    "sender": "Ratnadwip",
    "time": "16:25",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_80",
    "sender": "Ratnadwip",
    "time": "16:25",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "ei dara",
    "type": "text"
  },
  {
    "id": "m_81",
    "sender": "Ratnadwip",
    "time": "16:25",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "pradipta na toh ?",
    "type": "text"
  },
  {
    "id": "m_82",
    "sender": "Ankita",
    "time": "16:26",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "Download hocchey na sticker ta",
    "type": "text"
  },
  {
    "id": "m_83",
    "sender": "Ankita",
    "time": "16:26",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "Na na eita onek din dhorey msg korey",
    "type": "text"
  },
  {
    "id": "m_84",
    "sender": "Ankita",
    "time": "16:26",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "& idt j pradipta oto smoothly hindi bolte parbe bole",
    "type": "text"
  },
  {
    "id": "m_85",
    "sender": "Ratnadwip",
    "time": "16:26",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "tui seta entertain koris 🤣",
    "type": "text"
  },
  {
    "id": "m_86",
    "sender": "Ankita",
    "time": "16:27",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "Erm koto accheyy🤣",
    "type": "text"
  },
  {
    "id": "m_87",
    "sender": "Ankita",
    "time": "16:27",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "But eta barabari korlo tai sts dilm",
    "type": "text"
  },
  {
    "id": "m_88",
    "sender": "Ratnadwip",
    "time": "16:27",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "maal ta bangalore e chilo 1 bochor. smooth boltei pare",
    "type": "text"
  },
  {
    "id": "m_89",
    "sender": "Ratnadwip",
    "time": "16:27",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "crazy",
    "type": "text"
  },
  {
    "id": "m_90",
    "sender": "Ratnadwip",
    "time": "16:28",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "entertain keno korchis ? <This message was edited>",
    "type": "text"
  },
  {
    "id": "m_91",
    "sender": "Ankita",
    "time": "16:28",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "But eita onek purono re agey toh kotha hoto na pradipta r sathey so impossible eta oo noy",
    "type": "text"
  },
  {
    "id": "m_92",
    "sender": "Ankita",
    "time": "16:28",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_93",
    "sender": "Ratnadwip",
    "time": "16:28",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "you know what, tui actually patagobi",
    "type": "text"
  },
  {
    "id": "m_94",
    "sender": "Ankita",
    "time": "16:28",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_95",
    "sender": "Ratnadwip",
    "time": "16:28",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "i agree",
    "type": "text"
  },
  {
    "id": "m_96",
    "sender": "Ankita",
    "time": "16:28",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_97",
    "sender": "Ankita",
    "time": "16:28",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "Erm blte prli?",
    "type": "text"
  },
  {
    "id": "m_98",
    "sender": "Ratnadwip",
    "time": "16:29",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "haa",
    "type": "text"
  },
  {
    "id": "m_99",
    "sender": "Ratnadwip",
    "time": "16:29",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_100",
    "sender": "Ankita",
    "time": "16:29",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "Mar khbi?",
    "type": "text"
  },
  {
    "id": "m_101",
    "sender": "Ankita",
    "time": "16:29",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "🫩",
    "type": "text"
  },
  {
    "id": "m_102",
    "sender": "Ratnadwip",
    "time": "16:29",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "aro sticker banate hobe",
    "type": "text"
  },
  {
    "id": "m_103",
    "sender": "Ankita",
    "time": "16:29",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "Hya🤣🙏",
    "type": "text"
  },
  {
    "id": "m_104",
    "sender": "Ratnadwip",
    "time": "16:29",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "ekta sundor dekhte meye jodi maare then haa",
    "type": "text"
  },
  {
    "id": "m_105",
    "sender": "Ratnadwip",
    "time": "16:29",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "ache ?",
    "type": "text"
  },
  {
    "id": "m_106",
    "sender": "Ankita",
    "time": "16:29",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "Sundor na but ami marbo hoibo?",
    "type": "text"
  },
  {
    "id": "m_107",
    "sender": "Ankita",
    "time": "16:30",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "😑😒🤣",
    "type": "text"
  },
  {
    "id": "m_108",
    "sender": "Ratnadwip",
    "time": "16:30",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "erom hole toh moja lagbe, legit",
    "type": "text"
  },
  {
    "id": "m_109",
    "sender": "Ratnadwip",
    "time": "16:30",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "naa, violence",
    "type": "text"
  },
  {
    "id": "m_110",
    "sender": "Ankita",
    "time": "16:30",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "Tor kopale nei",
    "type": "text"
  },
  {
    "id": "m_111",
    "sender": "Ankita",
    "time": "16:30",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "Khun sidha",
    "type": "text"
  },
  {
    "id": "m_112",
    "sender": "Ankita",
    "time": "16:30",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "Violence na",
    "type": "text"
  },
  {
    "id": "m_113",
    "sender": "Ankita",
    "time": "16:30",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_114",
    "sender": "Ratnadwip",
    "time": "16:30",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "parbi na",
    "type": "text"
  },
  {
    "id": "m_115",
    "sender": "Ankita",
    "time": "16:30",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "Sob pri",
    "type": "text"
  },
  {
    "id": "m_116",
    "sender": "Ratnadwip",
    "time": "16:30",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_117",
    "sender": "Ratnadwip",
    "time": "16:30",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "paris na",
    "type": "text"
  },
  {
    "id": "m_118",
    "sender": "Ratnadwip",
    "time": "16:30",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_119",
    "sender": "Ankita",
    "time": "16:31",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "Gun ta niye jbo nxt din thle",
    "type": "text"
  },
  {
    "id": "m_120",
    "sender": "Ankita",
    "time": "16:31",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "😒",
    "type": "text"
  },
  {
    "id": "m_121",
    "sender": "Ratnadwip",
    "time": "16:31",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "rp ke niye gaurd banabo",
    "type": "text"
  },
  {
    "id": "m_122",
    "sender": "Ankita",
    "time": "16:31",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "Okeo mere dbo",
    "type": "text"
  },
  {
    "id": "m_123",
    "sender": "Ankita",
    "time": "16:31",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "🫡",
    "type": "text"
  },
  {
    "id": "m_124",
    "sender": "Ratnadwip",
    "time": "16:31",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "but morle, next biral",
    "type": "text"
  },
  {
    "id": "m_125",
    "sender": "Ratnadwip",
    "time": "16:32",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "biral hobo",
    "type": "text"
  },
  {
    "id": "m_126",
    "sender": "Ankita",
    "time": "16:32",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "🤣🤣🤣",
    "type": "text"
  },
  {
    "id": "m_127",
    "sender": "Ratnadwip",
    "time": "16:32",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "meyeder gaaye uthe bose thakbo",
    "type": "text"
  },
  {
    "id": "m_128",
    "sender": "Ankita",
    "time": "16:32",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "Bujhsi tor dhanda",
    "type": "text"
  },
  {
    "id": "m_129",
    "sender": "Ankita",
    "time": "16:32",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_130",
    "sender": "Ratnadwip",
    "time": "16:32",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "i have one dhanda",
    "type": "text"
  },
  {
    "id": "m_131",
    "sender": "Ankita",
    "time": "16:32",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "Chosma pora right?",
    "type": "text"
  },
  {
    "id": "m_132",
    "sender": "Ratnadwip",
    "time": "16:32",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "i love women",
    "type": "text"
  },
  {
    "id": "m_133",
    "sender": "Ratnadwip",
    "time": "16:32",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "osob o lagbe na",
    "type": "text"
  },
  {
    "id": "m_134",
    "sender": "Ankita",
    "time": "16:32",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "U r a women",
    "type": "text"
  },
  {
    "id": "m_135",
    "sender": "Ankita",
    "time": "16:33",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "🤣🤣",
    "type": "text"
  },
  {
    "id": "m_136",
    "sender": "Ratnadwip",
    "time": "16:33",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "orom mone hoi",
    "type": "text"
  },
  {
    "id": "m_137",
    "sender": "Ratnadwip",
    "time": "16:33",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "opposition ki chal",
    "type": "text"
  },
  {
    "id": "m_138",
    "sender": "Ankita",
    "time": "16:33",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_139",
    "sender": "Ankita",
    "time": "16:34",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_140",
    "sender": "Ratnadwip",
    "time": "16:39",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "don't send niggas",
    "type": "text"
  },
  {
    "id": "m_141",
    "sender": "Ratnadwip",
    "time": "16:39",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_142",
    "sender": "Ratnadwip",
    "time": "17:35",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "shit remix. thik thak korte pare ni",
    "type": "text"
  },
  {
    "id": "m_143",
    "sender": "Ankita",
    "time": "17:36",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "Hyaa",
    "type": "text"
  },
  {
    "id": "m_144",
    "sender": "Ankita",
    "time": "17:36",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "Kaney lagche",
    "type": "text"
  },
  {
    "id": "m_145",
    "sender": "Ratnadwip",
    "time": "17:36",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "aj banabo dara",
    "type": "text"
  },
  {
    "id": "m_146",
    "sender": "Ratnadwip",
    "time": "17:36",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "once i stop scrolling reels",
    "type": "text"
  },
  {
    "id": "m_147",
    "sender": "Ankita",
    "time": "17:38",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "Stop it then",
    "type": "text"
  },
  {
    "id": "m_148",
    "sender": "Ratnadwip",
    "time": "19:36",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_149",
    "sender": "Ratnadwip",
    "time": "19:37",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "now you have become a sticker",
    "type": "text"
  },
  {
    "id": "m_150",
    "sender": "Ankita",
    "time": "19:37",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "PTT-20260712-WA0011.opus (file attached)",
    "type": "voice_note",
    "mediaName": "PTT-20260712-WA0011.opus"
  },
  {
    "id": "m_151",
    "sender": "Ratnadwip",
    "time": "19:38",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_152",
    "sender": "Ankita",
    "time": "19:38",
    "date": "2026-07-12",
    "dateLabel": "12 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_153",
    "sender": "Ratnadwip",
    "time": "00:37",
    "date": "2026-07-13",
    "dateLabel": "13 July 2026",
    "text": "tea dite bolche",
    "type": "text"
  },
  {
    "id": "m_154",
    "sender": "Ratnadwip",
    "time": "00:37",
    "date": "2026-07-13",
    "dateLabel": "13 July 2026",
    "text": "sunbi?",
    "type": "text"
  },
  {
    "id": "m_155",
    "sender": "Ankita",
    "time": "00:37",
    "date": "2026-07-13",
    "dateLabel": "13 July 2026",
    "text": "Ok",
    "type": "text"
  },
  {
    "id": "m_156",
    "sender": "Ankita",
    "time": "00:37",
    "date": "2026-07-13",
    "dateLabel": "13 July 2026",
    "text": "Np",
    "type": "text"
  },
  {
    "id": "m_157",
    "sender": "Ratnadwip",
    "time": "00:38",
    "date": "2026-07-13",
    "dateLabel": "13 July 2026",
    "text": "je kono ektai join ho",
    "type": "text"
  },
  {
    "id": "m_158",
    "sender": "Ankita",
    "time": "00:38",
    "date": "2026-07-13",
    "dateLabel": "13 July 2026",
    "text": "Ok",
    "type": "text"
  },
  {
    "id": "m_159",
    "sender": "Ankita",
    "time": "00:39",
    "date": "2026-07-13",
    "dateLabel": "13 July 2026",
    "text": "Kothay hobo?",
    "type": "text"
  },
  {
    "id": "m_160",
    "sender": "Ankita",
    "time": "00:39",
    "date": "2026-07-13",
    "dateLabel": "13 July 2026",
    "text": "Dis a toh keu e nei",
    "type": "text"
  },
  {
    "id": "m_161",
    "sender": "Ankita",
    "time": "00:39",
    "date": "2026-07-13",
    "dateLabel": "13 July 2026",
    "text": "😑🤌🏻",
    "type": "text"
  },
  {
    "id": "m_162",
    "sender": "Ratnadwip",
    "time": "00:39",
    "date": "2026-07-13",
    "dateLabel": "13 July 2026",
    "text": "jekono ekta",
    "type": "text"
  },
  {
    "id": "m_163",
    "sender": "Ratnadwip",
    "time": "00:39",
    "date": "2026-07-13",
    "dateLabel": "13 July 2026",
    "text": "join ho",
    "type": "text"
  },
  {
    "id": "m_164",
    "sender": "Ankita",
    "time": "00:39",
    "date": "2026-07-13",
    "dateLabel": "13 July 2026",
    "text": "Nei re",
    "type": "text"
  },
  {
    "id": "m_165",
    "sender": "Ankita",
    "time": "00:39",
    "date": "2026-07-13",
    "dateLabel": "13 July 2026",
    "text": "🙃",
    "type": "text"
  },
  {
    "id": "m_166",
    "sender": "Ankita",
    "time": "00:39",
    "date": "2026-07-13",
    "dateLabel": "13 July 2026",
    "text": "Ami hobo 1st?",
    "type": "text"
  },
  {
    "id": "m_167",
    "sender": "Ankita",
    "time": "00:39",
    "date": "2026-07-13",
    "dateLabel": "13 July 2026",
    "text": "Eta bolchis?",
    "type": "text"
  },
  {
    "id": "m_168",
    "sender": "Ratnadwip",
    "time": "00:39",
    "date": "2026-07-13",
    "dateLabel": "13 July 2026",
    "text": "sobai lukiye ache",
    "type": "text"
  },
  {
    "id": "m_169",
    "sender": "Ankita",
    "time": "00:40",
    "date": "2026-07-13",
    "dateLabel": "13 July 2026",
    "text": "🙃",
    "type": "text"
  },
  {
    "id": "m_170",
    "sender": "Ratnadwip",
    "time": "00:41",
    "date": "2026-07-13",
    "dateLabel": "13 July 2026",
    "text": "samaya hote geli ?",
    "type": "text"
  },
  {
    "id": "m_171",
    "sender": "Ankita",
    "time": "00:42",
    "date": "2026-07-13",
    "dateLabel": "13 July 2026",
    "text": "Dara aschi",
    "type": "text"
  },
  {
    "id": "m_172",
    "sender": "Ankita",
    "time": "00:42",
    "date": "2026-07-13",
    "dateLabel": "13 July 2026",
    "text": "1 min",
    "type": "text"
  },
  {
    "id": "m_173",
    "sender": "Ratnadwip",
    "time": "00:43",
    "date": "2026-07-13",
    "dateLabel": "13 July 2026",
    "text": "aaaaaaaaaaaaaiii",
    "type": "text"
  },
  {
    "id": "m_174",
    "sender": "Ratnadwip",
    "time": "20:23",
    "date": "2026-07-13",
    "dateLabel": "13 July 2026",
    "text": "what if you have cancer.",
    "type": "text"
  },
  {
    "id": "m_175",
    "sender": "Ankita",
    "time": "09:19",
    "date": "2026-07-14",
    "dateLabel": "14 July 2026",
    "text": "Group – A (Very Short Answer Type Question)\n\n                Answer any ten of the following.                [1×10=10]\n\n1. State Green's Theorem.\n\n2. Write the Cauchy–Riemann equations.\n\n3. Define an analytic function.\n\n4. Find the integrating factor of\n   dy/dx + 2y = e^(-x).\n\n5. Write the general solution of\n   (D² + 9)y = 0.\n\n6. State Cauchy's Integral Formula.\n\n7. Find the residue of\n   1/[z(z−2)]\n   at z = 0.\n\n8. Evaluate\n   ∬ xy dxdy,\n   where 0 ≤ x ≤ 1, 0 ≤ y ≤ 2.\n\n9. State Laplace's Equation.\n\n10. Write the general form of Cauchy–Euler equation.\n\n11. Define a simple pole.\n\n12. Write the Jacobian for transformation from Cartesian to Polar coordinates.\n\n\n                     Group – B (Short Answer Type Question)\n\n                 Answer any three of the following.            [5×3=15]\n\n2.\n\nEvaluate\n∬(x + y) dxdy,\nwhere\nR : 0 ≤ x ≤ 1, 0 ≤ y ≤ 2.\n\n3.\n\nSolve\ndy/dx + y = e^x.\n\n4.\n\nSolve\n(D² − 4D + 4)y = e^(2x).\n\n5.\n\nFind the analytic function\nf(z) = u + iv,\nif\nu = x² − y².\n\n6.\n\nShow that\nw = (z − 1)/(z + 1)\nmaps the right half-plane into the unit circle.\n\n\n                     Group – C (Long Answer Type Question)\n\n                 Answer any three of the following.          [15×3=45]\n\n7.\n\n(a) Solve\n(e^x + y)dx + (x + e^y)dy = 0.\n\n(b) Test whether\n(2xy + y)dx + (x² + x)dy = 0\nis exact. Hence solve it.\n\n(c) Find the differential equation of all circles passing through the origin.\n\n\n8.\n\n(a) Solve\n(D² + 4)y = sin2x.\n\n(b) Solve by variation of parameters\ny'' + y = secx.\n\n(c) Solve the Cauchy–Euler equation\nx²y'' − 3xy' + 4y = x².\n\n\n9.\n\n(a) Using the transformation\nu = x + y,\nv = x − y,\nevaluate the given double integral.\n\n(b) Evaluate\n∭ xyz dxdydz\nover the tetrahedron\nx + y + z ≤ 1,\nx, y, z ≥ 0.\n\n(c) Evaluate\n∭ (x + y + z)dxdydz\nover the unit cube.\n\n\n10.\n\n(a) Find the analytic function whose real part is\nu = e^x cos y.\n\n(b) Evaluate\n∮ (z + 1)/[z(z − 2)] dz,\nwhere |z| = 1.\n\n(c) Classify all singularities of\n1/[z(z − 1)²].\n\n\n11.\n\n(a) State and prove Green's Theorem.\n\n(b) Using Green's Theorem evaluate\n∮C (x²dy + y²dx),\nwhere C is the boundary of the square\n0 ≤ x ≤ 1,\n0 ≤ y ≤ 1.\n\n(c) Evaluate\n∬R (x − y) dxdy,\nwhere\nR : x + y ≤ 1,\nx ≥ 0,\ny ≥ 0.",
    "type": "text"
  },
  {
    "id": "m_176",
    "sender": "Ankita",
    "time": "09:19",
    "date": "2026-07-14",
    "dateLabel": "14 July 2026",
    "text": "1st set",
    "type": "text"
  },
  {
    "id": "m_177",
    "sender": "Ankita",
    "time": "09:19",
    "date": "2026-07-14",
    "dateLabel": "14 July 2026",
    "text": "2nd set asey ni",
    "type": "text"
  },
  {
    "id": "m_178",
    "sender": "Ratnadwip",
    "time": "09:19",
    "date": "2026-07-14",
    "dateLabel": "14 July 2026",
    "text": "de",
    "type": "text"
  },
  {
    "id": "m_179",
    "sender": "Ankita",
    "time": "09:20",
    "date": "2026-07-14",
    "dateLabel": "14 July 2026",
    "text": "Aseni akhono",
    "type": "text"
  },
  {
    "id": "m_180",
    "sender": "Ankita",
    "time": "09:20",
    "date": "2026-07-14",
    "dateLabel": "14 July 2026",
    "text": "Ashle dbo",
    "type": "text"
  },
  {
    "id": "m_181",
    "sender": "Ratnadwip",
    "time": "09:20",
    "date": "2026-07-14",
    "dateLabel": "14 July 2026",
    "text": "ok",
    "type": "text"
  },
  {
    "id": "m_182",
    "sender": "Ankita",
    "time": "09:42",
    "date": "2026-07-14",
    "dateLabel": "14 July 2026",
    "text": "IMG-20260714-WA0011.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20260714-WA0011.jpg"
  },
  {
    "id": "m_183",
    "sender": "Ankita",
    "time": "09:42",
    "date": "2026-07-14",
    "dateLabel": "14 July 2026",
    "text": "IMG-20260714-WA0013.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20260714-WA0013.jpg"
  },
  {
    "id": "m_184",
    "sender": "Ankita",
    "time": "09:42",
    "date": "2026-07-14",
    "dateLabel": "14 July 2026",
    "text": "IMG-20260714-WA0014.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20260714-WA0014.jpg"
  },
  {
    "id": "m_185",
    "sender": "Ankita",
    "time": "09:42",
    "date": "2026-07-14",
    "dateLabel": "14 July 2026",
    "text": "IMG-20260714-WA0012.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20260714-WA0012.jpg"
  },
  {
    "id": "m_186",
    "sender": "Ankita",
    "time": "09:42",
    "date": "2026-07-14",
    "dateLabel": "14 July 2026",
    "text": "Egulo de",
    "type": "text"
  },
  {
    "id": "m_187",
    "sender": "Ankita",
    "time": "22:25",
    "date": "2026-07-14",
    "dateLabel": "14 July 2026",
    "text": "https://www.linkedin.com/posts/ruyam-bhattacharya_hackathon-hexafalls-selection-activity-7482836125607321601-tUG_?utm_source=social_share_send&utm_medium=android_app&rcm=ACoAAF6my0ABIfsaFS93mI7635-Rw41GoVU9e2I&utm_campaign=whatsapp",
    "type": "link",
    "linkUrl": "https://www.linkedin.com/posts/ruyam-bhattacharya_hackathon-hexafalls-selection-activity-7482836125607321601-tUG_?utm_source=social_share_send&utm_medium=android_app&rcm=ACoAAF6my0ABIfsaFS93mI7635-Rw41GoVU9e2I&utm_campaign=whatsapp"
  },
  {
    "id": "m_188",
    "sender": "Ankita",
    "time": "22:25",
    "date": "2026-07-14",
    "dateLabel": "14 July 2026",
    "text": "Ki re eta?",
    "type": "text"
  },
  {
    "id": "m_189",
    "sender": "Ratnadwip",
    "time": "22:33",
    "date": "2026-07-14",
    "dateLabel": "14 July 2026",
    "text": "peyeche o hexafalls e",
    "type": "text"
  },
  {
    "id": "m_190",
    "sender": "Ratnadwip",
    "time": "22:34",
    "date": "2026-07-14",
    "dateLabel": "14 July 2026",
    "text": "bara proma er bf ta hack scene e bhalo ache",
    "type": "text"
  },
  {
    "id": "m_191",
    "sender": "Ankita",
    "time": "22:34",
    "date": "2026-07-14",
    "dateLabel": "14 July 2026",
    "text": "Accha",
    "type": "text"
  },
  {
    "id": "m_192",
    "sender": "Ratnadwip",
    "time": "22:34",
    "date": "2026-07-14",
    "dateLabel": "14 July 2026",
    "text": "souptik pal ta or bf",
    "type": "text"
  },
  {
    "id": "m_193",
    "sender": "Ratnadwip",
    "time": "22:34",
    "date": "2026-07-14",
    "dateLabel": "14 July 2026",
    "text": "aot er student",
    "type": "text"
  },
  {
    "id": "m_194",
    "sender": "Ratnadwip",
    "time": "22:34",
    "date": "2026-07-14",
    "dateLabel": "14 July 2026",
    "text": "3rd year",
    "type": "text"
  },
  {
    "id": "m_195",
    "sender": "Ankita",
    "time": "22:34",
    "date": "2026-07-14",
    "dateLabel": "14 July 2026",
    "text": "K era chini na",
    "type": "text"
  },
  {
    "id": "m_196",
    "sender": "Ratnadwip",
    "time": "22:35",
    "date": "2026-07-14",
    "dateLabel": "14 July 2026",
    "text": "chinbi na",
    "type": "text"
  },
  {
    "id": "m_197",
    "sender": "Ankita",
    "time": "21:08",
    "date": "2026-07-15",
    "dateLabel": "15 July 2026",
    "text": "Kothay tui??",
    "type": "text"
  },
  {
    "id": "m_198",
    "sender": "Ratnadwip",
    "time": "21:34",
    "date": "2026-07-15",
    "dateLabel": "15 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_199",
    "sender": "Ankita",
    "time": "21:40",
    "date": "2026-07-16",
    "dateLabel": "16 July 2026",
    "text": "This message was deleted",
    "type": "text"
  },
  {
    "id": "m_200",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-07-16",
    "dateLabel": "16 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_201",
    "sender": "Ratnadwip",
    "time": "23:56",
    "date": "2026-07-16",
    "dateLabel": "16 July 2026",
    "text": "koi geli ?",
    "type": "text"
  },
  {
    "id": "m_202",
    "sender": "Ratnadwip",
    "time": "12:55",
    "date": "2026-07-17",
    "dateLabel": "17 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_203",
    "sender": "Ankita",
    "time": "12:58",
    "date": "2026-07-17",
    "dateLabel": "17 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_204",
    "sender": "Ratnadwip",
    "time": "12:58",
    "date": "2026-07-17",
    "dateLabel": "17 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_205",
    "sender": "Ratnadwip",
    "time": "20:46",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "crazy",
    "type": "text"
  },
  {
    "id": "m_206",
    "sender": "Ankita",
    "time": "21:03",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_207",
    "sender": "Ratnadwip",
    "time": "21:06",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "https://youtu.be/Y2Y5KVtU810\n\nmy response to the video.",
    "type": "link",
    "linkUrl": "https://youtu.be/Y2Y5KVtU810"
  },
  {
    "id": "m_208",
    "sender": "Ankita",
    "time": "21:06",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "Btw",
    "type": "text"
  },
  {
    "id": "m_209",
    "sender": "Ankita",
    "time": "21:07",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "Sts dekhli sbr?",
    "type": "text"
  },
  {
    "id": "m_210",
    "sender": "Ratnadwip",
    "time": "21:36",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "dekhlam",
    "type": "text"
  },
  {
    "id": "m_211",
    "sender": "Ratnadwip",
    "time": "21:37",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "sayantica msg korlo",
    "type": "text"
  },
  {
    "id": "m_212",
    "sender": "Ankita",
    "time": "21:37",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "Ki niye",
    "type": "text"
  },
  {
    "id": "m_213",
    "sender": "Ankita",
    "time": "21:37",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "?",
    "type": "text"
  },
  {
    "id": "m_214",
    "sender": "Ratnadwip",
    "time": "21:37",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "ora gache ei niye.",
    "type": "text"
  },
  {
    "id": "m_215",
    "sender": "Ankita",
    "time": "21:37",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "Amakeo bole ni point eta",
    "type": "text"
  },
  {
    "id": "m_216",
    "sender": "Ankita",
    "time": "21:37",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "Hyaa toder boley ni bujhlm but amakeo bole ni",
    "type": "text"
  },
  {
    "id": "m_217",
    "sender": "Ankita",
    "time": "21:37",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "🫡",
    "type": "text"
  },
  {
    "id": "m_218",
    "sender": "Ratnadwip",
    "time": "21:37",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "🫡",
    "type": "text"
  },
  {
    "id": "m_219",
    "sender": "Ankita",
    "time": "21:37",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "Marattok seen",
    "type": "text"
  },
  {
    "id": "m_220",
    "sender": "Ankita",
    "time": "21:38",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "Last din bujheche j amr tor sathey kotha hoy oi jnnoi boley ni...",
    "type": "text"
  },
  {
    "id": "m_221",
    "sender": "Ratnadwip",
    "time": "21:38",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "ami bou ke baja chilam. \nek jholok dekhe bhablam streets",
    "type": "text"
  },
  {
    "id": "m_222",
    "sender": "Ankita",
    "time": "21:38",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "Streets?",
    "type": "text"
  },
  {
    "id": "m_223",
    "sender": "Ankita",
    "time": "21:38",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "What?",
    "type": "text"
  },
  {
    "id": "m_224",
    "sender": "Ratnadwip",
    "time": "21:39",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "na na pore dekhlam je kanchrapara",
    "type": "text"
  },
  {
    "id": "m_225",
    "sender": "Ratnadwip",
    "time": "21:39",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "🙆🏻‍♂️",
    "type": "text"
  },
  {
    "id": "m_226",
    "sender": "Ankita",
    "time": "21:39",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "Point hocche amr prove korte holo na Rikita r Debosmita r kotha kothay jayy ajk",
    "type": "text"
  },
  {
    "id": "m_227",
    "sender": "Ankita",
    "time": "21:39",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "😎",
    "type": "text"
  },
  {
    "id": "m_228",
    "sender": "Ratnadwip",
    "time": "21:39",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "🫡",
    "type": "text"
  },
  {
    "id": "m_229",
    "sender": "Ankita",
    "time": "21:40",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "Marattok byapar",
    "type": "text"
  },
  {
    "id": "m_230",
    "sender": "Ratnadwip",
    "time": "21:40",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "#wearebiggerthanthis",
    "type": "text"
  },
  {
    "id": "m_231",
    "sender": "Ankita",
    "time": "21:40",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "Rikita r Debosmita ou bole ni",
    "type": "text"
  },
  {
    "id": "m_232",
    "sender": "Ankita",
    "time": "21:40",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "Amy",
    "type": "text"
  },
  {
    "id": "m_233",
    "sender": "Ankita",
    "time": "21:40",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "Point holo eta",
    "type": "text"
  },
  {
    "id": "m_234",
    "sender": "Ankita",
    "time": "21:40",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_235",
    "sender": "Ankita",
    "time": "21:40",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "Ki korar nei thaak",
    "type": "text"
  },
  {
    "id": "m_236",
    "sender": "Ratnadwip",
    "time": "21:41",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "kichu toh ekta scene cholche oi group er sathe",
    "type": "text"
  },
  {
    "id": "m_237",
    "sender": "Ratnadwip",
    "time": "21:41",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "amar ekta speculation ache",
    "type": "text"
  },
  {
    "id": "m_238",
    "sender": "Ankita",
    "time": "21:41",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "Hyaa bujhey gecchi",
    "type": "text"
  },
  {
    "id": "m_239",
    "sender": "Ankita",
    "time": "21:41",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "Hya hya same r seta Rikita r sathei hobey",
    "type": "text"
  },
  {
    "id": "m_240",
    "sender": "Ankita",
    "time": "21:41",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "Ik that",
    "type": "text"
  },
  {
    "id": "m_241",
    "sender": "Ankita",
    "time": "21:42",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "R eta ami jni j Debosmita oi grp er kakey like korey",
    "type": "text"
  },
  {
    "id": "m_242",
    "sender": "Ankita",
    "time": "21:42",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "But Rikita r ta ager din puro bujhlm...",
    "type": "text"
  },
  {
    "id": "m_243",
    "sender": "Ratnadwip",
    "time": "21:42",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "amar sathe je scene ta hoyechilo. but gender swapped. \n\npeer pressure and all shit",
    "type": "text"
  },
  {
    "id": "m_244",
    "sender": "Ratnadwip",
    "time": "21:42",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "this aint good",
    "type": "text"
  },
  {
    "id": "m_245",
    "sender": "Ankita",
    "time": "21:42",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "Reading room eo dekhechi oder aksathey amio chilm but oto bujhi ni but ager din full clear..",
    "type": "text"
  },
  {
    "id": "m_246",
    "sender": "Ankita",
    "time": "21:43",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "Ja hobe hobe amar ki",
    "type": "text"
  },
  {
    "id": "m_247",
    "sender": "Ankita",
    "time": "21:43",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "😎",
    "type": "text"
  },
  {
    "id": "m_248",
    "sender": "Ratnadwip",
    "time": "21:43",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "true.",
    "type": "text"
  },
  {
    "id": "m_249",
    "sender": "Ankita",
    "time": "21:43",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "Thekey shikhuk",
    "type": "text"
  },
  {
    "id": "m_250",
    "sender": "Ankita",
    "time": "21:43",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "Sob kota",
    "type": "text"
  },
  {
    "id": "m_251",
    "sender": "Ratnadwip",
    "time": "21:43",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "new hackathon team form korte hobe amake",
    "type": "text"
  },
  {
    "id": "m_252",
    "sender": "Ratnadwip",
    "time": "21:43",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_253",
    "sender": "Ankita",
    "time": "21:43",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "Yess",
    "type": "text"
  },
  {
    "id": "m_254",
    "sender": "Ankita",
    "time": "21:43",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "Agei bolechilam",
    "type": "text"
  },
  {
    "id": "m_255",
    "sender": "Ratnadwip",
    "time": "21:43",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "#womenbenifits",
    "type": "text"
  },
  {
    "id": "m_256",
    "sender": "Ankita",
    "time": "21:43",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "🥲🤌🏻😆",
    "type": "text"
  },
  {
    "id": "m_257",
    "sender": "Ratnadwip",
    "time": "21:43",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "6 jon lagbe. joto meye besi hobe toto bhalo",
    "type": "text"
  },
  {
    "id": "m_258",
    "sender": "Ratnadwip",
    "time": "21:44",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "6 jon lagbei",
    "type": "text"
  },
  {
    "id": "m_259",
    "sender": "Ankita",
    "time": "21:44",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "Aro bhalo bhalo meye acchey bro clg a..",
    "type": "text"
  },
  {
    "id": "m_260",
    "sender": "Ratnadwip",
    "time": "21:44",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "6 jon er kom team hobe na",
    "type": "text"
  },
  {
    "id": "m_261",
    "sender": "Ratnadwip",
    "time": "21:44",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "fax",
    "type": "text"
  },
  {
    "id": "m_262",
    "sender": "Ankita",
    "time": "21:44",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "Ok dekhchi clg open hok abar",
    "type": "text"
  },
  {
    "id": "m_263",
    "sender": "Ratnadwip",
    "time": "21:44",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "kintu kau ke giye jodi boli tor benifit nebo... crazy <This message was edited>",
    "type": "text"
  },
  {
    "id": "m_264",
    "sender": "Ankita",
    "time": "21:45",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "😆😆😆😆",
    "type": "text"
  },
  {
    "id": "m_265",
    "sender": "Ratnadwip",
    "time": "21:45",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "anyways",
    "type": "text"
  },
  {
    "id": "m_266",
    "sender": "Ratnadwip",
    "time": "21:45",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "amar bou ke spa koriye diyechi",
    "type": "text"
  },
  {
    "id": "m_267",
    "sender": "Ratnadwip",
    "time": "21:45",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "shine marche bou",
    "type": "text"
  },
  {
    "id": "m_268",
    "sender": "Ankita",
    "time": "21:45",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "Mati koreche 🙃",
    "type": "text"
  },
  {
    "id": "m_269",
    "sender": "Ankita",
    "time": "21:45",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_270",
    "sender": "Ratnadwip",
    "time": "21:45",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "awaj palte gache bou er",
    "type": "text"
  },
  {
    "id": "m_271",
    "sender": "Ankita",
    "time": "21:45",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "Kichui na amar ajk oder sts ta dekhey khrp lglo byass ei tukui...",
    "type": "text"
  },
  {
    "id": "m_272",
    "sender": "Ankita",
    "time": "21:46",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "🤣🤣🤣🤣",
    "type": "text"
  },
  {
    "id": "m_273",
    "sender": "Ankita",
    "time": "21:46",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "Marattok byapar",
    "type": "text"
  },
  {
    "id": "m_274",
    "sender": "Ankita",
    "time": "21:46",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "Anyways 🙃",
    "type": "text"
  },
  {
    "id": "m_275",
    "sender": "Ratnadwip",
    "time": "21:46",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "amar maya hoi dekhe",
    "type": "text"
  },
  {
    "id": "m_276",
    "sender": "Ratnadwip",
    "time": "21:46",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_277",
    "sender": "Ankita",
    "time": "21:47",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "Point 🤪",
    "type": "text"
  },
  {
    "id": "m_278",
    "sender": "Ankita",
    "time": "21:47",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_279",
    "sender": "Ratnadwip",
    "time": "21:47",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "jai hok, time to focus on first year.",
    "type": "text"
  },
  {
    "id": "m_280",
    "sender": "Ankita",
    "time": "21:47",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "No no no not for me",
    "type": "text"
  },
  {
    "id": "m_281",
    "sender": "Ankita",
    "time": "21:48",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "🙃",
    "type": "text"
  },
  {
    "id": "m_282",
    "sender": "Ankita",
    "time": "21:48",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "Ami aktai bhul ki korechi jnis",
    "type": "text"
  },
  {
    "id": "m_283",
    "sender": "Ratnadwip",
    "time": "21:48",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "tui koris na. tui orientation e focus kor. crazy",
    "type": "text"
  },
  {
    "id": "m_284",
    "sender": "Ankita",
    "time": "21:48",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "Oder k Topobroto er byapar ta bole bhul korechi bki sob thik achey...",
    "type": "text"
  },
  {
    "id": "m_285",
    "sender": "Ankita",
    "time": "21:48",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_286",
    "sender": "Ratnadwip",
    "time": "21:48",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_287",
    "sender": "Ankita",
    "time": "21:48",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "Oi jnnoi toh ora okey volunteer a nilo",
    "type": "text"
  },
  {
    "id": "m_288",
    "sender": "Ankita",
    "time": "21:49",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "Noyto nito na re",
    "type": "text"
  },
  {
    "id": "m_289",
    "sender": "Ankita",
    "time": "21:49",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "🙃",
    "type": "text"
  },
  {
    "id": "m_290",
    "sender": "Ratnadwip",
    "time": "21:49",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "2nd year e pouche gache for sure",
    "type": "text"
  },
  {
    "id": "m_291",
    "sender": "Ankita",
    "time": "21:49",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "Mne mne?",
    "type": "text"
  },
  {
    "id": "m_292",
    "sender": "Ankita",
    "time": "21:49",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "Bujhlm na",
    "type": "text"
  },
  {
    "id": "m_293",
    "sender": "Ratnadwip",
    "time": "21:49",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "oi khane kotha sob jaiga tei jai",
    "type": "text"
  },
  {
    "id": "m_294",
    "sender": "Ratnadwip",
    "time": "21:49",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "oitai",
    "type": "text"
  },
  {
    "id": "m_295",
    "sender": "Ankita",
    "time": "21:50",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "Hya otai bhabchi akhon but chele taro guilty achey re.. point eta...",
    "type": "text"
  },
  {
    "id": "m_296",
    "sender": "Ratnadwip",
    "time": "21:50",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "bara sob jaiga mean sob jaiga. kono exception nei",
    "type": "text"
  },
  {
    "id": "m_297",
    "sender": "Ankita",
    "time": "21:50",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "Ager din Rikita o bolchilo",
    "type": "text"
  },
  {
    "id": "m_298",
    "sender": "Ankita",
    "time": "21:50",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "🥲horibol",
    "type": "text"
  },
  {
    "id": "m_299",
    "sender": "Ratnadwip",
    "time": "21:50",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "rikita r scene ta ami dur theke dekhbo",
    "type": "text"
  },
  {
    "id": "m_300",
    "sender": "Ratnadwip",
    "time": "21:50",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "amar scene ta repeat hochhe",
    "type": "text"
  },
  {
    "id": "m_301",
    "sender": "Ratnadwip",
    "time": "21:51",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "dekhbo ami bhalo kore",
    "type": "text"
  },
  {
    "id": "m_302",
    "sender": "Ankita",
    "time": "21:51",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "Dekhis dekhis..",
    "type": "text"
  },
  {
    "id": "m_303",
    "sender": "Ankita",
    "time": "21:51",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "But era chay ta ki mainly?",
    "type": "text"
  },
  {
    "id": "m_304",
    "sender": "Ankita",
    "time": "21:51",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "Etai toh buhte parchi na",
    "type": "text"
  },
  {
    "id": "m_305",
    "sender": "Ankita",
    "time": "21:51",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "Mentally break down?",
    "type": "text"
  },
  {
    "id": "m_306",
    "sender": "Ratnadwip",
    "time": "21:51",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "#era_sukher_lagi_chahe_prem",
    "type": "text"
  },
  {
    "id": "m_307",
    "sender": "Ankita",
    "time": "21:51",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "Nki onno kichu bujhlm na..\nEsob toh ami onek dekhechi",
    "type": "text"
  },
  {
    "id": "m_308",
    "sender": "Ankita",
    "time": "21:52",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "Trauma",
    "type": "text"
  },
  {
    "id": "m_309",
    "sender": "Ankita",
    "time": "21:52",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "Nijeder ki khrp feel hoy na??",
    "type": "text"
  },
  {
    "id": "m_310",
    "sender": "Ankita",
    "time": "21:52",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "🫩🫩",
    "type": "text"
  },
  {
    "id": "m_311",
    "sender": "Ratnadwip",
    "time": "21:52",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "odd sem gulo explosive hoi. kichu ekta toh hobe",
    "type": "text"
  },
  {
    "id": "m_312",
    "sender": "Ratnadwip",
    "time": "21:52",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "hoi na nishchoi",
    "type": "text"
  },
  {
    "id": "m_313",
    "sender": "Ankita",
    "time": "21:52",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_314",
    "sender": "Ratnadwip",
    "time": "21:53",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "naam nebo na.",
    "type": "text"
  },
  {
    "id": "m_315",
    "sender": "Ankita",
    "time": "21:53",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "Okayy damnn bhalo bhalo ja icchey tai kor amader ki..",
    "type": "text"
  },
  {
    "id": "m_316",
    "sender": "Ankita",
    "time": "21:53",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "Kar?",
    "type": "text"
  },
  {
    "id": "m_317",
    "sender": "Ratnadwip",
    "time": "21:53",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "but sob year e ekta kore jholano is not good",
    "type": "text"
  },
  {
    "id": "m_318",
    "sender": "Ratnadwip",
    "time": "21:53",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_319",
    "sender": "Ankita",
    "time": "21:53",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "Thik otai",
    "type": "text"
  },
  {
    "id": "m_320",
    "sender": "Ankita",
    "time": "21:53",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "1 ta thaak 4 yrs it's fine",
    "type": "text"
  },
  {
    "id": "m_321",
    "sender": "Ankita",
    "time": "21:53",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "But atoh gulo ki korbe bhogoban jne",
    "type": "text"
  },
  {
    "id": "m_322",
    "sender": "Ankita",
    "time": "21:54",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_323",
    "sender": "Ratnadwip",
    "time": "21:54",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_324",
    "sender": "Ratnadwip",
    "time": "21:54",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "freaky",
    "type": "text"
  },
  {
    "id": "m_325",
    "sender": "Ankita",
    "time": "21:54",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_326",
    "sender": "Ankita",
    "time": "21:54",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "Bhalo bhalo ja hoy bhalor jnno hoy..",
    "type": "text"
  },
  {
    "id": "m_327",
    "sender": "Ankita",
    "time": "21:55",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "But hya Pronay besi mitthey kotha bolte parey na bhalo korey...\nDhora poreche point eta...",
    "type": "text"
  },
  {
    "id": "m_328",
    "sender": "Ratnadwip",
    "time": "21:55",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_329",
    "sender": "Ratnadwip",
    "time": "21:55",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "true.",
    "type": "text"
  },
  {
    "id": "m_330",
    "sender": "Ankita",
    "time": "21:55",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "Dara na",
    "type": "text"
  },
  {
    "id": "m_331",
    "sender": "Ankita",
    "time": "21:56",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "Wait 28 tarik asuk",
    "type": "text"
  },
  {
    "id": "m_332",
    "sender": "Ankita",
    "time": "21:56",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "Amr gng member firbe",
    "type": "text"
  },
  {
    "id": "m_333",
    "sender": "Ratnadwip",
    "time": "21:56",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "cheleta show off korte jai. kintu hoi na... childish lage",
    "type": "text"
  },
  {
    "id": "m_334",
    "sender": "Ankita",
    "time": "21:56",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "Moja toh tokhon nebo sbr..",
    "type": "text"
  },
  {
    "id": "m_335",
    "sender": "Ratnadwip",
    "time": "21:56",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "🫪",
    "type": "text"
  },
  {
    "id": "m_336",
    "sender": "Ankita",
    "time": "21:56",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_337",
    "sender": "Ankita",
    "time": "21:56",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "Baje bhabey dhuli",
    "type": "text"
  },
  {
    "id": "m_338",
    "sender": "Ratnadwip",
    "time": "21:56",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_339",
    "sender": "Ankita",
    "time": "21:56",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_340",
    "sender": "Ankita",
    "time": "21:57",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "28 th theke abr prime a firbo",
    "type": "text"
  },
  {
    "id": "m_341",
    "sender": "Ratnadwip",
    "time": "21:57",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "khela hobe 🫡",
    "type": "text"
  },
  {
    "id": "m_342",
    "sender": "Ankita",
    "time": "21:58",
    "date": "2026-07-20",
    "dateLabel": "20 July 2026",
    "text": "Yess🙂‍↕️",
    "type": "text"
  },
  {
    "id": "m_343",
    "sender": "Ratnadwip",
    "time": "21:57",
    "date": "2026-07-21",
    "dateLabel": "21 July 2026",
    "text": "traffic er gaan shona #অন্ধ-অনুরাগী",
    "type": "text"
  },
  {
    "id": "m_344",
    "sender": "Ankita",
    "time": "21:59",
    "date": "2026-07-21",
    "dateLabel": "21 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_345",
    "sender": "Ratnadwip",
    "time": "22:02",
    "date": "2026-07-21",
    "dateLabel": "21 July 2026",
    "text": "https://www.instagram.com/reel/Da-HQFVhIZN/",
    "type": "link",
    "linkUrl": "https://www.instagram.com/reel/Da-HQFVhIZN/"
  },
  {
    "id": "m_346",
    "sender": "Ratnadwip",
    "time": "22:02",
    "date": "2026-07-21",
    "dateLabel": "21 July 2026",
    "text": "#promotion",
    "type": "text"
  },
  {
    "id": "m_347",
    "sender": "Ankita",
    "time": "22:35",
    "date": "2026-07-21",
    "dateLabel": "21 July 2026",
    "text": "Acha",
    "type": "text"
  },
  {
    "id": "m_348",
    "sender": "Ratnadwip",
    "time": "00:37",
    "date": "2026-07-22",
    "dateLabel": "22 July 2026",
    "text": "amog us?",
    "type": "text"
  },
  {
    "id": "m_349",
    "sender": "Ankita",
    "time": "00:37",
    "date": "2026-07-22",
    "dateLabel": "22 July 2026",
    "text": "Yes",
    "type": "text"
  },
  {
    "id": "m_350",
    "sender": "Ankita",
    "time": "00:37",
    "date": "2026-07-22",
    "dateLabel": "22 July 2026",
    "text": "Link",
    "type": "text"
  },
  {
    "id": "m_351",
    "sender": "Ankita",
    "time": "00:37",
    "date": "2026-07-22",
    "dateLabel": "22 July 2026",
    "text": "Ba code plz",
    "type": "text"
  },
  {
    "id": "m_352",
    "sender": "Ratnadwip",
    "time": "00:38",
    "date": "2026-07-22",
    "dateLabel": "22 July 2026",
    "text": "5 min",
    "type": "text"
  },
  {
    "id": "m_353",
    "sender": "Ankita",
    "time": "00:38",
    "date": "2026-07-22",
    "dateLabel": "22 July 2026",
    "text": "🫩",
    "type": "text"
  },
  {
    "id": "m_354",
    "sender": "Ankita",
    "time": "00:38",
    "date": "2026-07-22",
    "dateLabel": "22 July 2026",
    "text": "Jldi",
    "type": "text"
  },
  {
    "id": "m_355",
    "sender": "Ratnadwip",
    "time": "00:38",
    "date": "2026-07-22",
    "dateLabel": "22 July 2026",
    "text": "tea cholche",
    "type": "text"
  },
  {
    "id": "m_356",
    "sender": "Ankita",
    "time": "00:38",
    "date": "2026-07-22",
    "dateLabel": "22 July 2026",
    "text": "Ghumobo aj",
    "type": "text"
  },
  {
    "id": "m_357",
    "sender": "Ratnadwip",
    "time": "00:38",
    "date": "2026-07-22",
    "dateLabel": "22 July 2026",
    "text": "discord",
    "type": "text"
  },
  {
    "id": "m_358",
    "sender": "Ankita",
    "time": "00:38",
    "date": "2026-07-22",
    "dateLabel": "22 July 2026",
    "text": "Kothay?",
    "type": "text"
  },
  {
    "id": "m_359",
    "sender": "Ratnadwip",
    "time": "00:38",
    "date": "2026-07-22",
    "dateLabel": "22 July 2026",
    "text": "orientation teaser",
    "type": "text"
  },
  {
    "id": "m_360",
    "sender": "Ankita",
    "time": "00:38",
    "date": "2026-07-22",
    "dateLabel": "22 July 2026",
    "text": "Dara jacchi",
    "type": "text"
  },
  {
    "id": "m_361",
    "sender": "Ankita",
    "time": "00:38",
    "date": "2026-07-22",
    "dateLabel": "22 July 2026",
    "text": "Dara dara",
    "type": "text"
  },
  {
    "id": "m_362",
    "sender": "Ratnadwip",
    "time": "01:55",
    "date": "2026-07-22",
    "dateLabel": "22 July 2026",
    "text": "malik",
    "type": "text"
  },
  {
    "id": "m_363",
    "sender": "Ratnadwip",
    "time": "01:55",
    "date": "2026-07-22",
    "dateLabel": "22 July 2026",
    "text": "malik impo",
    "type": "text"
  },
  {
    "id": "m_364",
    "sender": "Ankita",
    "time": "02:04",
    "date": "2026-07-22",
    "dateLabel": "22 July 2026",
    "text": "Fuck uu",
    "type": "text"
  },
  {
    "id": "m_365",
    "sender": "Ratnadwip",
    "time": "02:04",
    "date": "2026-07-22",
    "dateLabel": "22 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_366",
    "sender": "Ankita",
    "time": "23:27",
    "date": "2026-07-22",
    "dateLabel": "22 July 2026",
    "text": "Aa",
    "type": "text"
  },
  {
    "id": "m_367",
    "sender": "Ankita",
    "time": "23:27",
    "date": "2026-07-22",
    "dateLabel": "22 July 2026",
    "text": "Khelbi ki bol",
    "type": "text"
  },
  {
    "id": "m_368",
    "sender": "Ankita",
    "time": "23:27",
    "date": "2026-07-22",
    "dateLabel": "22 July 2026",
    "text": "😑😑",
    "type": "text"
  },
  {
    "id": "m_369",
    "sender": "Ankita",
    "time": "23:27",
    "date": "2026-07-22",
    "dateLabel": "22 July 2026",
    "text": "Noyto ghumabo <This message was edited>",
    "type": "text"
  },
  {
    "id": "m_370",
    "sender": "Ratnadwip",
    "time": "23:32",
    "date": "2026-07-22",
    "dateLabel": "22 July 2026",
    "text": "keu toh asche na aj",
    "type": "text"
  },
  {
    "id": "m_371",
    "sender": "Ratnadwip",
    "time": "23:32",
    "date": "2026-07-22",
    "dateLabel": "22 July 2026",
    "text": "ami eka bose achi",
    "type": "text"
  },
  {
    "id": "m_372",
    "sender": "Ratnadwip",
    "time": "23:32",
    "date": "2026-07-22",
    "dateLabel": "22 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_373",
    "sender": "Ankita",
    "time": "23:32",
    "date": "2026-07-22",
    "dateLabel": "22 July 2026",
    "text": "Morey ja",
    "type": "text"
  },
  {
    "id": "m_374",
    "sender": "Ankita",
    "time": "23:32",
    "date": "2026-07-22",
    "dateLabel": "22 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_375",
    "sender": "Ratnadwip",
    "time": "23:33",
    "date": "2026-07-22",
    "dateLabel": "22 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_376",
    "sender": "Ratnadwip",
    "time": "23:33",
    "date": "2026-07-22",
    "dateLabel": "22 July 2026",
    "text": "thats the goal",
    "type": "text"
  },
  {
    "id": "m_377",
    "sender": "Ankita",
    "time": "23:33",
    "date": "2026-07-22",
    "dateLabel": "22 July 2026",
    "text": "Wahhh then do that",
    "type": "text"
  },
  {
    "id": "m_378",
    "sender": "Ankita",
    "time": "23:33",
    "date": "2026-07-22",
    "dateLabel": "22 July 2026",
    "text": "Competition kombe market a",
    "type": "text"
  },
  {
    "id": "m_379",
    "sender": "Ratnadwip",
    "time": "23:33",
    "date": "2026-07-22",
    "dateLabel": "22 July 2026",
    "text": "eto taratari ghumiye poros",
    "type": "text"
  },
  {
    "id": "m_380",
    "sender": "Ratnadwip",
    "time": "23:33",
    "date": "2026-07-22",
    "dateLabel": "22 July 2026",
    "text": "crazy",
    "type": "text"
  },
  {
    "id": "m_381",
    "sender": "Ankita",
    "time": "23:33",
    "date": "2026-07-22",
    "dateLabel": "22 July 2026",
    "text": "Jor amr",
    "type": "text"
  },
  {
    "id": "m_382",
    "sender": "Ankita",
    "time": "23:34",
    "date": "2026-07-22",
    "dateLabel": "22 July 2026",
    "text": "Jor komche na",
    "type": "text"
  },
  {
    "id": "m_383",
    "sender": "Ratnadwip",
    "time": "23:34",
    "date": "2026-07-22",
    "dateLabel": "22 July 2026",
    "text": "tui age morbi",
    "type": "text"
  },
  {
    "id": "m_384",
    "sender": "Ratnadwip",
    "time": "23:34",
    "date": "2026-07-22",
    "dateLabel": "22 July 2026",
    "text": "less competition",
    "type": "text"
  },
  {
    "id": "m_385",
    "sender": "Ankita",
    "time": "23:34",
    "date": "2026-07-22",
    "dateLabel": "22 July 2026",
    "text": "Akdin thakey arek din thakey na",
    "type": "text"
  },
  {
    "id": "m_386",
    "sender": "Ankita",
    "time": "23:34",
    "date": "2026-07-22",
    "dateLabel": "22 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_387",
    "sender": "Ratnadwip",
    "time": "23:34",
    "date": "2026-07-22",
    "dateLabel": "22 July 2026",
    "text": "07.10.2026",
    "type": "text"
  },
  {
    "id": "m_388",
    "sender": "Ankita",
    "time": "23:34",
    "date": "2026-07-22",
    "dateLabel": "22 July 2026",
    "text": "Shut up yrr \nDon't spill the truth",
    "type": "text"
  },
  {
    "id": "m_389",
    "sender": "Ankita",
    "time": "23:34",
    "date": "2026-07-22",
    "dateLabel": "22 July 2026",
    "text": "What?",
    "type": "text"
  },
  {
    "id": "m_390",
    "sender": "Ratnadwip",
    "time": "23:35",
    "date": "2026-07-22",
    "dateLabel": "22 July 2026",
    "text": "i predict the DOD",
    "type": "text"
  },
  {
    "id": "m_391",
    "sender": "Ratnadwip",
    "time": "23:35",
    "date": "2026-07-22",
    "dateLabel": "22 July 2026",
    "text": "date of death",
    "type": "text"
  },
  {
    "id": "m_392",
    "sender": "Ankita",
    "time": "23:35",
    "date": "2026-07-22",
    "dateLabel": "22 July 2026",
    "text": "🫩🫩",
    "type": "text"
  },
  {
    "id": "m_393",
    "sender": "Ankita",
    "time": "23:35",
    "date": "2026-07-22",
    "dateLabel": "22 July 2026",
    "text": "Go to hell",
    "type": "text"
  },
  {
    "id": "m_394",
    "sender": "Ankita",
    "time": "23:35",
    "date": "2026-07-22",
    "dateLabel": "22 July 2026",
    "text": "Gng",
    "type": "text"
  },
  {
    "id": "m_395",
    "sender": "Ratnadwip",
    "time": "23:35",
    "date": "2026-07-22",
    "dateLabel": "22 July 2026",
    "text": "souradip esche",
    "type": "text"
  },
  {
    "id": "m_396",
    "sender": "Ankita",
    "time": "23:35",
    "date": "2026-07-22",
    "dateLabel": "22 July 2026",
    "text": "Hmn",
    "type": "text"
  },
  {
    "id": "m_397",
    "sender": "Ratnadwip",
    "time": "23:35",
    "date": "2026-07-22",
    "dateLabel": "22 July 2026",
    "text": "khela jai",
    "type": "text"
  },
  {
    "id": "m_398",
    "sender": "Ankita",
    "time": "23:35",
    "date": "2026-07-22",
    "dateLabel": "22 July 2026",
    "text": "Baki der phone kor",
    "type": "text"
  },
  {
    "id": "m_399",
    "sender": "Ankita",
    "time": "23:35",
    "date": "2026-07-22",
    "dateLabel": "22 July 2026",
    "text": "1 bar kheley ghumobo",
    "type": "text"
  },
  {
    "id": "m_400",
    "sender": "Ratnadwip",
    "time": "23:35",
    "date": "2026-07-22",
    "dateLabel": "22 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_401",
    "sender": "Ratnadwip",
    "time": "22:24",
    "date": "2026-07-23",
    "dateLabel": "23 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_402",
    "sender": "Ankita",
    "time": "22:24",
    "date": "2026-07-23",
    "dateLabel": "23 July 2026",
    "text": "😑",
    "type": "text"
  },
  {
    "id": "m_403",
    "sender": "Ankita",
    "time": "22:25",
    "date": "2026-07-23",
    "dateLabel": "23 July 2026",
    "text": "Delete kor",
    "type": "text"
  },
  {
    "id": "m_404",
    "sender": "Ankita",
    "time": "22:25",
    "date": "2026-07-23",
    "dateLabel": "23 July 2026",
    "text": "Sob jayga theke",
    "type": "text"
  },
  {
    "id": "m_405",
    "sender": "Ankita",
    "time": "22:25",
    "date": "2026-07-23",
    "dateLabel": "23 July 2026",
    "text": "Noyto bomb marbo",
    "type": "text"
  },
  {
    "id": "m_406",
    "sender": "Ratnadwip",
    "time": "22:25",
    "date": "2026-07-23",
    "dateLabel": "23 July 2026",
    "text": "kothao di ni. ig",
    "type": "text"
  },
  {
    "id": "m_407",
    "sender": "Ratnadwip",
    "time": "22:25",
    "date": "2026-07-23",
    "dateLabel": "23 July 2026",
    "text": "grp eo di ni",
    "type": "text"
  },
  {
    "id": "m_408",
    "sender": "Ankita",
    "time": "22:25",
    "date": "2026-07-23",
    "dateLabel": "23 July 2026",
    "text": "🫩thik achey",
    "type": "text"
  },
  {
    "id": "m_409",
    "sender": "Ankita",
    "time": "22:25",
    "date": "2026-07-23",
    "dateLabel": "23 July 2026",
    "text": "Among us?",
    "type": "text"
  },
  {
    "id": "m_410",
    "sender": "Ankita",
    "time": "22:25",
    "date": "2026-07-23",
    "dateLabel": "23 July 2026",
    "text": "Daak baki der",
    "type": "text"
  },
  {
    "id": "m_411",
    "sender": "Ratnadwip",
    "time": "22:26",
    "date": "2026-07-23",
    "dateLabel": "23 July 2026",
    "text": "khai ni ami. raat e bosbo",
    "type": "text"
  },
  {
    "id": "m_412",
    "sender": "Ratnadwip",
    "time": "22:26",
    "date": "2026-07-23",
    "dateLabel": "23 July 2026",
    "text": "12",
    "type": "text"
  },
  {
    "id": "m_413",
    "sender": "Ankita",
    "time": "22:26",
    "date": "2026-07-23",
    "dateLabel": "23 July 2026",
    "text": "Ghumobo ami",
    "type": "text"
  },
  {
    "id": "m_414",
    "sender": "Ankita",
    "time": "22:26",
    "date": "2026-07-23",
    "dateLabel": "23 July 2026",
    "text": "Jor amr",
    "type": "text"
  },
  {
    "id": "m_415",
    "sender": "Ratnadwip",
    "time": "22:26",
    "date": "2026-07-23",
    "dateLabel": "23 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_416",
    "sender": "Ankita",
    "time": "22:26",
    "date": "2026-07-23",
    "dateLabel": "23 July 2026",
    "text": "😑",
    "type": "text"
  },
  {
    "id": "m_417",
    "sender": "Ratnadwip",
    "time": "22:26",
    "date": "2026-07-23",
    "dateLabel": "23 July 2026",
    "text": "aj ghuma",
    "type": "text"
  },
  {
    "id": "m_418",
    "sender": "Ratnadwip",
    "time": "22:26",
    "date": "2026-07-23",
    "dateLabel": "23 July 2026",
    "text": "kal khelbo tale",
    "type": "text"
  },
  {
    "id": "m_419",
    "sender": "Ankita",
    "time": "22:26",
    "date": "2026-07-23",
    "dateLabel": "23 July 2026",
    "text": "Yes",
    "type": "text"
  },
  {
    "id": "m_420",
    "sender": "Ratnadwip",
    "time": "22:26",
    "date": "2026-07-23",
    "dateLabel": "23 July 2026",
    "text": "aj minecraft",
    "type": "text"
  },
  {
    "id": "m_421",
    "sender": "Ankita",
    "time": "22:26",
    "date": "2026-07-23",
    "dateLabel": "23 July 2026",
    "text": "Kal o hobe na",
    "type": "text"
  },
  {
    "id": "m_422",
    "sender": "Ankita",
    "time": "22:26",
    "date": "2026-07-23",
    "dateLabel": "23 July 2026",
    "text": "Amio kheli bro",
    "type": "text"
  },
  {
    "id": "m_423",
    "sender": "Ankita",
    "time": "22:26",
    "date": "2026-07-23",
    "dateLabel": "23 July 2026",
    "text": "🥲😭🤌🏻",
    "type": "text"
  },
  {
    "id": "m_424",
    "sender": "Ratnadwip",
    "time": "22:26",
    "date": "2026-07-23",
    "dateLabel": "23 July 2026",
    "text": "kal age age khelbo.",
    "type": "text"
  },
  {
    "id": "m_425",
    "sender": "Ratnadwip",
    "time": "22:26",
    "date": "2026-07-23",
    "dateLabel": "23 July 2026",
    "text": "pc",
    "type": "text"
  },
  {
    "id": "m_426",
    "sender": "Ankita",
    "time": "22:27",
    "date": "2026-07-23",
    "dateLabel": "23 July 2026",
    "text": "No no",
    "type": "text"
  },
  {
    "id": "m_427",
    "sender": "Ankita",
    "time": "22:27",
    "date": "2026-07-23",
    "dateLabel": "23 July 2026",
    "text": "Not pc",
    "type": "text"
  },
  {
    "id": "m_428",
    "sender": "Ratnadwip",
    "time": "22:27",
    "date": "2026-07-23",
    "dateLabel": "23 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_429",
    "sender": "Ratnadwip",
    "time": "22:27",
    "date": "2026-07-23",
    "dateLabel": "23 July 2026",
    "text": "amra pc te kheli",
    "type": "text"
  },
  {
    "id": "m_430",
    "sender": "Ankita",
    "time": "22:27",
    "date": "2026-07-23",
    "dateLabel": "23 July 2026",
    "text": "Boroloks",
    "type": "text"
  },
  {
    "id": "m_431",
    "sender": "Ankita",
    "time": "22:27",
    "date": "2026-07-23",
    "dateLabel": "23 July 2026",
    "text": "Tai",
    "type": "text"
  },
  {
    "id": "m_432",
    "sender": "Ratnadwip",
    "time": "22:27",
    "date": "2026-07-23",
    "dateLabel": "23 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_433",
    "sender": "Ankita",
    "time": "22:27",
    "date": "2026-07-23",
    "dateLabel": "23 July 2026",
    "text": "🤧",
    "type": "text"
  },
  {
    "id": "m_434",
    "sender": "Ankita",
    "time": "22:27",
    "date": "2026-07-23",
    "dateLabel": "23 July 2026",
    "text": "Download hoy na",
    "type": "text"
  },
  {
    "id": "m_435",
    "sender": "Ratnadwip",
    "time": "22:27",
    "date": "2026-07-23",
    "dateLabel": "23 July 2026",
    "text": "ez download kora",
    "type": "text"
  },
  {
    "id": "m_436",
    "sender": "Ankita",
    "time": "22:28",
    "date": "2026-07-23",
    "dateLabel": "23 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_437",
    "sender": "Ratnadwip",
    "time": "14:37",
    "date": "2026-07-27",
    "dateLabel": "27 July 2026",
    "text": "srutijatk ki ?",
    "type": "text"
  },
  {
    "id": "m_438",
    "sender": "Ankita",
    "time": "14:38",
    "date": "2026-07-27",
    "dateLabel": "27 July 2026",
    "text": "Amar gaan er grp er name chilo",
    "type": "text"
  },
  {
    "id": "m_439",
    "sender": "Ankita",
    "time": "14:38",
    "date": "2026-07-27",
    "dateLabel": "27 July 2026",
    "text": "Chilo bola bhul achey",
    "type": "text"
  },
  {
    "id": "m_440",
    "sender": "Ratnadwip",
    "time": "14:38",
    "date": "2026-07-27",
    "dateLabel": "27 July 2026",
    "text": "damn",
    "type": "text"
  },
  {
    "id": "m_441",
    "sender": "Ratnadwip",
    "time": "14:38",
    "date": "2026-07-27",
    "dateLabel": "27 July 2026",
    "text": "koto purono ?",
    "type": "text"
  },
  {
    "id": "m_442",
    "sender": "Ankita",
    "time": "14:38",
    "date": "2026-07-27",
    "dateLabel": "27 July 2026",
    "text": "Onek",
    "type": "text"
  },
  {
    "id": "m_443",
    "sender": "Ankita",
    "time": "14:38",
    "date": "2026-07-27",
    "dateLabel": "27 July 2026",
    "text": "Thik moton amio jni na",
    "type": "text"
  },
  {
    "id": "m_444",
    "sender": "Ratnadwip",
    "time": "14:38",
    "date": "2026-07-27",
    "dateLabel": "27 July 2026",
    "text": "cd keno post korchis. content ta post kor",
    "type": "text"
  },
  {
    "id": "m_445",
    "sender": "Ankita",
    "time": "14:39",
    "date": "2026-07-27",
    "dateLabel": "27 July 2026",
    "text": "Arey dvd nosto hoye gacchey bang",
    "type": "text"
  },
  {
    "id": "m_446",
    "sender": "Ankita",
    "time": "14:39",
    "date": "2026-07-27",
    "dateLabel": "27 July 2026",
    "text": "🫩🫩",
    "type": "text"
  },
  {
    "id": "m_447",
    "sender": "Ratnadwip",
    "time": "14:39",
    "date": "2026-07-27",
    "dateLabel": "27 July 2026",
    "text": "eta toh cd, not dvd",
    "type": "text"
  },
  {
    "id": "m_448",
    "sender": "Ankita",
    "time": "14:39",
    "date": "2026-07-27",
    "dateLabel": "27 July 2026",
    "text": "R cd ta toh maa khujey pelo tai dilo",
    "type": "text"
  },
  {
    "id": "m_449",
    "sender": "Ankita",
    "time": "14:39",
    "date": "2026-07-27",
    "dateLabel": "27 July 2026",
    "text": "Eta kothay lagabo?",
    "type": "text"
  },
  {
    "id": "m_450",
    "sender": "Ankita",
    "time": "14:40",
    "date": "2026-07-27",
    "dateLabel": "27 July 2026",
    "text": "🫩🫩🤌🏻",
    "type": "text"
  },
  {
    "id": "m_451",
    "sender": "Ratnadwip",
    "time": "14:40",
    "date": "2026-07-27",
    "dateLabel": "27 July 2026",
    "text": "cd reader",
    "type": "text"
  },
  {
    "id": "m_452",
    "sender": "Ankita",
    "time": "14:40",
    "date": "2026-07-27",
    "dateLabel": "27 July 2026",
    "text": "Eta ki?",
    "type": "text"
  },
  {
    "id": "m_453",
    "sender": "Ratnadwip",
    "time": "14:40",
    "date": "2026-07-27",
    "dateLabel": "27 July 2026",
    "text": "cd chalas ni konodin ?",
    "type": "text"
  },
  {
    "id": "m_454",
    "sender": "Ankita",
    "time": "14:40",
    "date": "2026-07-27",
    "dateLabel": "27 July 2026",
    "text": "Hyaa but bohu din agey",
    "type": "text"
  },
  {
    "id": "m_455",
    "sender": "Ratnadwip",
    "time": "14:41",
    "date": "2026-07-27",
    "dateLabel": "27 July 2026",
    "text": "oi same bhabe e chalate hoi.",
    "type": "text"
  },
  {
    "id": "m_456",
    "sender": "Ankita",
    "time": "14:41",
    "date": "2026-07-27",
    "dateLabel": "27 July 2026",
    "text": "But tokhon toh dvd te chalatam",
    "type": "text"
  },
  {
    "id": "m_457",
    "sender": "Ratnadwip",
    "time": "14:41",
    "date": "2026-07-27",
    "dateLabel": "27 July 2026",
    "text": "oh",
    "type": "text"
  },
  {
    "id": "m_458",
    "sender": "Ankita",
    "time": "14:41",
    "date": "2026-07-27",
    "dateLabel": "27 July 2026",
    "text": "Accha",
    "type": "text"
  },
  {
    "id": "m_459",
    "sender": "Ratnadwip",
    "time": "14:41",
    "date": "2026-07-27",
    "dateLabel": "27 July 2026",
    "text": "amar pc te chole",
    "type": "text"
  },
  {
    "id": "m_460",
    "sender": "Ankita",
    "time": "14:41",
    "date": "2026-07-27",
    "dateLabel": "27 July 2026",
    "text": "Amr pc nei mora",
    "type": "text"
  },
  {
    "id": "m_461",
    "sender": "Ankita",
    "time": "14:41",
    "date": "2026-07-27",
    "dateLabel": "27 July 2026",
    "text": "Laptop",
    "type": "text"
  },
  {
    "id": "m_462",
    "sender": "Ankita",
    "time": "14:41",
    "date": "2026-07-27",
    "dateLabel": "27 July 2026",
    "text": "🫩🫩",
    "type": "text"
  },
  {
    "id": "m_463",
    "sender": "Ratnadwip",
    "time": "14:41",
    "date": "2026-07-27",
    "dateLabel": "27 July 2026",
    "text": "ami amar onnoprason recovery korechi 🫡🫡",
    "type": "text"
  },
  {
    "id": "m_464",
    "sender": "Ankita",
    "time": "14:42",
    "date": "2026-07-27",
    "dateLabel": "27 July 2026",
    "text": "Ebr bolish na laptop khuley chala",
    "type": "text"
  },
  {
    "id": "m_465",
    "sender": "Ratnadwip",
    "time": "14:42",
    "date": "2026-07-27",
    "dateLabel": "27 July 2026",
    "text": "actually",
    "type": "text"
  },
  {
    "id": "m_466",
    "sender": "Ankita",
    "time": "14:42",
    "date": "2026-07-27",
    "dateLabel": "27 July 2026",
    "text": "Sera byapar",
    "type": "text"
  },
  {
    "id": "m_467",
    "sender": "Ratnadwip",
    "time": "14:42",
    "date": "2026-07-27",
    "dateLabel": "27 July 2026",
    "text": "https://amzn.in/d/04XEPu5q",
    "type": "link",
    "linkUrl": "https://amzn.in/d/04XEPu5q"
  },
  {
    "id": "m_468",
    "sender": "Ankita",
    "time": "14:51",
    "date": "2026-07-27",
    "dateLabel": "27 July 2026",
    "text": "Bhlo jinis",
    "type": "text"
  },
  {
    "id": "m_469",
    "sender": "Ankita",
    "time": "14:51",
    "date": "2026-07-27",
    "dateLabel": "27 July 2026",
    "text": "Maa k dekhlm",
    "type": "text"
  },
  {
    "id": "m_470",
    "sender": "Ankita",
    "time": "14:51",
    "date": "2026-07-27",
    "dateLabel": "27 July 2026",
    "text": "🤪",
    "type": "text"
  },
  {
    "id": "m_471",
    "sender": "Ankita",
    "time": "14:51",
    "date": "2026-07-27",
    "dateLabel": "27 July 2026",
    "text": "Dbe bllo",
    "type": "text"
  },
  {
    "id": "m_472",
    "sender": "Ratnadwip",
    "time": "14:52",
    "date": "2026-07-27",
    "dateLabel": "27 July 2026",
    "text": "😁😁",
    "type": "text"
  },
  {
    "id": "m_473",
    "sender": "Ratnadwip",
    "time": "14:53",
    "date": "2026-07-27",
    "dateLabel": "27 July 2026",
    "text": "ami bhalo kothai boli",
    "type": "text"
  },
  {
    "id": "m_474",
    "sender": "Ankita",
    "time": "14:53",
    "date": "2026-07-27",
    "dateLabel": "27 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_475",
    "sender": "Ankita",
    "time": "14:53",
    "date": "2026-07-27",
    "dateLabel": "27 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_476",
    "sender": "Ankita",
    "time": "10:41",
    "date": "2026-07-28",
    "dateLabel": "28 July 2026",
    "text": "Kothay tui?",
    "type": "text"
  },
  {
    "id": "m_477",
    "sender": "Ratnadwip",
    "time": "10:41",
    "date": "2026-07-28",
    "dateLabel": "28 July 2026",
    "text": "bridge",
    "type": "text"
  },
  {
    "id": "m_478",
    "sender": "Ratnadwip",
    "time": "16:35",
    "date": "2026-07-28",
    "dateLabel": "28 July 2026",
    "text": "ki hoyeche aunty",
    "type": "text"
  },
  {
    "id": "m_479",
    "sender": "Ankita",
    "time": "16:35",
    "date": "2026-07-28",
    "dateLabel": "28 July 2026",
    "text": "Case hoyeche",
    "type": "text"
  },
  {
    "id": "m_480",
    "sender": "Ankita",
    "time": "16:36",
    "date": "2026-07-28",
    "dateLabel": "28 July 2026",
    "text": "Epic scene",
    "type": "text"
  },
  {
    "id": "m_481",
    "sender": "Ratnadwip",
    "time": "21:55",
    "date": "2026-07-28",
    "dateLabel": "28 July 2026",
    "text": "asbi dc?",
    "type": "text"
  },
  {
    "id": "m_482",
    "sender": "Ankita",
    "time": "21:57",
    "date": "2026-07-28",
    "dateLabel": "28 July 2026",
    "text": "Jacchi wait",
    "type": "text"
  },
  {
    "id": "m_483",
    "sender": "Ratnadwip",
    "time": "21:58",
    "date": "2026-07-28",
    "dateLabel": "28 July 2026",
    "text": "aai aai aai",
    "type": "text"
  },
  {
    "id": "m_484",
    "sender": "Ratnadwip",
    "time": "00:09",
    "date": "2026-07-30",
    "dateLabel": "30 July 2026",
    "text": "ed0b3b4a9b",
    "type": "text"
  },
  {
    "id": "m_485",
    "sender": "Ankita",
    "time": "00:10",
    "date": "2026-07-30",
    "dateLabel": "30 July 2026",
    "text": "Ki eta?",
    "type": "text"
  },
  {
    "id": "m_486",
    "sender": "Ankita",
    "time": "00:10",
    "date": "2026-07-30",
    "dateLabel": "30 July 2026",
    "text": "Kon hackathone eta bol",
    "type": "text"
  },
  {
    "id": "m_487",
    "sender": "Ankita",
    "time": "00:10",
    "date": "2026-07-30",
    "dateLabel": "30 July 2026",
    "text": "Agey",
    "type": "text"
  },
  {
    "id": "m_488",
    "sender": "Ankita",
    "time": "00:10",
    "date": "2026-07-30",
    "dateLabel": "30 July 2026",
    "text": "🫩🤌🏻🥲",
    "type": "text"
  },
  {
    "id": "m_489",
    "sender": "Ratnadwip",
    "time": "00:10",
    "date": "2026-07-30",
    "dateLabel": "30 July 2026",
    "text": "https://hacknex-season-2.devfolio.co/",
    "type": "link",
    "linkUrl": "https://hacknex-season-2.devfolio.co/"
  },
  {
    "id": "m_490",
    "sender": "Ratnadwip",
    "time": "00:16",
    "date": "2026-07-30",
    "dateLabel": "30 July 2026",
    "text": ".",
    "type": "text"
  },
  {
    "id": "m_491",
    "sender": "Ankita",
    "time": "00:18",
    "date": "2026-07-30",
    "dateLabel": "30 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_492",
    "sender": "Ankita",
    "time": "00:18",
    "date": "2026-07-30",
    "dateLabel": "30 July 2026",
    "text": "Matha nosto",
    "type": "text"
  },
  {
    "id": "m_493",
    "sender": "Ratnadwip",
    "time": "20:20",
    "date": "2026-07-30",
    "dateLabel": "30 July 2026",
    "text": "VID-20260730-WA0023.mp4 (file attached)",
    "type": "video",
    "mediaName": "VID-20260730-WA0023.mp4"
  },
  {
    "id": "m_494",
    "sender": "Ratnadwip",
    "time": "21:03",
    "date": "2026-07-30",
    "dateLabel": "30 July 2026",
    "text": "VID-20260730-WA0028.mp4 (file attached)",
    "type": "video",
    "mediaName": "VID-20260730-WA0028.mp4"
  },
  {
    "id": "m_495",
    "sender": "Ankita",
    "time": "21:04",
    "date": "2026-07-30",
    "dateLabel": "30 July 2026",
    "text": "PTT-20260730-WA0026.opus (file attached)",
    "type": "voice_note",
    "mediaName": "PTT-20260730-WA0026.opus"
  },
  {
    "id": "m_496",
    "sender": "Ratnadwip",
    "time": "21:05",
    "date": "2026-07-30",
    "dateLabel": "30 July 2026",
    "text": "ota ichha kore e dilam 😂🤣🤣",
    "type": "text"
  },
  {
    "id": "m_497",
    "sender": "Ratnadwip",
    "time": "21:05",
    "date": "2026-07-30",
    "dateLabel": "30 July 2026",
    "text": "serious kichu deoar moto pachhi na, bhablam comedy diye di",
    "type": "text"
  },
  {
    "id": "m_498",
    "sender": "Ratnadwip",
    "time": "21:06",
    "date": "2026-07-30",
    "dateLabel": "30 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_499",
    "sender": "Ankita",
    "time": "21:06",
    "date": "2026-07-30",
    "dateLabel": "30 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_500",
    "sender": "Ankita",
    "time": "21:06",
    "date": "2026-07-30",
    "dateLabel": "30 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_501",
    "sender": "Ankita",
    "time": "21:06",
    "date": "2026-07-30",
    "dateLabel": "30 July 2026",
    "text": "But amr bishaal hasi paccheyy",
    "type": "text"
  },
  {
    "id": "m_502",
    "sender": "Ankita",
    "time": "21:06",
    "date": "2026-07-30",
    "dateLabel": "30 July 2026",
    "text": "🤣🤣🤣",
    "type": "text"
  },
  {
    "id": "m_503",
    "sender": "Ratnadwip",
    "time": "21:06",
    "date": "2026-07-30",
    "dateLabel": "30 July 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_504",
    "sender": "Ratnadwip",
    "time": "16:58",
    "date": "2026-07-31",
    "dateLabel": "31 July 2026",
    "text": "ki re beche gechis ?",
    "type": "text"
  },
  {
    "id": "m_505",
    "sender": "Ratnadwip",
    "time": "22:37",
    "date": "2026-07-31",
    "dateLabel": "31 July 2026",
    "text": "😂",
    "type": "text"
  },
  {
    "id": "m_506",
    "sender": "Ratnadwip",
    "time": "15:08",
    "date": "2026-08-02",
    "dateLabel": "2 August 2026",
    "text": "cover img ta darun",
    "type": "text"
  },
  {
    "id": "m_507",
    "sender": "Ankita",
    "time": "22:10",
    "date": "2026-08-04",
    "dateLabel": "4 August 2026",
    "text": "Among us?",
    "type": "text"
  },
  {
    "id": "m_508",
    "sender": "Ankita",
    "time": "22:10",
    "date": "2026-08-04",
    "dateLabel": "4 August 2026",
    "text": "Akbar?",
    "type": "text"
  },
  {
    "id": "m_509",
    "sender": "Ratnadwip",
    "time": "22:11",
    "date": "2026-08-04",
    "dateLabel": "4 August 2026",
    "text": "hok hok",
    "type": "text"
  },
  {
    "id": "m_510",
    "sender": "Ratnadwip",
    "time": "22:12",
    "date": "2026-08-04",
    "dateLabel": "4 August 2026",
    "text": "discord e on hochhi",
    "type": "text"
  },
  {
    "id": "m_511",
    "sender": "Ratnadwip",
    "time": "22:17",
    "date": "2026-08-04",
    "dateLabel": "4 August 2026",
    "text": "koiii",
    "type": "text"
  },
  {
    "id": "m_512",
    "sender": "Ankita",
    "time": "22:21",
    "date": "2026-08-04",
    "dateLabel": "4 August 2026",
    "text": "Oohh dara",
    "type": "text"
  },
  {
    "id": "m_513",
    "sender": "Ankita",
    "time": "22:21",
    "date": "2026-08-04",
    "dateLabel": "4 August 2026",
    "text": "Arey net off korey diyechi",
    "type": "text"
  },
  {
    "id": "m_514",
    "sender": "Ankita",
    "time": "22:21",
    "date": "2026-08-04",
    "dateLabel": "4 August 2026",
    "text": "Bhul korey",
    "type": "text"
  },
  {
    "id": "m_515",
    "sender": "Ratnadwip",
    "time": "22:21",
    "date": "2026-08-04",
    "dateLabel": "4 August 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_516",
    "sender": "Ankita",
    "time": "22:22",
    "date": "2026-08-04",
    "dateLabel": "4 August 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_517",
    "sender": "Ankita",
    "time": "21:24",
    "date": "2026-08-05",
    "dateLabel": "5 August 2026",
    "text": "https://github.com/ankitaaichhh29",
    "type": "link",
    "linkUrl": "https://github.com/ankitaaichhh29"
  },
  {
    "id": "m_518",
    "sender": "Ankita",
    "time": "21:24",
    "date": "2026-08-05",
    "dateLabel": "5 August 2026",
    "text": "🫩",
    "type": "text"
  },
  {
    "id": "m_519",
    "sender": "Ankita",
    "time": "21:24",
    "date": "2026-08-05",
    "dateLabel": "5 August 2026",
    "text": "Eta ki?",
    "type": "text"
  },
  {
    "id": "m_520",
    "sender": "Ankita",
    "time": "21:41",
    "date": "2026-08-05",
    "dateLabel": "5 August 2026",
    "text": "Open Renovation Presentation.pptx (file attached)",
    "type": "text"
  },
  {
    "id": "m_521",
    "sender": "Ratnadwip",
    "time": "23:39",
    "date": "2026-08-07",
    "dateLabel": "7 August 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_522",
    "sender": "Ankita",
    "time": "23:40",
    "date": "2026-08-07",
    "dateLabel": "7 August 2026",
    "text": "Ki holo?",
    "type": "text"
  },
  {
    "id": "m_523",
    "sender": "Ankita",
    "time": "23:40",
    "date": "2026-08-07",
    "dateLabel": "7 August 2026",
    "text": "Bhlo toh reel ta",
    "type": "text"
  },
  {
    "id": "m_524",
    "sender": "Ankita",
    "time": "23:40",
    "date": "2026-08-07",
    "dateLabel": "7 August 2026",
    "text": "🫠🫠🫠",
    "type": "text"
  },
  {
    "id": "m_525",
    "sender": "Ratnadwip",
    "time": "23:40",
    "date": "2026-08-07",
    "dateLabel": "7 August 2026",
    "text": "reel e real hobe na 🥲",
    "type": "text"
  },
  {
    "id": "m_526",
    "sender": "Ankita",
    "time": "23:40",
    "date": "2026-08-07",
    "dateLabel": "7 August 2026",
    "text": "Erm asa bhangis kno blth??",
    "type": "text"
  },
  {
    "id": "m_527",
    "sender": "Ankita",
    "time": "23:40",
    "date": "2026-08-07",
    "dateLabel": "7 August 2026",
    "text": "😑😑😑",
    "type": "text"
  },
  {
    "id": "m_528",
    "sender": "Ankita",
    "time": "23:41",
    "date": "2026-08-07",
    "dateLabel": "7 August 2026",
    "text": "Pocha chele",
    "type": "text"
  },
  {
    "id": "m_529",
    "sender": "Ratnadwip",
    "time": "23:41",
    "date": "2026-08-07",
    "dateLabel": "7 August 2026",
    "text": "bhetor theke benge gechi",
    "type": "text"
  },
  {
    "id": "m_530",
    "sender": "Ankita",
    "time": "23:41",
    "date": "2026-08-07",
    "dateLabel": "7 August 2026",
    "text": "Se jni osob hoyy ei boyoshe",
    "type": "text"
  },
  {
    "id": "m_531",
    "sender": "Ankita",
    "time": "23:41",
    "date": "2026-08-07",
    "dateLabel": "7 August 2026",
    "text": "But bhalor jnnoi hoyy",
    "type": "text"
  },
  {
    "id": "m_532",
    "sender": "Ankita",
    "time": "23:41",
    "date": "2026-08-07",
    "dateLabel": "7 August 2026",
    "text": "Point eta",
    "type": "text"
  },
  {
    "id": "m_533",
    "sender": "Ratnadwip",
    "time": "23:42",
    "date": "2026-08-07",
    "dateLabel": "7 August 2026",
    "text": "achha, tai naki...",
    "type": "text"
  },
  {
    "id": "m_534",
    "sender": "Ankita",
    "time": "23:42",
    "date": "2026-08-07",
    "dateLabel": "7 August 2026",
    "text": "👻👻hyaa",
    "type": "text"
  },
  {
    "id": "m_535",
    "sender": "Ratnadwip",
    "time": "23:42",
    "date": "2026-08-07",
    "dateLabel": "7 August 2026",
    "text": "eta thik",
    "type": "text"
  },
  {
    "id": "m_536",
    "sender": "Ankita",
    "time": "23:42",
    "date": "2026-08-07",
    "dateLabel": "7 August 2026",
    "text": "Thle???",
    "type": "text"
  },
  {
    "id": "m_537",
    "sender": "Ankita",
    "time": "23:42",
    "date": "2026-08-07",
    "dateLabel": "7 August 2026",
    "text": "Atoh bhabte nei",
    "type": "text"
  },
  {
    "id": "m_538",
    "sender": "Ankita",
    "time": "23:42",
    "date": "2026-08-07",
    "dateLabel": "7 August 2026",
    "text": "Bhuley giye lafate hoy",
    "type": "text"
  },
  {
    "id": "m_539",
    "sender": "Ratnadwip",
    "time": "23:42",
    "date": "2026-08-07",
    "dateLabel": "7 August 2026",
    "text": "sob somoy hoi na",
    "type": "text"
  },
  {
    "id": "m_540",
    "sender": "Ankita",
    "time": "23:44",
    "date": "2026-08-07",
    "dateLabel": "7 August 2026",
    "text": "But majhey moddhey toh hoyy",
    "type": "text"
  },
  {
    "id": "m_541",
    "sender": "Ankita",
    "time": "23:45",
    "date": "2026-08-07",
    "dateLabel": "7 August 2026",
    "text": "Tora keu amr past jnis na jnle r esob depression tora r bhabtis e naa🤣🤦🏻‍♀️ <This message was edited>",
    "type": "text"
  },
  {
    "id": "m_542",
    "sender": "Ratnadwip",
    "time": "23:45",
    "date": "2026-08-07",
    "dateLabel": "7 August 2026",
    "text": "🙃🙃 sobar e past thake. sobai sobar moto traumatized",
    "type": "text"
  },
  {
    "id": "m_543",
    "sender": "Ankita",
    "time": "23:46",
    "date": "2026-08-07",
    "dateLabel": "7 August 2026",
    "text": "Point",
    "type": "text"
  },
  {
    "id": "m_544",
    "sender": "Ankita",
    "time": "23:46",
    "date": "2026-08-07",
    "dateLabel": "7 August 2026",
    "text": "But lafano thamate nei point eta🙂🤌🏻",
    "type": "text"
  },
  {
    "id": "m_545",
    "sender": "Ratnadwip",
    "time": "23:47",
    "date": "2026-08-07",
    "dateLabel": "7 August 2026",
    "text": "ekhon ekta chobi dekhlam. dekhi college e bhorti hoyeche",
    "type": "text"
  },
  {
    "id": "m_546",
    "sender": "Ratnadwip",
    "time": "23:47",
    "date": "2026-08-07",
    "dateLabel": "7 August 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_547",
    "sender": "Ankita",
    "time": "23:47",
    "date": "2026-08-07",
    "dateLabel": "7 August 2026",
    "text": "K?",
    "type": "text"
  },
  {
    "id": "m_548",
    "sender": "Ankita",
    "time": "23:48",
    "date": "2026-08-07",
    "dateLabel": "7 August 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_549",
    "sender": "Ratnadwip",
    "time": "23:49",
    "date": "2026-08-07",
    "dateLabel": "7 August 2026",
    "text": "past",
    "type": "text"
  },
  {
    "id": "m_550",
    "sender": "Ankita",
    "time": "23:49",
    "date": "2026-08-07",
    "dateLabel": "7 August 2026",
    "text": "Ayeinnn 🙃",
    "type": "text"
  },
  {
    "id": "m_551",
    "sender": "Ankita",
    "time": "23:49",
    "date": "2026-08-07",
    "dateLabel": "7 August 2026",
    "text": "Bujhlm na",
    "type": "text"
  },
  {
    "id": "m_552",
    "sender": "Ratnadwip",
    "time": "23:51",
    "date": "2026-08-07",
    "dateLabel": "7 August 2026",
    "text": "ex no 1",
    "type": "text"
  },
  {
    "id": "m_553",
    "sender": "Ankita",
    "time": "23:51",
    "date": "2026-08-07",
    "dateLabel": "7 August 2026",
    "text": "Amader clg a admit?",
    "type": "text"
  },
  {
    "id": "m_554",
    "sender": "Ankita",
    "time": "23:51",
    "date": "2026-08-07",
    "dateLabel": "7 August 2026",
    "text": "Mati koreche 🙃",
    "type": "text"
  },
  {
    "id": "m_555",
    "sender": "Ratnadwip",
    "time": "23:52",
    "date": "2026-08-07",
    "dateLabel": "7 August 2026",
    "text": "na na",
    "type": "text"
  },
  {
    "id": "m_556",
    "sender": "Ankita",
    "time": "23:52",
    "date": "2026-08-07",
    "dateLabel": "7 August 2026",
    "text": "Oo tai bol",
    "type": "text"
  },
  {
    "id": "m_557",
    "sender": "Ratnadwip",
    "time": "23:52",
    "date": "2026-08-07",
    "dateLabel": "7 August 2026",
    "text": "se onek dure ekhon",
    "type": "text"
  },
  {
    "id": "m_558",
    "sender": "Ankita",
    "time": "23:52",
    "date": "2026-08-07",
    "dateLabel": "7 August 2026",
    "text": "Tatey ki chaar",
    "type": "text"
  },
  {
    "id": "m_559",
    "sender": "Ankita",
    "time": "23:52",
    "date": "2026-08-07",
    "dateLabel": "7 August 2026",
    "text": "Bhabis na baad de",
    "type": "text"
  },
  {
    "id": "m_560",
    "sender": "Ratnadwip",
    "time": "23:52",
    "date": "2026-08-07",
    "dateLabel": "7 August 2026",
    "text": "🙂🙂",
    "type": "text"
  },
  {
    "id": "m_561",
    "sender": "Ankita",
    "time": "23:52",
    "date": "2026-08-07",
    "dateLabel": "7 August 2026",
    "text": "🙂🙂",
    "type": "text"
  },
  {
    "id": "m_562",
    "sender": "Ankita",
    "time": "23:53",
    "date": "2026-08-07",
    "dateLabel": "7 August 2026",
    "text": "Bolbo dekhbi amr trauma er kotha sunle tui trauma y jbi",
    "type": "text"
  },
  {
    "id": "m_563",
    "sender": "Ankita",
    "time": "23:53",
    "date": "2026-08-07",
    "dateLabel": "7 August 2026",
    "text": "Esob toh baccha der bisoy tora ja bolishh",
    "type": "text"
  },
  {
    "id": "m_564",
    "sender": "Ankita",
    "time": "23:53",
    "date": "2026-08-07",
    "dateLabel": "7 August 2026",
    "text": "🙃🙃🙂‍↕️",
    "type": "text"
  },
  {
    "id": "m_565",
    "sender": "Ratnadwip",
    "time": "23:53",
    "date": "2026-08-07",
    "dateLabel": "7 August 2026",
    "text": "ranked trauma",
    "type": "text"
  },
  {
    "id": "m_566",
    "sender": "Ankita",
    "time": "23:53",
    "date": "2026-08-07",
    "dateLabel": "7 August 2026",
    "text": "Hyaa koyek jon k bolechilm tara aj o trauma y acchey just suney",
    "type": "text"
  },
  {
    "id": "m_567",
    "sender": "Ankita",
    "time": "23:54",
    "date": "2026-08-07",
    "dateLabel": "7 August 2026",
    "text": "🙂‍↕️😆🤣",
    "type": "text"
  },
  {
    "id": "m_568",
    "sender": "Ratnadwip",
    "time": "23:54",
    "date": "2026-08-07",
    "dateLabel": "7 August 2026",
    "text": "amar ta sune o koek jon trauma te ache",
    "type": "text"
  },
  {
    "id": "m_569",
    "sender": "Ratnadwip",
    "time": "23:54",
    "date": "2026-08-07",
    "dateLabel": "7 August 2026",
    "text": "🥲",
    "type": "text"
  },
  {
    "id": "m_570",
    "sender": "Ankita",
    "time": "23:54",
    "date": "2026-08-07",
    "dateLabel": "7 August 2026",
    "text": "Bolish sunbo🙃",
    "type": "text"
  },
  {
    "id": "m_571",
    "sender": "Ankita",
    "time": "23:54",
    "date": "2026-08-07",
    "dateLabel": "7 August 2026",
    "text": "Nki last er ta ?",
    "type": "text"
  },
  {
    "id": "m_572",
    "sender": "Ankita",
    "time": "23:54",
    "date": "2026-08-07",
    "dateLabel": "7 August 2026",
    "text": "Last er ta toh jni",
    "type": "text"
  },
  {
    "id": "m_573",
    "sender": "Ankita",
    "time": "23:54",
    "date": "2026-08-07",
    "dateLabel": "7 August 2026",
    "text": "Ager gulo sunbo",
    "type": "text"
  },
  {
    "id": "m_574",
    "sender": "Ratnadwip",
    "time": "23:54",
    "date": "2026-08-07",
    "dateLabel": "7 August 2026",
    "text": "last er ta toh kichu e na",
    "type": "text"
  },
  {
    "id": "m_575",
    "sender": "Ankita",
    "time": "23:54",
    "date": "2026-08-07",
    "dateLabel": "7 August 2026",
    "text": "🙃🙃",
    "type": "text"
  },
  {
    "id": "m_576",
    "sender": "Ankita",
    "time": "23:55",
    "date": "2026-08-07",
    "dateLabel": "7 August 2026",
    "text": "Ager gulo hya hya sunbo",
    "type": "text"
  },
  {
    "id": "m_577",
    "sender": "Ratnadwip",
    "time": "23:55",
    "date": "2026-08-07",
    "dateLabel": "7 August 2026",
    "text": "ota toh kichu e hoi ni",
    "type": "text"
  },
  {
    "id": "m_578",
    "sender": "Ankita",
    "time": "23:55",
    "date": "2026-08-07",
    "dateLabel": "7 August 2026",
    "text": "🙃🙃",
    "type": "text"
  },
  {
    "id": "m_579",
    "sender": "Ankita",
    "time": "23:55",
    "date": "2026-08-07",
    "dateLabel": "7 August 2026",
    "text": "Sunbo sunbo clg je din jbo sunbo",
    "type": "text"
  },
  {
    "id": "m_580",
    "sender": "Ratnadwip",
    "time": "23:55",
    "date": "2026-08-07",
    "dateLabel": "7 August 2026",
    "text": "maal niye boste hobe",
    "type": "text"
  },
  {
    "id": "m_581",
    "sender": "Ratnadwip",
    "time": "23:55",
    "date": "2026-08-07",
    "dateLabel": "7 August 2026",
    "text": "dekhi",
    "type": "text"
  },
  {
    "id": "m_582",
    "sender": "Ankita",
    "time": "23:55",
    "date": "2026-08-07",
    "dateLabel": "7 August 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_583",
    "sender": "Ankita",
    "time": "23:55",
    "date": "2026-08-07",
    "dateLabel": "7 August 2026",
    "text": "Mati koreche 🙃",
    "type": "text"
  },
  {
    "id": "m_584",
    "sender": "Ratnadwip",
    "time": "23:55",
    "date": "2026-08-07",
    "dateLabel": "7 August 2026",
    "text": "😶‍🌫️🙏🏻",
    "type": "text"
  },
  {
    "id": "m_585",
    "sender": "Ratnadwip",
    "time": "17:15",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_586",
    "sender": "Ankita",
    "time": "17:19",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_587",
    "sender": "Ratnadwip",
    "time": "17:19",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "🥗 salad baniye debo",
    "type": "text"
  },
  {
    "id": "m_588",
    "sender": "Ankita",
    "time": "17:20",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "😑😑",
    "type": "text"
  },
  {
    "id": "m_589",
    "sender": "Ankita",
    "time": "17:20",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "Mere debo",
    "type": "text"
  },
  {
    "id": "m_590",
    "sender": "Ankita",
    "time": "17:20",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "Jnis toh",
    "type": "text"
  },
  {
    "id": "m_591",
    "sender": "Ratnadwip",
    "time": "17:20",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "tui toh patagobi. marbi ki kore 😃",
    "type": "text"
  },
  {
    "id": "m_592",
    "sender": "Ankita",
    "time": "17:20",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "Poison hoye",
    "type": "text"
  },
  {
    "id": "m_593",
    "sender": "Ratnadwip",
    "time": "17:20",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_594",
    "sender": "Ankita",
    "time": "17:20",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "😒😒",
    "type": "text"
  },
  {
    "id": "m_595",
    "sender": "Ankita",
    "time": "17:20",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "Buddhiless",
    "type": "text"
  },
  {
    "id": "m_596",
    "sender": "Ratnadwip",
    "time": "17:21",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_597",
    "sender": "Ankita",
    "time": "17:21",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_598",
    "sender": "Ratnadwip",
    "time": "17:21",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "college e naa ele ebar gaar mara jabe",
    "type": "text"
  },
  {
    "id": "m_599",
    "sender": "Ratnadwip",
    "time": "17:21",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "onek rules asche",
    "type": "text"
  },
  {
    "id": "m_600",
    "sender": "Ankita",
    "time": "17:22",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "Kaar? Amr?",
    "type": "text"
  },
  {
    "id": "m_601",
    "sender": "Ratnadwip",
    "time": "17:22",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "sobar",
    "type": "text"
  },
  {
    "id": "m_602",
    "sender": "Ankita",
    "time": "17:22",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "Ami kono rules mni na",
    "type": "text"
  },
  {
    "id": "m_603",
    "sender": "Ratnadwip",
    "time": "17:22",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "naa ele e case",
    "type": "text"
  },
  {
    "id": "m_604",
    "sender": "Ratnadwip",
    "time": "17:22",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "ebar mante hobe unfortunately",
    "type": "text"
  },
  {
    "id": "m_605",
    "sender": "Ankita",
    "time": "17:22",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "Ami toh jaboi naa🙂",
    "type": "text"
  },
  {
    "id": "m_606",
    "sender": "Ankita",
    "time": "17:23",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "My life my rules 💅",
    "type": "text"
  },
  {
    "id": "m_607",
    "sender": "Ratnadwip",
    "time": "17:23",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "exam e issue korbe. makaut er maa ki chut 108 bar",
    "type": "text"
  },
  {
    "id": "m_608",
    "sender": "Ratnadwip",
    "time": "17:23",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "mah life, mah rules",
    "type": "text"
  },
  {
    "id": "m_609",
    "sender": "Ankita",
    "time": "17:23",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "Ishh esob gali dite nei",
    "type": "text"
  },
  {
    "id": "m_610",
    "sender": "Ankita",
    "time": "17:23",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "Yesssss",
    "type": "text"
  },
  {
    "id": "m_611",
    "sender": "Ratnadwip",
    "time": "17:24",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "makaut khub problem korbe dekhis",
    "type": "text"
  },
  {
    "id": "m_612",
    "sender": "Ratnadwip",
    "time": "17:24",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "ar 100 diye enrollment kore nis",
    "type": "text"
  },
  {
    "id": "m_613",
    "sender": "Ratnadwip",
    "time": "17:24",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "asis ar naa asis",
    "type": "text"
  },
  {
    "id": "m_614",
    "sender": "Ankita",
    "time": "17:24",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "Arey ki niye...",
    "type": "text"
  },
  {
    "id": "m_615",
    "sender": "Ankita",
    "time": "17:24",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "Ki bhabey??",
    "type": "text"
  },
  {
    "id": "m_616",
    "sender": "Ratnadwip",
    "time": "17:24",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "exam e boste debe na.",
    "type": "text"
  },
  {
    "id": "m_617",
    "sender": "Ankita",
    "time": "17:24",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "Koto din time?",
    "type": "text"
  },
  {
    "id": "m_618",
    "sender": "Ratnadwip",
    "time": "17:24",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "14 tarik",
    "type": "text"
  },
  {
    "id": "m_619",
    "sender": "Ankita",
    "time": "17:24",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "Clg a giye korbo nki?",
    "type": "text"
  },
  {
    "id": "m_620",
    "sender": "Ankita",
    "time": "17:25",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "Tuesday koto tarik..?",
    "type": "text"
  },
  {
    "id": "m_621",
    "sender": "Ratnadwip",
    "time": "17:25",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "ami nijeo kori ni. but college e 100 payment korte hobe",
    "type": "text"
  },
  {
    "id": "m_622",
    "sender": "Ankita",
    "time": "17:25",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "Acchaa",
    "type": "text"
  },
  {
    "id": "m_623",
    "sender": "Ratnadwip",
    "time": "17:25",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "11",
    "type": "text"
  },
  {
    "id": "m_624",
    "sender": "Ankita",
    "time": "17:25",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "Tuesday dekhi sorir bhlo thakle jbo",
    "type": "text"
  },
  {
    "id": "m_625",
    "sender": "Ankita",
    "time": "17:25",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "Giye korbo",
    "type": "text"
  },
  {
    "id": "m_626",
    "sender": "Ankita",
    "time": "17:26",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "Tui jbi?",
    "type": "text"
  },
  {
    "id": "m_627",
    "sender": "Ratnadwip",
    "time": "17:26",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "ami jabo",
    "type": "text"
  },
  {
    "id": "m_628",
    "sender": "Ratnadwip",
    "time": "17:26",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "naa gele sesh",
    "type": "text"
  },
  {
    "id": "m_629",
    "sender": "Ankita",
    "time": "17:26",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "Then aksathey jbo morte",
    "type": "text"
  },
  {
    "id": "m_630",
    "sender": "Ratnadwip",
    "time": "17:26",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "STK-20260801-WA0015.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260801-WA0015.webp"
  },
  {
    "id": "m_631",
    "sender": "Ankita",
    "time": "17:26",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "Kno??",
    "type": "text"
  },
  {
    "id": "m_632",
    "sender": "Ratnadwip",
    "time": "17:26",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "ei sem attendance khub strict.",
    "type": "text"
  },
  {
    "id": "m_633",
    "sender": "Ratnadwip",
    "time": "17:26",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "clg korbe na, board korche",
    "type": "text"
  },
  {
    "id": "m_634",
    "sender": "Ankita",
    "time": "17:26",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_635",
    "sender": "Ankita",
    "time": "17:27",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "Mati koreche 🙃",
    "type": "text"
  },
  {
    "id": "m_636",
    "sender": "Ratnadwip",
    "time": "17:27",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "koste achi",
    "type": "text"
  },
  {
    "id": "m_637",
    "sender": "Ankita",
    "time": "17:27",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "Amr ki hobe?",
    "type": "text"
  },
  {
    "id": "m_638",
    "sender": "Ratnadwip",
    "time": "17:27",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "eto clg jete bhalo lage na",
    "type": "text"
  },
  {
    "id": "m_639",
    "sender": "Ankita",
    "time": "17:27",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "Amy consider kortei hobe",
    "type": "text"
  },
  {
    "id": "m_640",
    "sender": "Ankita",
    "time": "17:27",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "Setai toh",
    "type": "text"
  },
  {
    "id": "m_641",
    "sender": "Ratnadwip",
    "time": "17:27",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "toke consider korbe kina ke jane",
    "type": "text"
  },
  {
    "id": "m_642",
    "sender": "Ankita",
    "time": "17:27",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "Daily lab dekhchi",
    "type": "text"
  },
  {
    "id": "m_643",
    "sender": "Ratnadwip",
    "time": "17:27",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "haa",
    "type": "text"
  },
  {
    "id": "m_644",
    "sender": "Ratnadwip",
    "time": "17:28",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "Wednesday te nei",
    "type": "text"
  },
  {
    "id": "m_645",
    "sender": "Ankita",
    "time": "17:28",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "Bhoy dekhas na r",
    "type": "text"
  },
  {
    "id": "m_646",
    "sender": "Ankita",
    "time": "17:28",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "Hya ota ki akta diyeche dekhlm",
    "type": "text"
  },
  {
    "id": "m_647",
    "sender": "Ratnadwip",
    "time": "17:28",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "situation is not good. ami roj college jachi",
    "type": "text"
  },
  {
    "id": "m_648",
    "sender": "Ankita",
    "time": "17:28",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "Morbi tuio",
    "type": "text"
  },
  {
    "id": "m_649",
    "sender": "Ankita",
    "time": "17:28",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "Amio",
    "type": "text"
  },
  {
    "id": "m_650",
    "sender": "Ratnadwip",
    "time": "17:28",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_651",
    "sender": "Ankita",
    "time": "17:29",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "Ami legit ai month barite thakte boleche",
    "type": "text"
  },
  {
    "id": "m_652",
    "sender": "Ankita",
    "time": "17:29",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "Doctor",
    "type": "text"
  },
  {
    "id": "m_653",
    "sender": "Ankita",
    "time": "17:29",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "Jbo kmon korey",
    "type": "text"
  },
  {
    "id": "m_654",
    "sender": "Ratnadwip",
    "time": "17:29",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "but eta MAKAUT ke bojhabe...",
    "type": "text"
  },
  {
    "id": "m_655",
    "sender": "Ankita",
    "time": "17:29",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "Aro test diyeche ogulo 15 days por korey check korate hobe",
    "type": "text"
  },
  {
    "id": "m_656",
    "sender": "Ankita",
    "time": "17:29",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_657",
    "sender": "Ratnadwip",
    "time": "17:30",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "guinea pig",
    "type": "text"
  },
  {
    "id": "m_658",
    "sender": "Ankita",
    "time": "17:30",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_659",
    "sender": "Ankita",
    "time": "17:30",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_660",
    "sender": "Ratnadwip",
    "time": "17:30",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "sob attendance erp te hochhe",
    "type": "text"
  },
  {
    "id": "m_661",
    "sender": "Ankita",
    "time": "17:30",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "Erp meaning?",
    "type": "text"
  },
  {
    "id": "m_662",
    "sender": "Ratnadwip",
    "time": "17:30",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "kono 2nombori kaj hobe na",
    "type": "text"
  },
  {
    "id": "m_663",
    "sender": "Ratnadwip",
    "time": "17:30",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "digital",
    "type": "text"
  },
  {
    "id": "m_664",
    "sender": "Ankita",
    "time": "17:31",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "Mati koreche 🙃 🥲😑",
    "type": "text"
  },
  {
    "id": "m_665",
    "sender": "Ratnadwip",
    "time": "17:32",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "IMG-20260808-WA0006.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20260808-WA0006.jpg"
  },
  {
    "id": "m_666",
    "sender": "Ratnadwip",
    "time": "17:32",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "sob digital",
    "type": "text"
  },
  {
    "id": "m_667",
    "sender": "Ankita",
    "time": "17:32",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "Ai re case toh jondis puro",
    "type": "text"
  },
  {
    "id": "m_668",
    "sender": "Ratnadwip",
    "time": "17:33",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "setai toh. scene ache",
    "type": "text"
  },
  {
    "id": "m_669",
    "sender": "Ankita",
    "time": "17:33",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "😑😑",
    "type": "text"
  },
  {
    "id": "m_670",
    "sender": "Ankita",
    "time": "17:33",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "Uff biroktikor",
    "type": "text"
  },
  {
    "id": "m_671",
    "sender": "Ratnadwip",
    "time": "17:34",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_672",
    "sender": "Ankita",
    "time": "17:34",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "Eta amr",
    "type": "text"
  },
  {
    "id": "m_673",
    "sender": "Ankita",
    "time": "17:34",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "Hus husss",
    "type": "text"
  },
  {
    "id": "m_674",
    "sender": "Ratnadwip",
    "time": "17:34",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "na na",
    "type": "text"
  },
  {
    "id": "m_675",
    "sender": "Ankita",
    "time": "17:34",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "Hus huss",
    "type": "text"
  },
  {
    "id": "m_676",
    "sender": "Ratnadwip",
    "time": "17:35",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_677",
    "sender": "Ankita",
    "time": "17:38",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "Abrrrr",
    "type": "text"
  },
  {
    "id": "m_678",
    "sender": "Ankita",
    "time": "17:38",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_679",
    "sender": "Ratnadwip",
    "time": "17:38",
    "date": "2026-08-08",
    "dateLabel": "8 August 2026",
    "text": "😁😁",
    "type": "text"
  },
  {
    "id": "m_680",
    "sender": "Ratnadwip",
    "time": "16:15",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "peak",
    "type": "text"
  },
  {
    "id": "m_681",
    "sender": "Ankita",
    "time": "16:16",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "🙂‍↕️🙂‍↕️",
    "type": "text"
  },
  {
    "id": "m_682",
    "sender": "Ankita",
    "time": "16:16",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "Yes",
    "type": "text"
  },
  {
    "id": "m_683",
    "sender": "Ratnadwip",
    "time": "17:19",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "sponsored by sensodyne & durex",
    "type": "text"
  },
  {
    "id": "m_684",
    "sender": "Ankita",
    "time": "17:19",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "Kihhh😶",
    "type": "text"
  },
  {
    "id": "m_685",
    "sender": "Ratnadwip",
    "time": "17:20",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "STK-20260728-WA0005.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260728-WA0005.webp"
  },
  {
    "id": "m_686",
    "sender": "Ankita",
    "time": "17:20",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "But why durex?\nDil toh?",
    "type": "text"
  },
  {
    "id": "m_687",
    "sender": "Ankita",
    "time": "17:20",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "Matha nosto holey ja hoy r ki",
    "type": "text"
  },
  {
    "id": "m_688",
    "sender": "Ratnadwip",
    "time": "17:20",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "STK-20260809-WA0005.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0005.webp"
  },
  {
    "id": "m_689",
    "sender": "Ankita",
    "time": "17:20",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "STK-20260809-WA0021.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0021.webp"
  },
  {
    "id": "m_690",
    "sender": "Ratnadwip",
    "time": "17:20",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "STK-20260809-WA0021.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0021.webp"
  },
  {
    "id": "m_691",
    "sender": "Ankita",
    "time": "17:21",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "Eta amr",
    "type": "text"
  },
  {
    "id": "m_692",
    "sender": "Ankita",
    "time": "17:21",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "Tui dibi kno?",
    "type": "text"
  },
  {
    "id": "m_693",
    "sender": "Ratnadwip",
    "time": "17:21",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "STK-20260809-WA0022.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0022.webp"
  },
  {
    "id": "m_694",
    "sender": "Ankita",
    "time": "17:21",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "Ai ai ai",
    "type": "text"
  },
  {
    "id": "m_695",
    "sender": "Ankita",
    "time": "17:22",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "Kothay kothay eta kno pathas",
    "type": "text"
  },
  {
    "id": "m_696",
    "sender": "Ankita",
    "time": "17:22",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "Khub maar khbi",
    "type": "text"
  },
  {
    "id": "m_697",
    "sender": "Ratnadwip",
    "time": "17:22",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "😂🤣",
    "type": "text"
  },
  {
    "id": "m_698",
    "sender": "Ankita",
    "time": "17:22",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "Tuesday theke clg jbo confirm...",
    "type": "text"
  },
  {
    "id": "m_699",
    "sender": "Ratnadwip",
    "time": "17:22",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "STK-20260809-WA0023.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0023.webp"
  },
  {
    "id": "m_700",
    "sender": "Ankita",
    "time": "17:22",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "Khub marbo toky drain a fele",
    "type": "text"
  },
  {
    "id": "m_701",
    "sender": "Ratnadwip",
    "time": "17:22",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "STK-20260809-WA0024.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0024.webp"
  },
  {
    "id": "m_702",
    "sender": "Ratnadwip",
    "time": "17:22",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "sotti asbi naki ?",
    "type": "text"
  },
  {
    "id": "m_703",
    "sender": "Ankita",
    "time": "17:22",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "Hya",
    "type": "text"
  },
  {
    "id": "m_704",
    "sender": "Ankita",
    "time": "17:22",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "Jabo",
    "type": "text"
  },
  {
    "id": "m_705",
    "sender": "Ankita",
    "time": "17:23",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "Bari thakle kmon jno lgey",
    "type": "text"
  },
  {
    "id": "m_706",
    "sender": "Ratnadwip",
    "time": "17:23",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "ciggerate er nesha",
    "type": "text"
  },
  {
    "id": "m_707",
    "sender": "Ankita",
    "time": "17:23",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "No",
    "type": "text"
  },
  {
    "id": "m_708",
    "sender": "Ankita",
    "time": "17:23",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "Chere diyechi",
    "type": "text"
  },
  {
    "id": "m_709",
    "sender": "Ankita",
    "time": "17:23",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "Uk that",
    "type": "text"
  },
  {
    "id": "m_710",
    "sender": "Ratnadwip",
    "time": "17:23",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "STK-20260809-WA0021.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0021.webp"
  },
  {
    "id": "m_711",
    "sender": "Ankita",
    "time": "17:23",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "But main kotha hocchey",
    "type": "text"
  },
  {
    "id": "m_712",
    "sender": "Ratnadwip",
    "time": "17:23",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "ki ?",
    "type": "text"
  },
  {
    "id": "m_713",
    "sender": "Ankita",
    "time": "17:24",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "Topobroto cigs khay?",
    "type": "text"
  },
  {
    "id": "m_714",
    "sender": "Ratnadwip",
    "time": "17:24",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "haa",
    "type": "text"
  },
  {
    "id": "m_715",
    "sender": "Ankita",
    "time": "17:24",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "Seriously?",
    "type": "text"
  },
  {
    "id": "m_716",
    "sender": "Ratnadwip",
    "time": "17:24",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "ami o counter marlam",
    "type": "text"
  },
  {
    "id": "m_717",
    "sender": "Ankita",
    "time": "17:24",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "O j bollo cherey diyeche",
    "type": "text"
  },
  {
    "id": "m_718",
    "sender": "Ankita",
    "time": "17:24",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "Mati koreche 🙃",
    "type": "text"
  },
  {
    "id": "m_719",
    "sender": "Ratnadwip",
    "time": "17:24",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "STK-20260809-WA0025.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0025.webp"
  },
  {
    "id": "m_720",
    "sender": "Ankita",
    "time": "17:24",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "Na na tor samneo toh akbar bolechilo bol",
    "type": "text"
  },
  {
    "id": "m_721",
    "sender": "Ankita",
    "time": "17:24",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "🙃",
    "type": "text"
  },
  {
    "id": "m_722",
    "sender": "Ratnadwip",
    "time": "17:25",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "ki ?",
    "type": "text"
  },
  {
    "id": "m_723",
    "sender": "Ankita",
    "time": "17:25",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "J chere diyeche",
    "type": "text"
  },
  {
    "id": "m_724",
    "sender": "Ratnadwip",
    "time": "17:25",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "bole ni toh",
    "type": "text"
  },
  {
    "id": "m_725",
    "sender": "Ankita",
    "time": "17:25",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "🤦🏻‍♀️😒",
    "type": "text"
  },
  {
    "id": "m_726",
    "sender": "Ankita",
    "time": "17:25",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "Bolechilo",
    "type": "text"
  },
  {
    "id": "m_727",
    "sender": "Ankita",
    "time": "17:25",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "Tor mone nei",
    "type": "text"
  },
  {
    "id": "m_728",
    "sender": "Ratnadwip",
    "time": "17:25",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "short term memory loss",
    "type": "text"
  },
  {
    "id": "m_729",
    "sender": "Ankita",
    "time": "17:25",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "Kukur takey lathi marlo ami boka dilm",
    "type": "text"
  },
  {
    "id": "m_730",
    "sender": "Ankita",
    "time": "17:26",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "🤦🏻‍♀️",
    "type": "text"
  },
  {
    "id": "m_731",
    "sender": "Ratnadwip",
    "time": "17:26",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "haa mone poreche",
    "type": "text"
  },
  {
    "id": "m_732",
    "sender": "Ankita",
    "time": "17:26",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "Kakey boli j bhuley jay",
    "type": "text"
  },
  {
    "id": "m_733",
    "sender": "Ratnadwip",
    "time": "17:26",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "amar motoi chere diyeche mone hoi",
    "type": "text"
  },
  {
    "id": "m_734",
    "sender": "Ankita",
    "time": "17:26",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "Bolechilo na?",
    "type": "text"
  },
  {
    "id": "m_735",
    "sender": "Ratnadwip",
    "time": "17:26",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "haa",
    "type": "text"
  },
  {
    "id": "m_736",
    "sender": "Ankita",
    "time": "17:26",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "Tui kobe charli😒🤦🏻‍♀️",
    "type": "text"
  },
  {
    "id": "m_737",
    "sender": "Ratnadwip",
    "time": "17:26",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "o kobe charlo ?",
    "type": "text"
  },
  {
    "id": "m_738",
    "sender": "Ankita",
    "time": "17:27",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "Setai toh suney obak holm",
    "type": "text"
  },
  {
    "id": "m_739",
    "sender": "Ankita",
    "time": "17:27",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "Chaar bad de amder ki",
    "type": "text"
  },
  {
    "id": "m_740",
    "sender": "Ratnadwip",
    "time": "17:27",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "STK-20260809-WA0021.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0021.webp"
  },
  {
    "id": "m_741",
    "sender": "Ankita",
    "time": "17:27",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "STK-20260809-WA0021.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0021.webp"
  },
  {
    "id": "m_742",
    "sender": "Ankita",
    "time": "17:27",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "Amr ta amy diley khun korey dbo kintu",
    "type": "text"
  },
  {
    "id": "m_743",
    "sender": "Ratnadwip",
    "time": "17:27",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "dara ami ekta tomato version banai",
    "type": "text"
  },
  {
    "id": "m_744",
    "sender": "Ratnadwip",
    "time": "17:27",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "STK-20260809-WA0021.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0021.webp"
  },
  {
    "id": "m_745",
    "sender": "Ankita",
    "time": "17:28",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "😒😒😒",
    "type": "text"
  },
  {
    "id": "m_746",
    "sender": "Ankita",
    "time": "17:28",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "STK-20260809-WA0026.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0026.webp"
  },
  {
    "id": "m_747",
    "sender": "Ratnadwip",
    "time": "17:32",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "STK-20260809-WA0027.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0027.webp"
  },
  {
    "id": "m_748",
    "sender": "Ankita",
    "time": "17:32",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "STK-20260809-WA0021.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0021.webp"
  },
  {
    "id": "m_749",
    "sender": "Ankita",
    "time": "17:32",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "Ebar thik acchey",
    "type": "text"
  },
  {
    "id": "m_750",
    "sender": "Ratnadwip",
    "time": "17:32",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "STK-20260809-WA0027.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0027.webp"
  },
  {
    "id": "m_751",
    "sender": "Ankita",
    "time": "17:32",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "STK-20260809-WA0021.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0021.webp"
  },
  {
    "id": "m_752",
    "sender": "Ratnadwip",
    "time": "17:32",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "STK-20260809-WA0027.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0027.webp"
  },
  {
    "id": "m_753",
    "sender": "Ankita",
    "time": "17:32",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "STK-20260809-WA0021.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0021.webp"
  },
  {
    "id": "m_754",
    "sender": "Ratnadwip",
    "time": "17:32",
    "date": "2026-08-09",
    "dateLabel": "9 August 2026",
    "text": "STK-20260809-WA0027.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0027.webp"
  },
  {
    "id": "m_755",
    "sender": "Ratnadwip",
    "time": "23:00",
    "date": "2026-08-10",
    "dateLabel": "10 August 2026",
    "text": "STK-20260809-WA0024.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0024.webp"
  },
  {
    "id": "m_756",
    "sender": "Ankita",
    "time": "23:02",
    "date": "2026-08-10",
    "dateLabel": "10 August 2026",
    "text": "Ki holo abr?",
    "type": "text"
  },
  {
    "id": "m_757",
    "sender": "Ratnadwip",
    "time": "23:02",
    "date": "2026-08-10",
    "dateLabel": "10 August 2026",
    "text": "esob expect koris na",
    "type": "text"
  },
  {
    "id": "m_758",
    "sender": "Ratnadwip",
    "time": "23:02",
    "date": "2026-08-10",
    "dateLabel": "10 August 2026",
    "text": "don't be someone's music",
    "type": "text"
  },
  {
    "id": "m_759",
    "sender": "Ankita",
    "time": "23:02",
    "date": "2026-08-10",
    "dateLabel": "10 August 2026",
    "text": "Thik🤧",
    "type": "text"
  },
  {
    "id": "m_760",
    "sender": "Ankita",
    "time": "23:02",
    "date": "2026-08-10",
    "dateLabel": "10 August 2026",
    "text": "Hmn",
    "type": "text"
  },
  {
    "id": "m_761",
    "sender": "Ratnadwip",
    "time": "23:43",
    "date": "2026-08-10",
    "dateLabel": "10 August 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo"
  },
  {
    "id": "m_762",
    "sender": "Ratnadwip",
    "time": "07:13",
    "date": "2026-08-11",
    "dateLabel": "11 August 2026",
    "text": "aj jachi na 🙂",
    "type": "text"
  },
  {
    "id": "m_763",
    "sender": "Ratnadwip",
    "time": "07:13",
    "date": "2026-08-11",
    "dateLabel": "11 August 2026",
    "text": "kal jabo fs",
    "type": "text"
  },
  {
    "id": "m_764",
    "sender": "Ankita",
    "time": "07:13",
    "date": "2026-08-11",
    "dateLabel": "11 August 2026",
    "text": "Kiser jnno",
    "type": "text"
  },
  {
    "id": "m_765",
    "sender": "Ankita",
    "time": "07:13",
    "date": "2026-08-11",
    "dateLabel": "11 August 2026",
    "text": "STK-20260809-WA0021.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0021.webp"
  },
  {
    "id": "m_766",
    "sender": "Ratnadwip",
    "time": "07:13",
    "date": "2026-08-11",
    "dateLabel": "11 August 2026",
    "text": "bari thakbo",
    "type": "text"
  },
  {
    "id": "m_767",
    "sender": "Ankita",
    "time": "07:13",
    "date": "2026-08-11",
    "dateLabel": "11 August 2026",
    "text": "More ja",
    "type": "text"
  },
  {
    "id": "m_768",
    "sender": "Ankita",
    "time": "07:14",
    "date": "2026-08-11",
    "dateLabel": "11 August 2026",
    "text": "Fs",
    "type": "text"
  },
  {
    "id": "m_769",
    "sender": "Ankita",
    "time": "07:14",
    "date": "2026-08-11",
    "dateLabel": "11 August 2026",
    "text": "Dhop baj",
    "type": "text"
  },
  {
    "id": "m_770",
    "sender": "Ratnadwip",
    "time": "07:14",
    "date": "2026-08-11",
    "dateLabel": "11 August 2026",
    "text": "tui aai aj",
    "type": "text"
  },
  {
    "id": "m_771",
    "sender": "Ratnadwip",
    "time": "07:14",
    "date": "2026-08-11",
    "dateLabel": "11 August 2026",
    "text": "kal theke jabo",
    "type": "text"
  },
  {
    "id": "m_772",
    "sender": "Ratnadwip",
    "time": "07:14",
    "date": "2026-08-11",
    "dateLabel": "11 August 2026",
    "text": "fs",
    "type": "text"
  },
  {
    "id": "m_773",
    "sender": "Ankita",
    "time": "07:14",
    "date": "2026-08-11",
    "dateLabel": "11 August 2026",
    "text": "Ami toh jboi",
    "type": "text"
  },
  {
    "id": "m_774",
    "sender": "Ankita",
    "time": "07:14",
    "date": "2026-08-11",
    "dateLabel": "11 August 2026",
    "text": "🙂‍↕️🙂‍↕️",
    "type": "text"
  },
  {
    "id": "m_775",
    "sender": "Ratnadwip",
    "time": "07:14",
    "date": "2026-08-11",
    "dateLabel": "11 August 2026",
    "text": "jaa. 🫡🫡",
    "type": "text"
  },
  {
    "id": "m_776",
    "sender": "Ratnadwip",
    "time": "07:14",
    "date": "2026-08-11",
    "dateLabel": "11 August 2026",
    "text": "kal theke fs",
    "type": "text"
  },
  {
    "id": "m_777",
    "sender": "Ankita",
    "time": "07:14",
    "date": "2026-08-11",
    "dateLabel": "11 August 2026",
    "text": "STK-20260811-WA0000.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260811-WA0000.webp"
  },
  {
    "id": "m_778",
    "sender": "Ratnadwip",
    "time": "07:14",
    "date": "2026-08-11",
    "dateLabel": "11 August 2026",
    "text": "STK-20260809-WA0027.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0027.webp"
  },
  {
    "id": "m_779",
    "sender": "Ankita",
    "time": "07:14",
    "date": "2026-08-11",
    "dateLabel": "11 August 2026",
    "text": "Ghumo",
    "type": "text"
  },
  {
    "id": "m_780",
    "sender": "Ankita",
    "time": "07:14",
    "date": "2026-08-11",
    "dateLabel": "11 August 2026",
    "text": "Tui",
    "type": "text"
  },
  {
    "id": "m_781",
    "sender": "Ankita",
    "time": "07:14",
    "date": "2026-08-11",
    "dateLabel": "11 August 2026",
    "text": "STK-20260809-WA0021.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0021.webp"
  },
  {
    "id": "m_782",
    "sender": "Ratnadwip",
    "time": "07:15",
    "date": "2026-08-11",
    "dateLabel": "11 August 2026",
    "text": "thankyou",
    "type": "text"
  },
  {
    "id": "m_783",
    "sender": "Ankita",
    "time": "07:15",
    "date": "2026-08-11",
    "dateLabel": "11 August 2026",
    "text": "You're welcome",
    "type": "text"
  },
  {
    "id": "m_784",
    "sender": "Ratnadwip",
    "time": "13:24",
    "date": "2026-08-11",
    "dateLabel": "11 August 2026",
    "text": "Following students are requested to contact the *HOD, CSE* , at the Departmental Faculty Room *positively by today* without fail .\n1. SOUHARDA GIRI\n2. SUMIT KUMAR SINGH\n3. AMIT BHAGAT\n4. ANKITA AICH\n5. ANKIT PRASAD\n6. ABHRA KANTI MAZUMDER\n7. SUBHADIP BAIRAGYA\n8. RINTU DEB\n9. AARIJ AKHTAR\n10. KRISHNA SAHA\n11. AJAY SHAH\n12. TIRTHA GOPAL SAHA\n13. AKSHAT SHARMA\n14. SOUMYAJIT DAS\n15. ARNAVJEET BISWAS\n16. BIDISHA CHAKRABORTY\n17. ARSHAD ALI\n18. SAYANTICA GHOSH\n19. AMIT RAJAK\n20. ANKAN HAZRA\n21. SAYAN SARKAR\n22. SUPRIYO ROY\n23. MAHAK MODAK\n24. SK JASIMUDDIN",
    "type": "text"
  },
  {
    "id": "m_785",
    "sender": "Ratnadwip",
    "time": "13:24",
    "date": "2026-08-11",
    "dateLabel": "11 August 2026",
    "text": "🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨",
    "type": "text"
  },
  {
    "id": "m_786",
    "sender": "Ankita",
    "time": "16:33",
    "date": "2026-08-11",
    "dateLabel": "11 August 2026",
    "text": "Ik ik",
    "type": "text"
  },
  {
    "id": "m_787",
    "sender": "Ankita",
    "time": "16:33",
    "date": "2026-08-11",
    "dateLabel": "11 August 2026",
    "text": "Case hoyeche bolbo",
    "type": "text"
  },
  {
    "id": "m_788",
    "sender": "Ankita",
    "time": "16:33",
    "date": "2026-08-11",
    "dateLabel": "11 August 2026",
    "text": "Tokey",
    "type": "text"
  },
  {
    "id": "m_789",
    "sender": "Ratnadwip",
    "time": "16:34",
    "date": "2026-08-11",
    "dateLabel": "11 August 2026",
    "text": "mati koreche ?",
    "type": "text"
  },
  {
    "id": "m_790",
    "sender": "Ankita",
    "time": "16:34",
    "date": "2026-08-11",
    "dateLabel": "11 August 2026",
    "text": "Yess",
    "type": "text"
  },
  {
    "id": "m_791",
    "sender": "Ankita",
    "time": "16:34",
    "date": "2026-08-11",
    "dateLabel": "11 August 2026",
    "text": "Mainly kichui na pritam biswas sir k ami giye bolchi j sir apni dekechilen",
    "type": "text"
  },
  {
    "id": "m_792",
    "sender": "Ankita",
    "time": "16:35",
    "date": "2026-08-11",
    "dateLabel": "11 August 2026",
    "text": "HOD Sumanta Daw k PB sir er sathey guliye felechi",
    "type": "text"
  },
  {
    "id": "m_793",
    "sender": "Ankita",
    "time": "16:35",
    "date": "2026-08-11",
    "dateLabel": "11 August 2026",
    "text": "PD sir bosey ojhorey hasche",
    "type": "text"
  },
  {
    "id": "m_794",
    "sender": "Ankita",
    "time": "16:35",
    "date": "2026-08-11",
    "dateLabel": "11 August 2026",
    "text": "SD sir o hasche",
    "type": "text"
  },
  {
    "id": "m_795",
    "sender": "Ratnadwip",
    "time": "16:35",
    "date": "2026-08-11",
    "dateLabel": "11 August 2026",
    "text": "ar lok peli na 🙂",
    "type": "text"
  },
  {
    "id": "m_796",
    "sender": "Ankita",
    "time": "16:35",
    "date": "2026-08-11",
    "dateLabel": "11 August 2026",
    "text": "DBS sir bolche j tumi adeo cheno j k hod tmr.??",
    "type": "text"
  },
  {
    "id": "m_797",
    "sender": "Ratnadwip",
    "time": "16:35",
    "date": "2026-08-11",
    "dateLabel": "11 August 2026",
    "text": "😂🤣",
    "type": "text"
  },
  {
    "id": "m_798",
    "sender": "Ankita",
    "time": "16:36",
    "date": "2026-08-11",
    "dateLabel": "11 August 2026",
    "text": "Ami mathay hat diye bolchi sir sorry 😞",
    "type": "text"
  },
  {
    "id": "m_799",
    "sender": "Ankita",
    "time": "16:36",
    "date": "2026-08-11",
    "dateLabel": "11 August 2026",
    "text": "R amio haschi",
    "type": "text"
  },
  {
    "id": "m_800",
    "sender": "Ankita",
    "time": "16:36",
    "date": "2026-08-11",
    "dateLabel": "11 August 2026",
    "text": "🤣🤣🤣",
    "type": "text"
  },
  {
    "id": "m_801",
    "sender": "Ratnadwip",
    "time": "16:36",
    "date": "2026-08-11",
    "dateLabel": "11 August 2026",
    "text": "STK-20260811-WA0004.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260811-WA0004.webp"
  },
  {
    "id": "m_802",
    "sender": "Ankita",
    "time": "16:36",
    "date": "2026-08-11",
    "dateLabel": "11 August 2026",
    "text": "Peak opoman sir er",
    "type": "text"
  },
  {
    "id": "m_803",
    "sender": "Ratnadwip",
    "time": "16:36",
    "date": "2026-08-11",
    "dateLabel": "11 August 2026",
    "text": "STK-20260811-WA0005.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260811-WA0005.webp"
  },
  {
    "id": "m_804",
    "sender": "Ankita",
    "time": "16:36",
    "date": "2026-08-11",
    "dateLabel": "11 August 2026",
    "text": "STK-20260809-WA0021.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0021.webp"
  },
  {
    "id": "m_805",
    "sender": "Ratnadwip",
    "time": "08:29",
    "date": "2026-08-12",
    "dateLabel": "12 August 2026",
    "text": "asbi toh ?",
    "type": "text"
  },
  {
    "id": "m_806",
    "sender": "Ratnadwip",
    "time": "08:29",
    "date": "2026-08-12",
    "dateLabel": "12 August 2026",
    "text": "STK-20260810-WA0012.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260810-WA0012.webp"
  },
  {
    "id": "m_807",
    "sender": "Ankita",
    "time": "08:35",
    "date": "2026-08-12",
    "dateLabel": "12 August 2026",
    "text": "Kno bolbo?",
    "type": "text"
  },
  {
    "id": "m_808",
    "sender": "Ratnadwip",
    "time": "08:36",
    "date": "2026-08-12",
    "dateLabel": "12 August 2026",
    "text": "tui bhalo meye tai",
    "type": "text"
  },
  {
    "id": "m_809",
    "sender": "Ankita",
    "time": "08:36",
    "date": "2026-08-12",
    "dateLabel": "12 August 2026",
    "text": "Tui pocha chele tai jbo na",
    "type": "text"
  },
  {
    "id": "m_810",
    "sender": "Ratnadwip",
    "time": "08:36",
    "date": "2026-08-12",
    "dateLabel": "12 August 2026",
    "text": "STK-20260809-WA0027.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0027.webp"
  },
  {
    "id": "m_811",
    "sender": "Ankita",
    "time": "08:36",
    "date": "2026-08-12",
    "dateLabel": "12 August 2026",
    "text": "STK-20260809-WA0021.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0021.webp"
  },
  {
    "id": "m_812",
    "sender": "Ratnadwip",
    "time": "08:38",
    "date": "2026-08-12",
    "dateLabel": "12 August 2026",
    "text": "STK-20260728-WA0005.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260728-WA0005.webp"
  },
  {
    "id": "m_813",
    "sender": "Ankita",
    "time": "08:38",
    "date": "2026-08-12",
    "dateLabel": "12 August 2026",
    "text": "STK-20260809-WA0021.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0021.webp"
  },
  {
    "id": "m_814",
    "sender": "Ratnadwip",
    "time": "11:00",
    "date": "2026-08-12",
    "dateLabel": "12 August 2026",
    "text": "7th sem e hobe",
    "type": "text"
  },
  {
    "id": "m_815",
    "sender": "Ankita",
    "time": "13:59",
    "date": "2026-08-12",
    "dateLabel": "12 August 2026",
    "text": "IMG-20260812-WA0010.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20260812-WA0010.jpg"
  },
  {
    "id": "m_816",
    "sender": "Ratnadwip",
    "time": "20:47",
    "date": "2026-08-12",
    "dateLabel": "12 August 2026",
    "text": "IMG-20260812-WA0019.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20260812-WA0019.jpg"
  },
  {
    "id": "m_817",
    "sender": "Ratnadwip",
    "time": "20:47",
    "date": "2026-08-12",
    "dateLabel": "12 August 2026",
    "text": "STK-20260809-WA0006.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0006.webp"
  },
  {
    "id": "m_818",
    "sender": "Ankita",
    "time": "20:48",
    "date": "2026-08-12",
    "dateLabel": "12 August 2026",
    "text": "Wahhh",
    "type": "text"
  },
  {
    "id": "m_819",
    "sender": "Ankita",
    "time": "20:48",
    "date": "2026-08-12",
    "dateLabel": "12 August 2026",
    "text": "😋😋",
    "type": "text"
  },
  {
    "id": "m_820",
    "sender": "Ankita",
    "time": "20:48",
    "date": "2026-08-12",
    "dateLabel": "12 August 2026",
    "text": "Sundor",
    "type": "text"
  },
  {
    "id": "m_821",
    "sender": "Ratnadwip",
    "time": "20:48",
    "date": "2026-08-12",
    "dateLabel": "12 August 2026",
    "text": "",
    "type": "text"
  },
  {
    "id": "m_822",
    "sender": "Ratnadwip",
    "time": "20:48",
    "date": "2026-08-12",
    "dateLabel": "12 August 2026",
    "text": "IMG-20260812-WA0016.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20260812-WA0016.jpg"
  },
  {
    "id": "m_823",
    "sender": "Ratnadwip",
    "time": "20:48",
    "date": "2026-08-12",
    "dateLabel": "12 August 2026",
    "text": "IMG-20260812-WA0015.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20260812-WA0015.jpg"
  },
  {
    "id": "m_824",
    "sender": "Ratnadwip",
    "time": "20:48",
    "date": "2026-08-12",
    "dateLabel": "12 August 2026",
    "text": "IMG-20260812-WA0018.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20260812-WA0018.jpg"
  },
  {
    "id": "m_825",
    "sender": "Ratnadwip",
    "time": "20:48",
    "date": "2026-08-12",
    "dateLabel": "12 August 2026",
    "text": "IMG-20260812-WA0017.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20260812-WA0017.jpg"
  },
  {
    "id": "m_826",
    "sender": "Ankita",
    "time": "20:48",
    "date": "2026-08-12",
    "dateLabel": "12 August 2026",
    "text": "Vg",
    "type": "text"
  },
  {
    "id": "m_827",
    "sender": "Ankita",
    "time": "20:48",
    "date": "2026-08-12",
    "dateLabel": "12 August 2026",
    "text": "Matha nosto kora photo",
    "type": "text"
  },
  {
    "id": "m_828",
    "sender": "Ratnadwip",
    "time": "20:48",
    "date": "2026-08-12",
    "dateLabel": "12 August 2026",
    "text": "STK-20260809-WA0024.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0024.webp"
  },
  {
    "id": "m_829",
    "sender": "Ankita",
    "time": "20:49",
    "date": "2026-08-12",
    "dateLabel": "12 August 2026",
    "text": "STK-20260809-WA0021.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0021.webp"
  },
  {
    "id": "m_830",
    "sender": "Ratnadwip",
    "time": "08:09",
    "date": "2026-08-14",
    "dateLabel": "14 August 2026",
    "text": "yoo",
    "type": "text"
  },
  {
    "id": "m_831",
    "sender": "Ratnadwip",
    "time": "08:09",
    "date": "2026-08-14",
    "dateLabel": "14 August 2026",
    "text": "gng",
    "type": "text"
  },
  {
    "id": "m_832",
    "sender": "Ratnadwip",
    "time": "08:09",
    "date": "2026-08-14",
    "dateLabel": "14 August 2026",
    "text": "holo na",
    "type": "text"
  },
  {
    "id": "m_833",
    "sender": "Ratnadwip",
    "time": "10:28",
    "date": "2026-08-14",
    "dateLabel": "14 August 2026",
    "text": "ticket number ta likhte hobe",
    "type": "text"
  },
  {
    "id": "m_834",
    "sender": "Ankita",
    "time": "10:29",
    "date": "2026-08-14",
    "dateLabel": "14 August 2026",
    "text": "Hya tara kiser ato",
    "type": "text"
  },
  {
    "id": "m_835",
    "sender": "Ratnadwip",
    "time": "10:29",
    "date": "2026-08-14",
    "dateLabel": "14 August 2026",
    "text": "bhule jabo",
    "type": "text"
  },
  {
    "id": "m_836",
    "sender": "Ankita",
    "time": "10:29",
    "date": "2026-08-14",
    "dateLabel": "14 August 2026",
    "text": "Na bhulbo na",
    "type": "text"
  },
  {
    "id": "m_837",
    "sender": "Ratnadwip",
    "time": "16:43",
    "date": "2026-08-14",
    "dateLabel": "14 August 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_838",
    "sender": "Ratnadwip",
    "time": "19:18",
    "date": "2026-08-14",
    "dateLabel": "14 August 2026",
    "text": "STK-20260810-WA0012.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260810-WA0012.webp"
  },
  {
    "id": "m_839",
    "sender": "Ankita",
    "time": "22:26",
    "date": "2026-08-14",
    "dateLabel": "14 August 2026",
    "text": "",
    "type": "text"
  },
  {
    "id": "m_840",
    "sender": "Ankita",
    "time": "22:26",
    "date": "2026-08-14",
    "dateLabel": "14 August 2026",
    "text": "Trauma dilm",
    "type": "text"
  },
  {
    "id": "m_841",
    "sender": "Ankita",
    "time": "22:26",
    "date": "2026-08-14",
    "dateLabel": "14 August 2026",
    "text": "Srry",
    "type": "text"
  },
  {
    "id": "m_842",
    "sender": "Ankita",
    "time": "22:27",
    "date": "2026-08-14",
    "dateLabel": "14 August 2026",
    "text": "🙃",
    "type": "text"
  },
  {
    "id": "m_843",
    "sender": "Ratnadwip",
    "time": "22:27",
    "date": "2026-08-14",
    "dateLabel": "14 August 2026",
    "text": "eto onek bhalo",
    "type": "text"
  },
  {
    "id": "m_844",
    "sender": "Ankita",
    "time": "22:27",
    "date": "2026-08-14",
    "dateLabel": "14 August 2026",
    "text": "😶",
    "type": "text"
  },
  {
    "id": "m_845",
    "sender": "Ankita",
    "time": "22:27",
    "date": "2026-08-14",
    "dateLabel": "14 August 2026",
    "text": "STK-20260809-WA0021.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0021.webp"
  },
  {
    "id": "m_846",
    "sender": "Ratnadwip",
    "time": "23:14",
    "date": "2026-08-15",
    "dateLabel": "15 August 2026",
    "text": "Hey, I’ve got a link that gets you 3 months of Spotify Premium for ₹99. Check it out.\nhttps://open.spotify.com/referral/00398878959592a88993042e642616dbfaadf5c3edebd022c73035?si=VWFjVMJwSASxSu3_ya-CSA&utm_source=whatsapp&locale=en&sci=spotify%3Acard-config%3A4l116RjOmOxbyCEvPK7TLO&rv=2",
    "type": "link",
    "linkUrl": "https://open.spotify.com/referral/00398878959592a88993042e642616dbfaadf5c3edebd022c73035?si=VWFjVMJwSASxSu3_ya-CSA&utm_source=whatsapp&locale=en&sci=spotify%3Acard-config%3A4l116RjOmOxbyCEvPK7TLO&rv=2"
  },
  {
    "id": "m_847",
    "sender": "Ratnadwip",
    "time": "23:14",
    "date": "2026-08-15",
    "dateLabel": "15 August 2026",
    "text": "Saswata call korechilo, o amake or business join korte bolche 🙏🏻💀",
    "type": "text"
  },
  {
    "id": "m_848",
    "sender": "Ankita",
    "time": "23:23",
    "date": "2026-08-15",
    "dateLabel": "15 August 2026",
    "text": "Kiser business?",
    "type": "text"
  },
  {
    "id": "m_849",
    "sender": "Ratnadwip",
    "time": "02:54",
    "date": "2026-08-17",
    "dateLabel": "17 August 2026",
    "text": "https://girlgangplustax.745482.xyz/",
    "type": "link",
    "linkUrl": "https://girlgangplustax.745482.xyz/"
  },
  {
    "id": "m_850",
    "sender": "Ratnadwip",
    "time": "00:10",
    "date": "2026-08-18",
    "dateLabel": "18 August 2026",
    "text": "https://spotify.link/bf0wNVXrG5b",
    "type": "link",
    "linkUrl": "https://spotify.link/bf0wNVXrG5b"
  },
  {
    "id": "m_851",
    "sender": "Ankita",
    "time": "00:11",
    "date": "2026-08-18",
    "dateLabel": "18 August 2026",
    "text": "Kii?",
    "type": "text"
  },
  {
    "id": "m_852",
    "sender": "Ratnadwip",
    "time": "00:18",
    "date": "2026-08-18",
    "dateLabel": "18 August 2026",
    "text": "Kal 3rd year ar dada ra college ar ei timing niye principal sir ke janabe tiffin time a but dada der durer chele lagbe jader sotti e problem hocche amader bolle tho hobe na karon amra ka6e thaki so yodi oirokom keu thakis tahole janas",
    "type": "text"
  },
  {
    "id": "m_853",
    "sender": "Ratnadwip",
    "time": "00:04",
    "date": "2026-08-19",
    "dateLabel": "19 August 2026",
    "text": "IMG-20260818-WA0023.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20260818-WA0023.jpg"
  },
  {
    "id": "m_854",
    "sender": "Ratnadwip",
    "time": "00:04",
    "date": "2026-08-19",
    "dateLabel": "19 August 2026",
    "text": "IMG-20260818-WA0024.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20260818-WA0024.jpg"
  },
  {
    "id": "m_855",
    "sender": "Ankita",
    "time": "00:05",
    "date": "2026-08-19",
    "dateLabel": "19 August 2026",
    "text": "Ufff",
    "type": "text"
  },
  {
    "id": "m_856",
    "sender": "Ankita",
    "time": "00:05",
    "date": "2026-08-19",
    "dateLabel": "19 August 2026",
    "text": "Sera set up",
    "type": "text"
  },
  {
    "id": "m_857",
    "sender": "Ankita",
    "time": "00:05",
    "date": "2026-08-19",
    "dateLabel": "19 August 2026",
    "text": "😋😋",
    "type": "text"
  },
  {
    "id": "m_858",
    "sender": "Ankita",
    "time": "00:05",
    "date": "2026-08-19",
    "dateLabel": "19 August 2026",
    "text": "Churi kore nbo",
    "type": "text"
  },
  {
    "id": "m_859",
    "sender": "Ankita",
    "time": "11:47",
    "date": "2026-08-19",
    "dateLabel": "19 August 2026",
    "text": "IMG-20260819-WA0001.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20260819-WA0001.jpg"
  },
  {
    "id": "m_860",
    "sender": "Ankita",
    "time": "11:47",
    "date": "2026-08-19",
    "dateLabel": "19 August 2026",
    "text": "Aa korbi?",
    "type": "text"
  },
  {
    "id": "m_861",
    "sender": "Ankita",
    "time": "11:47",
    "date": "2026-08-19",
    "dateLabel": "19 August 2026",
    "text": "IMG-20260819-WA0002.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20260819-WA0002.jpg"
  },
  {
    "id": "m_862",
    "sender": "Ratnadwip",
    "time": "13:04",
    "date": "2026-08-19",
    "dateLabel": "19 August 2026",
    "text": "baad diye debe amake",
    "type": "text"
  },
  {
    "id": "m_863",
    "sender": "Ratnadwip",
    "time": "13:04",
    "date": "2026-08-19",
    "dateLabel": "19 August 2026",
    "text": "bekar kore labh nei",
    "type": "text"
  },
  {
    "id": "m_864",
    "sender": "Ratnadwip",
    "time": "13:04",
    "date": "2026-08-19",
    "dateLabel": "19 August 2026",
    "text": "😂",
    "type": "text"
  },
  {
    "id": "m_865",
    "sender": "Ratnadwip",
    "time": "22:55",
    "date": "2026-08-19",
    "dateLabel": "19 August 2026",
    "text": "😮",
    "type": "text"
  },
  {
    "id": "m_866",
    "sender": "Ankita",
    "time": "22:55",
    "date": "2026-08-19",
    "dateLabel": "19 August 2026",
    "text": "Hebi na?",
    "type": "text"
  },
  {
    "id": "m_867",
    "sender": "Ratnadwip",
    "time": "22:55",
    "date": "2026-08-19",
    "dateLabel": "19 August 2026",
    "text": "yes",
    "type": "text"
  },
  {
    "id": "m_868",
    "sender": "Ratnadwip",
    "time": "17:40",
    "date": "2026-08-20",
    "dateLabel": "20 August 2026",
    "text": "😂",
    "type": "text"
  },
  {
    "id": "m_869",
    "sender": "Ratnadwip",
    "time": "21:35",
    "date": "2026-08-22",
    "dateLabel": "22 August 2026",
    "text": "tor email de",
    "type": "text"
  },
  {
    "id": "m_870",
    "sender": "Ratnadwip",
    "time": "21:35",
    "date": "2026-08-22",
    "dateLabel": "22 August 2026",
    "text": "sih er jonno",
    "type": "text"
  },
  {
    "id": "m_871",
    "sender": "Ratnadwip",
    "time": "21:35",
    "date": "2026-08-22",
    "dateLabel": "22 August 2026",
    "text": "ar ph no ei no tai diye debo",
    "type": "text"
  },
  {
    "id": "m_872",
    "sender": "Ratnadwip",
    "time": "23:54",
    "date": "2026-08-22",
    "dateLabel": "22 August 2026",
    "text": "er mane ki ?",
    "type": "text"
  },
  {
    "id": "m_873",
    "sender": "Ratnadwip",
    "time": "23:54",
    "date": "2026-08-22",
    "dateLabel": "22 August 2026",
    "text": "jodi bole buddhi nei, matha khule dekhabe ?",
    "type": "text"
  },
  {
    "id": "m_874",
    "sender": "Ankita",
    "time": "23:54",
    "date": "2026-08-22",
    "dateLabel": "22 August 2026",
    "text": "😑😑",
    "type": "text"
  },
  {
    "id": "m_875",
    "sender": "Ankita",
    "time": "23:55",
    "date": "2026-08-22",
    "dateLabel": "22 August 2026",
    "text": "Literally tor mathay buddhi nei tai amon question korli",
    "type": "text"
  },
  {
    "id": "m_876",
    "sender": "Ratnadwip",
    "time": "23:56",
    "date": "2026-08-22",
    "dateLabel": "22 August 2026",
    "text": "STK-20260809-WA0025.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0025.webp"
  },
  {
    "id": "m_877",
    "sender": "Ankita",
    "time": "23:56",
    "date": "2026-08-22",
    "dateLabel": "22 August 2026",
    "text": "STK-20260814-WA0029.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260814-WA0029.webp"
  },
  {
    "id": "m_878",
    "sender": "Ratnadwip",
    "time": "00:00",
    "date": "2026-08-23",
    "dateLabel": "23 August 2026",
    "text": "IMG-20260823-WA0000.jpg (file attached)\ntui",
    "type": "image",
    "mediaName": "IMG-20260823-WA0000.jpg"
  },
  {
    "id": "m_879",
    "sender": "Ankita",
    "time": "00:00",
    "date": "2026-08-23",
    "dateLabel": "23 August 2026",
    "text": "😒😒",
    "type": "text"
  },
  {
    "id": "m_880",
    "sender": "Ankita",
    "time": "00:00",
    "date": "2026-08-23",
    "dateLabel": "23 August 2026",
    "text": "Erm bolli toh amy??",
    "type": "text"
  },
  {
    "id": "m_881",
    "sender": "Ratnadwip",
    "time": "00:00",
    "date": "2026-08-23",
    "dateLabel": "23 August 2026",
    "text": "kharap ki bollam",
    "type": "text"
  },
  {
    "id": "m_882",
    "sender": "Ratnadwip",
    "time": "00:01",
    "date": "2026-08-23",
    "dateLabel": "23 August 2026",
    "text": "STK-20260809-WA0025.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0025.webp"
  },
  {
    "id": "m_883",
    "sender": "Ankita",
    "time": "00:01",
    "date": "2026-08-23",
    "dateLabel": "23 August 2026",
    "text": "😒indirectly mota bolli",
    "type": "text"
  },
  {
    "id": "m_884",
    "sender": "Ankita",
    "time": "00:01",
    "date": "2026-08-23",
    "dateLabel": "23 August 2026",
    "text": "Natok kom kor",
    "type": "text"
  },
  {
    "id": "m_885",
    "sender": "Ankita",
    "time": "00:01",
    "date": "2026-08-23",
    "dateLabel": "23 August 2026",
    "text": "Sob bujhi",
    "type": "text"
  },
  {
    "id": "m_886",
    "sender": "Ratnadwip",
    "time": "00:01",
    "date": "2026-08-23",
    "dateLabel": "23 August 2026",
    "text": "samna samni aai directly bole debo 👍🏻",
    "type": "text"
  },
  {
    "id": "m_887",
    "sender": "Ratnadwip",
    "time": "00:01",
    "date": "2026-08-23",
    "dateLabel": "23 August 2026",
    "text": "no issue",
    "type": "text"
  },
  {
    "id": "m_888",
    "sender": "Ankita",
    "time": "00:01",
    "date": "2026-08-23",
    "dateLabel": "23 August 2026",
    "text": "😶😔",
    "type": "text"
  },
  {
    "id": "m_889",
    "sender": "Ankita",
    "time": "00:01",
    "date": "2026-08-23",
    "dateLabel": "23 August 2026",
    "text": "Ok",
    "type": "text"
  },
  {
    "id": "m_890",
    "sender": "Ratnadwip",
    "time": "00:02",
    "date": "2026-08-23",
    "dateLabel": "23 August 2026",
    "text": "masala momo 😋",
    "type": "text"
  },
  {
    "id": "m_891",
    "sender": "Ankita",
    "time": "00:02",
    "date": "2026-08-23",
    "dateLabel": "23 August 2026",
    "text": "😒",
    "type": "text"
  },
  {
    "id": "m_892",
    "sender": "Ratnadwip",
    "time": "00:02",
    "date": "2026-08-23",
    "dateLabel": "23 August 2026",
    "text": "na na",
    "type": "text"
  },
  {
    "id": "m_893",
    "sender": "Ratnadwip",
    "time": "00:02",
    "date": "2026-08-23",
    "dateLabel": "23 August 2026",
    "text": "muscle mommy",
    "type": "text"
  },
  {
    "id": "m_894",
    "sender": "Ratnadwip",
    "time": "00:02",
    "date": "2026-08-23",
    "dateLabel": "23 August 2026",
    "text": "minor spelling mistake",
    "type": "text"
  },
  {
    "id": "m_895",
    "sender": "Ankita",
    "time": "00:02",
    "date": "2026-08-23",
    "dateLabel": "23 August 2026",
    "text": "Kothai bolbo na jaa",
    "type": "text"
  },
  {
    "id": "m_896",
    "sender": "Ratnadwip",
    "time": "00:02",
    "date": "2026-08-23",
    "dateLabel": "23 August 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_897",
    "sender": "Ratnadwip",
    "time": "00:02",
    "date": "2026-08-23",
    "dateLabel": "23 August 2026",
    "text": "STK-20260809-WA0021.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0021.webp"
  },
  {
    "id": "m_898",
    "sender": "Ankita",
    "time": "00:03",
    "date": "2026-08-23",
    "dateLabel": "23 August 2026",
    "text": "STK-20260809-WA0021.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0021.webp"
  },
  {
    "id": "m_899",
    "sender": "Ratnadwip",
    "time": "00:03",
    "date": "2026-08-23",
    "dateLabel": "23 August 2026",
    "text": "STK-20260809-WA0021.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0021.webp"
  },
  {
    "id": "m_900",
    "sender": "Ankita",
    "time": "00:03",
    "date": "2026-08-23",
    "dateLabel": "23 August 2026",
    "text": "STK-20260809-WA0021.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0021.webp"
  },
  {
    "id": "m_901",
    "sender": "Ratnadwip",
    "time": "00:03",
    "date": "2026-08-23",
    "dateLabel": "23 August 2026",
    "text": "STK-20260809-WA0027.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0027.webp"
  },
  {
    "id": "m_902",
    "sender": "Ratnadwip",
    "time": "20:31",
    "date": "2026-08-26",
    "dateLabel": "26 August 2026",
    "text": "jinda lash",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_903",
    "sender": "Ankita",
    "time": "20:43",
    "date": "2026-08-26",
    "dateLabel": "26 August 2026",
    "text": "Hyaa😆🤦🏻‍♀️",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_904",
    "sender": "Ratnadwip",
    "time": "21:23",
    "date": "2026-08-26",
    "dateLabel": "26 August 2026",
    "text": "STK-20260820-WA0003.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260820-WA0003.webp",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_905",
    "sender": "Ratnadwip",
    "time": "04:13",
    "date": "2026-08-27",
    "dateLabel": "27 August 2026",
    "text": "😂",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_906",
    "sender": "Ankita",
    "time": "10:11",
    "date": "2026-08-27",
    "dateLabel": "27 August 2026",
    "text": "Sob cls korbi?",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_907",
    "sender": "Ratnadwip",
    "time": "10:13",
    "date": "2026-08-27",
    "dateLabel": "27 August 2026",
    "text": "haa, tui o korbi",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_908",
    "sender": "Ratnadwip",
    "time": "10:13",
    "date": "2026-08-27",
    "dateLabel": "27 August 2026",
    "text": "attendance lagbe",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_909",
    "sender": "Ratnadwip",
    "time": "10:13",
    "date": "2026-08-27",
    "dateLabel": "27 August 2026",
    "text": "12:30 ta te auditorium jabo.",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_910",
    "sender": "Ankita",
    "time": "10:13",
    "date": "2026-08-27",
    "dateLabel": "27 August 2026",
    "text": "Lagbe na",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_911",
    "sender": "Ratnadwip",
    "time": "10:13",
    "date": "2026-08-27",
    "dateLabel": "27 August 2026",
    "text": "jete bollo",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_912",
    "sender": "Ankita",
    "time": "10:13",
    "date": "2026-08-27",
    "dateLabel": "27 August 2026",
    "text": "Ki korete?",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_913",
    "sender": "Ankita",
    "time": "10:13",
    "date": "2026-08-27",
    "dateLabel": "27 August 2026",
    "text": "K?",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_914",
    "sender": "Ratnadwip",
    "time": "10:13",
    "date": "2026-08-27",
    "dateLabel": "27 August 2026",
    "text": "STK-20260820-WA0003.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260820-WA0003.webp",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_915",
    "sender": "Ankita",
    "time": "10:13",
    "date": "2026-08-27",
    "dateLabel": "27 August 2026",
    "text": "🫩",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_916",
    "sender": "Ratnadwip",
    "time": "10:14",
    "date": "2026-08-27",
    "dateLabel": "27 August 2026",
    "text": "gaan korbe tar jonno",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_917",
    "sender": "Ratnadwip",
    "time": "10:14",
    "date": "2026-08-27",
    "dateLabel": "27 August 2026",
    "text": "naam jani na",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_918",
    "sender": "Ankita",
    "time": "10:14",
    "date": "2026-08-27",
    "dateLabel": "27 August 2026",
    "text": "😑k?",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_919",
    "sender": "Ankita",
    "time": "10:14",
    "date": "2026-08-27",
    "dateLabel": "27 August 2026",
    "text": "Huss",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_920",
    "sender": "Ankita",
    "time": "10:14",
    "date": "2026-08-27",
    "dateLabel": "27 August 2026",
    "text": "Amio jbo",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_921",
    "sender": "Ratnadwip",
    "time": "10:14",
    "date": "2026-08-27",
    "dateLabel": "27 August 2026",
    "text": "sneha thakbe 😋😋",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_922",
    "sender": "Ankita",
    "time": "10:14",
    "date": "2026-08-27",
    "dateLabel": "27 August 2026",
    "text": "Bhlo lgche na",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_923",
    "sender": "Ratnadwip",
    "time": "10:14",
    "date": "2026-08-27",
    "dateLabel": "27 August 2026",
    "text": "ok",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_924",
    "sender": "Ankita",
    "time": "10:14",
    "date": "2026-08-27",
    "dateLabel": "27 August 2026",
    "text": "😒😑😑🫩",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_925",
    "sender": "Ankita",
    "time": "10:14",
    "date": "2026-08-27",
    "dateLabel": "27 August 2026",
    "text": "Keu ase ni bang",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_926",
    "sender": "Ratnadwip",
    "time": "10:14",
    "date": "2026-08-27",
    "dateLabel": "27 August 2026",
    "text": "STK-20260810-WA0007.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260810-WA0007.webp",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_927",
    "sender": "Ankita",
    "time": "10:14",
    "date": "2026-08-27",
    "dateLabel": "27 August 2026",
    "text": "More jaa",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_928",
    "sender": "Ratnadwip",
    "time": "10:15",
    "date": "2026-08-27",
    "dateLabel": "27 August 2026",
    "text": "STK-20260809-WA0025.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0025.webp",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_929",
    "sender": "Ankita",
    "time": "10:16",
    "date": "2026-08-27",
    "dateLabel": "27 August 2026",
    "text": "STK-20260809-WA0021.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0021.webp",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_930",
    "sender": "Ankita",
    "time": "10:16",
    "date": "2026-08-27",
    "dateLabel": "27 August 2026",
    "text": "STK-20260827-WA0007.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260827-WA0007.webp",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_931",
    "sender": "Ratnadwip",
    "time": "10:16",
    "date": "2026-08-27",
    "dateLabel": "27 August 2026",
    "text": "STK-20260809-WA0027.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0027.webp",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_932",
    "sender": "Ratnadwip",
    "time": "14:02",
    "date": "2026-08-27",
    "dateLabel": "27 August 2026",
    "text": "STK-20260824-WA0003.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260824-WA0003.webp",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_933",
    "sender": "Ratnadwip",
    "time": "23:44",
    "date": "2026-08-28",
    "dateLabel": "28 August 2026",
    "text": "hobe naaaa 🤣🤣🤣🤣🤣🤣",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_934",
    "sender": "Ankita",
    "time": "23:47",
    "date": "2026-08-28",
    "dateLabel": "28 August 2026",
    "text": "Acchaa",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_935",
    "sender": "Ratnadwip",
    "time": "23:47",
    "date": "2026-08-28",
    "dateLabel": "28 August 2026",
    "text": "STK-20260728-WA0005.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260728-WA0005.webp",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_936",
    "sender": "Ankita",
    "time": "23:47",
    "date": "2026-08-28",
    "dateLabel": "28 August 2026",
    "text": "Hm",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_937",
    "sender": "Ratnadwip",
    "time": "23:47",
    "date": "2026-08-28",
    "dateLabel": "28 August 2026",
    "text": "junior ta msg korche",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_938",
    "sender": "Ankita",
    "time": "23:47",
    "date": "2026-08-28",
    "dateLabel": "28 August 2026",
    "text": "Reply de",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_939",
    "sender": "Ratnadwip",
    "time": "23:47",
    "date": "2026-08-28",
    "dateLabel": "28 August 2026",
    "text": "annewsa",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_940",
    "sender": "Ratnadwip",
    "time": "23:47",
    "date": "2026-08-28",
    "dateLabel": "28 August 2026",
    "text": "STK-20260728-WA0005.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260728-WA0005.webp",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_941",
    "sender": "Ankita",
    "time": "23:47",
    "date": "2026-08-28",
    "dateLabel": "28 August 2026",
    "text": "Hm reply kor",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_942",
    "sender": "Ratnadwip",
    "time": "23:47",
    "date": "2026-08-28",
    "dateLabel": "28 August 2026",
    "text": "STK-20260820-WA0003.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260820-WA0003.webp",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_943",
    "sender": "Ankita",
    "time": "23:47",
    "date": "2026-08-28",
    "dateLabel": "28 August 2026",
    "text": "STK-20260828-WA0021.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260828-WA0021.webp",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_944",
    "sender": "Ratnadwip",
    "time": "05:41",
    "date": "2026-08-29",
    "dateLabel": "29 August 2026",
    "text": "actual goodnight",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_945",
    "sender": "Ratnadwip",
    "time": "05:41",
    "date": "2026-08-29",
    "dateLabel": "29 August 2026",
    "text": "kal sokal e dekha hochhe 😎",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_946",
    "sender": "Ratnadwip",
    "time": "05:41",
    "date": "2026-08-29",
    "dateLabel": "29 August 2026",
    "text": "STK-20260809-WA0012.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0012.webp",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_947",
    "sender": "Ratnadwip",
    "time": "05:42",
    "date": "2026-08-29",
    "dateLabel": "29 August 2026",
    "text": "ei sticker tar moto feel hochhe",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_948",
    "sender": "Ankita",
    "time": "07:19",
    "date": "2026-08-29",
    "dateLabel": "29 August 2026",
    "text": "Feeling depressed 😔",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_949",
    "sender": "Ankita",
    "time": "07:19",
    "date": "2026-08-29",
    "dateLabel": "29 August 2026",
    "text": "STK-20260809-WA0021.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0021.webp",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_950",
    "sender": "Ratnadwip",
    "time": "07:29",
    "date": "2026-08-29",
    "dateLabel": "29 August 2026",
    "text": "STK-20260809-WA0027.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0027.webp",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_951",
    "sender": "Ankita",
    "time": "09:01",
    "date": "2026-08-29",
    "dateLabel": "29 August 2026",
    "text": "",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_952",
    "sender": "Ratnadwip",
    "time": "09:51",
    "date": "2026-08-29",
    "dateLabel": "29 August 2026",
    "text": "eli na ?",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_953",
    "sender": "Ratnadwip",
    "time": "09:51",
    "date": "2026-08-29",
    "dateLabel": "29 August 2026",
    "text": "kojon esche ?",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_954",
    "sender": "Ratnadwip",
    "time": "12:54",
    "date": "2026-08-29",
    "dateLabel": "29 August 2026",
    "text": "thankyou from my side also",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_955",
    "sender": "Ratnadwip",
    "time": "12:54",
    "date": "2026-08-29",
    "dateLabel": "29 August 2026",
    "text": "apna time aayega",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_956",
    "sender": "Ratnadwip",
    "time": "16:15",
    "date": "2026-08-29",
    "dateLabel": "29 August 2026",
    "text": "ki baje lagche 🥲🥲",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_957",
    "sender": "Ankita",
    "time": "16:17",
    "date": "2026-08-29",
    "dateLabel": "29 August 2026",
    "text": "Mail ashlo kiser..",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_958",
    "sender": "Ratnadwip",
    "time": "16:17",
    "date": "2026-08-29",
    "dateLabel": "29 August 2026",
    "text": "sponsor form",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_959",
    "sender": "Ankita",
    "time": "16:17",
    "date": "2026-08-29",
    "dateLabel": "29 August 2026",
    "text": "Hya korbo toh?",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_960",
    "sender": "Ratnadwip",
    "time": "16:17",
    "date": "2026-08-29",
    "dateLabel": "29 August 2026",
    "text": "sondhe bela korbo",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_961",
    "sender": "Ankita",
    "time": "16:17",
    "date": "2026-08-29",
    "dateLabel": "29 August 2026",
    "text": "Ok 👍",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_962",
    "sender": "Ankita",
    "time": "17:47",
    "date": "2026-08-29",
    "dateLabel": "29 August 2026",
    "text": "😂",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_963",
    "sender": "Ratnadwip",
    "time": "19:54",
    "date": "2026-08-29",
    "dateLabel": "29 August 2026",
    "text": "😎😎",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_964",
    "sender": "Ratnadwip",
    "time": "19:58",
    "date": "2026-08-29",
    "dateLabel": "29 August 2026",
    "text": "😂",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_965",
    "sender": "Ankita",
    "time": "22:30",
    "date": "2026-08-29",
    "dateLabel": "29 August 2026",
    "text": "😂",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_966",
    "sender": "Ratnadwip",
    "time": "22:44",
    "date": "2026-08-29",
    "dateLabel": "29 August 2026",
    "text": "haschis keno?",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_967",
    "sender": "Ankita",
    "time": "22:45",
    "date": "2026-08-29",
    "dateLabel": "29 August 2026",
    "text": "Tokey dekhe",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_968",
    "sender": "Ratnadwip",
    "time": "22:45",
    "date": "2026-08-29",
    "dateLabel": "29 August 2026",
    "text": "STK-20260809-WA0008.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0008.webp",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_969",
    "sender": "Ankita",
    "time": "22:46",
    "date": "2026-08-29",
    "dateLabel": "29 August 2026",
    "text": "STK-20260827-WA0007.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260827-WA0007.webp",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_970",
    "sender": "Ratnadwip",
    "time": "22:46",
    "date": "2026-08-29",
    "dateLabel": "29 August 2026",
    "text": "thankyou from my side.",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_971",
    "sender": "Ankita",
    "time": "22:46",
    "date": "2026-08-29",
    "dateLabel": "29 August 2026",
    "text": "Acchaa🤣🤦🏻‍♀️",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_972",
    "sender": "Ankita",
    "time": "22:46",
    "date": "2026-08-29",
    "dateLabel": "29 August 2026",
    "text": "Kal keo kintu birthday amader",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_973",
    "sender": "Ankita",
    "time": "22:46",
    "date": "2026-08-29",
    "dateLabel": "29 August 2026",
    "text": "😶‍🌫️😶‍🌫️",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_974",
    "sender": "Ratnadwip",
    "time": "22:46",
    "date": "2026-08-29",
    "dateLabel": "29 August 2026",
    "text": "STK-20260728-WA0005.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260728-WA0005.webp",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_975",
    "sender": "Ankita",
    "time": "22:46",
    "date": "2026-08-29",
    "dateLabel": "29 August 2026",
    "text": "STK-20260829-WA0040.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260829-WA0040.webp",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_976",
    "sender": "Ratnadwip",
    "time": "22:47",
    "date": "2026-08-29",
    "dateLabel": "29 August 2026",
    "text": "ki bhabe?",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_977",
    "sender": "Ankita",
    "time": "22:47",
    "date": "2026-08-29",
    "dateLabel": "29 August 2026",
    "text": "Arey bengali motey",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_978",
    "sender": "Ankita",
    "time": "22:47",
    "date": "2026-08-29",
    "dateLabel": "29 August 2026",
    "text": "😋😋",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_979",
    "sender": "Ratnadwip",
    "time": "22:47",
    "date": "2026-08-29",
    "dateLabel": "29 August 2026",
    "text": "😋😋😋",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_980",
    "sender": "Ankita",
    "time": "22:47",
    "date": "2026-08-29",
    "dateLabel": "29 August 2026",
    "text": "Moj karenge",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_981",
    "sender": "Ratnadwip",
    "time": "22:48",
    "date": "2026-08-29",
    "dateLabel": "29 August 2026",
    "text": "STK-20260728-WA0005.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260728-WA0005.webp",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_982",
    "sender": "Ankita",
    "time": "22:48",
    "date": "2026-08-29",
    "dateLabel": "29 August 2026",
    "text": "Ai ami kintu devcon kore diyechi",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_983",
    "sender": "Ankita",
    "time": "22:48",
    "date": "2026-08-29",
    "dateLabel": "29 August 2026",
    "text": "Submit korar por kono mail ase ni",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_984",
    "sender": "Ratnadwip",
    "time": "22:48",
    "date": "2026-08-29",
    "dateLabel": "29 August 2026",
    "text": "aap Mumbao aa rahe ho",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_985",
    "sender": "Ankita",
    "time": "22:48",
    "date": "2026-08-29",
    "dateLabel": "29 August 2026",
    "text": "🤦🏻‍♀️",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_986",
    "sender": "Ratnadwip",
    "time": "22:48",
    "date": "2026-08-29",
    "dateLabel": "29 August 2026",
    "text": "ko din time de",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_987",
    "sender": "Ankita",
    "time": "22:48",
    "date": "2026-08-29",
    "dateLabel": "29 August 2026",
    "text": "Dara toh",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_988",
    "sender": "Ankita",
    "time": "22:48",
    "date": "2026-08-29",
    "dateLabel": "29 August 2026",
    "text": "Accha",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_989",
    "sender": "Ankita",
    "time": "22:48",
    "date": "2026-08-29",
    "dateLabel": "29 August 2026",
    "text": "Point hocchey j",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_990",
    "sender": "Ankita",
    "time": "22:48",
    "date": "2026-08-29",
    "dateLabel": "29 August 2026",
    "text": "Amr Hacknex ta korini ajk",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_991",
    "sender": "Ankita",
    "time": "22:49",
    "date": "2026-08-29",
    "dateLabel": "29 August 2026",
    "text": "Koto ki dekhalo",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_992",
    "sender": "Ratnadwip",
    "time": "22:49",
    "date": "2026-08-29",
    "dateLabel": "29 August 2026",
    "text": "pore koris",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_993",
    "sender": "Ratnadwip",
    "time": "22:49",
    "date": "2026-08-29",
    "dateLabel": "29 August 2026",
    "text": "amio korini",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_994",
    "sender": "Ankita",
    "time": "22:49",
    "date": "2026-08-29",
    "dateLabel": "29 August 2026",
    "text": "Hmn",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_995",
    "sender": "Ankita",
    "time": "22:49",
    "date": "2026-08-29",
    "dateLabel": "29 August 2026",
    "text": "Bolbi toh pgl",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_996",
    "sender": "Ankita",
    "time": "22:49",
    "date": "2026-08-29",
    "dateLabel": "29 August 2026",
    "text": "🤦🏻‍♀️😶‍🌫️",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_997",
    "sender": "Ratnadwip",
    "time": "22:49",
    "date": "2026-08-29",
    "dateLabel": "29 August 2026",
    "text": "STK-20260809-WA0025.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0025.webp",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_998",
    "sender": "Ankita",
    "time": "22:49",
    "date": "2026-08-29",
    "dateLabel": "29 August 2026",
    "text": "Korbi jokhon bolbi amy",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_999",
    "sender": "Ankita",
    "time": "22:49",
    "date": "2026-08-29",
    "dateLabel": "29 August 2026",
    "text": "🫩🫩",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_1000",
    "sender": "Ratnadwip",
    "time": "22:49",
    "date": "2026-08-29",
    "dateLabel": "29 August 2026",
    "text": "okok",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_1001",
    "sender": "Ankita",
    "time": "22:50",
    "date": "2026-08-29",
    "dateLabel": "29 August 2026",
    "text": "Ludo khel",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_1002",
    "sender": "Ankita",
    "time": "22:50",
    "date": "2026-08-29",
    "dateLabel": "29 August 2026",
    "text": "😶‍🌫️😋",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_1003",
    "sender": "Ratnadwip",
    "time": "22:50",
    "date": "2026-08-29",
    "dateLabel": "29 August 2026",
    "text": "STK-20260820-WA0003.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260820-WA0003.webp",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_1004",
    "sender": "Ratnadwip",
    "time": "10:44",
    "date": "2026-08-30",
    "dateLabel": "30 August 2026",
    "text": "😂",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_1005",
    "sender": "Ratnadwip",
    "time": "16:30",
    "date": "2026-08-30",
    "dateLabel": "30 August 2026",
    "text": "IMG-20260830-WA0007.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20260830-WA0007.jpg",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_1006",
    "sender": "Ankita",
    "time": "16:37",
    "date": "2026-08-30",
    "dateLabel": "30 August 2026",
    "text": "Jani re",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_1007",
    "sender": "Ankita",
    "time": "16:37",
    "date": "2026-08-30",
    "dateLabel": "30 August 2026",
    "text": "Bad de j boleche se bhlo manus byass otai",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_1008",
    "sender": "Ratnadwip",
    "time": "16:37",
    "date": "2026-08-30",
    "dateLabel": "30 August 2026",
    "text": "STK-20260809-WA0012.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0012.webp",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_1009",
    "sender": "Ankita",
    "time": "16:37",
    "date": "2026-08-30",
    "dateLabel": "30 August 2026",
    "text": "STK-20260830-WA0008.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260830-WA0008.webp",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_1010",
    "sender": "Ankita",
    "time": "16:38",
    "date": "2026-08-30",
    "dateLabel": "30 August 2026",
    "text": "J likheche takey ami bolechilam j chatgpt ?",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_1011",
    "sender": "Ankita",
    "time": "16:38",
    "date": "2026-08-30",
    "dateLabel": "30 August 2026",
    "text": "Se bollo na Aligpt",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_1012",
    "sender": "Ratnadwip",
    "time": "16:40",
    "date": "2026-08-30",
    "dateLabel": "30 August 2026",
    "text": "STK-20260830-WA0010.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260830-WA0010.webp",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_1013",
    "sender": "Ratnadwip",
    "time": "17:33",
    "date": "2026-08-30",
    "dateLabel": "30 August 2026",
    "text": "STK-20260830-WA0010.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260830-WA0010.webp",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_1014",
    "sender": "Ankita",
    "time": "17:34",
    "date": "2026-08-30",
    "dateLabel": "30 August 2026",
    "text": "STK-20260830-WA0011.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260830-WA0011.webp",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_1015",
    "sender": "Ratnadwip",
    "time": "17:34",
    "date": "2026-08-30",
    "dateLabel": "30 August 2026",
    "text": "nili na amake",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_1016",
    "sender": "Ankita",
    "time": "17:35",
    "date": "2026-08-30",
    "dateLabel": "30 August 2026",
    "text": "Maa bollo ghum theke othar por",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_1017",
    "sender": "Ankita",
    "time": "17:35",
    "date": "2026-08-30",
    "dateLabel": "30 August 2026",
    "text": "Kono plan e chilo na",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_1018",
    "sender": "Ratnadwip",
    "time": "17:35",
    "date": "2026-08-30",
    "dateLabel": "30 August 2026",
    "text": "STK-20260824-WA0003.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260824-WA0003.webp",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_1019",
    "sender": "Ankita",
    "time": "17:35",
    "date": "2026-08-30",
    "dateLabel": "30 August 2026",
    "text": "🫩🥲",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_1020",
    "sender": "Ankita",
    "time": "17:35",
    "date": "2026-08-30",
    "dateLabel": "30 August 2026",
    "text": "Dara kaushik da k boli esob tui ki korchis🤣🤣🤦🏻‍♀️",
    "type": "text",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_1021",
    "sender": "Ratnadwip",
    "time": "17:38",
    "date": "2026-08-30",
    "dateLabel": "30 August 2026",
    "text": "STK-20260824-WA0003.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260824-WA0003.webp",
    "milestone": "Rakhi & Shared Birthday"
  },
  {
    "id": "m_1022",
    "sender": "Ratnadwip",
    "time": "00:19",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "https://www.linkedin.com/posts/hooghly-engineering-technology-college_hetc-studentachievement-teampiedpiper-activity-7499864449982492673-W4JS?utm_source=share&utm_medium=member_android&rcm=ACoAADcL800BttegCa1-9sM0cbYRsbpo5Xz_3HU",
    "type": "link",
    "linkUrl": "https://www.linkedin.com/posts/hooghly-engineering-technology-college_hetc-studentachievement-teampiedpiper-activity-7499864449982492673-W4JS?utm_source=share&utm_medium=member_android&rcm=ACoAADcL800BttegCa1-9sM0cbYRsbpo5Xz_3HU"
  },
  {
    "id": "m_1023",
    "sender": "Ankita",
    "time": "00:20",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "🎀👌🏻",
    "type": "text"
  },
  {
    "id": "m_1024",
    "sender": "Ratnadwip",
    "time": "00:25",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "STK-20260830-WA0010.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260830-WA0010.webp"
  },
  {
    "id": "m_1025",
    "sender": "Ankita",
    "time": "12:03",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "Aa suggestions gulo de na",
    "type": "text"
  },
  {
    "id": "m_1026",
    "sender": "Ankita",
    "time": "12:04",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "😶‍🌫️",
    "type": "text"
  },
  {
    "id": "m_1027",
    "sender": "Ankita",
    "time": "12:04",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "Kal k ki exam?",
    "type": "text"
  },
  {
    "id": "m_1028",
    "sender": "Ratnadwip",
    "time": "12:37",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "haa",
    "type": "text"
  },
  {
    "id": "m_1029",
    "sender": "Ankita",
    "time": "12:37",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "Haa ta abr ki exam?",
    "type": "text"
  },
  {
    "id": "m_1030",
    "sender": "Ankita",
    "time": "12:37",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "🫩",
    "type": "text"
  },
  {
    "id": "m_1031",
    "sender": "Ratnadwip",
    "time": "12:37",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "https://docs.google.com/document/d/1HjUzTl31dBEdb7p4y2kifooXm6NYyt7ix0zHSUgi_iE/edit?usp=sharing",
    "type": "link",
    "linkUrl": "https://docs.google.com/document/d/1HjUzTl31dBEdb7p4y2kifooXm6NYyt7ix0zHSUgi_iE/edit?usp=sharing"
  },
  {
    "id": "m_1032",
    "sender": "Ratnadwip",
    "time": "12:37",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "IMG-20260826-WA0011.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20260826-WA0011.jpg"
  },
  {
    "id": "m_1033",
    "sender": "Ratnadwip",
    "time": "12:37",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "baki gulo dichhi pore",
    "type": "text"
  },
  {
    "id": "m_1034",
    "sender": "Ankita",
    "time": "12:37",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "Egulo ki?",
    "type": "text"
  },
  {
    "id": "m_1035",
    "sender": "Ratnadwip",
    "time": "12:38",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "Computer Organisation",
    "type": "text"
  },
  {
    "id": "m_1036",
    "sender": "Ankita",
    "time": "12:38",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "Kal toh nei co",
    "type": "text"
  },
  {
    "id": "m_1037",
    "sender": "Ankita",
    "time": "12:38",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "Kal toh analog",
    "type": "text"
  },
  {
    "id": "m_1038",
    "sender": "Ankita",
    "time": "12:38",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "R dsa",
    "type": "text"
  },
  {
    "id": "m_1039",
    "sender": "Ratnadwip",
    "time": "12:38",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "DS Questions (1).pdf (file attached)",
    "type": "document"
  },
  {
    "id": "m_1040",
    "sender": "Ratnadwip",
    "time": "12:38",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "analog ta pore dichhi",
    "type": "text"
  },
  {
    "id": "m_1041",
    "sender": "Ankita",
    "time": "12:39",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "Oo seta bol🙂",
    "type": "text"
  },
  {
    "id": "m_1042",
    "sender": "Ratnadwip",
    "time": "20:47",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "https://docs.google.com/document/d/1okaYNBT6znRmg-PSUHg32rYZi5mK3PCMTqHUz73Z56s/edit?usp=sharing",
    "type": "link",
    "linkUrl": "https://docs.google.com/document/d/1okaYNBT6znRmg-PSUHg32rYZi5mK3PCMTqHUz73Z56s/edit?usp=sharing"
  },
  {
    "id": "m_1043",
    "sender": "Ankita",
    "time": "20:49",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "Ki eta?",
    "type": "text"
  },
  {
    "id": "m_1044",
    "sender": "Ratnadwip",
    "time": "20:49",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "DSA suggestion with answer",
    "type": "text"
  },
  {
    "id": "m_1045",
    "sender": "Ankita",
    "time": "20:49",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "Porar por dili?",
    "type": "text"
  },
  {
    "id": "m_1046",
    "sender": "Ankita",
    "time": "20:49",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "😑🥲",
    "type": "text"
  },
  {
    "id": "m_1047",
    "sender": "Ankita",
    "time": "20:50",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "Pora sesh amr",
    "type": "text"
  },
  {
    "id": "m_1048",
    "sender": "Ankita",
    "time": "20:50",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "DSA",
    "type": "text"
  },
  {
    "id": "m_1049",
    "sender": "Ratnadwip",
    "time": "20:50",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "aww hell na",
    "type": "text"
  },
  {
    "id": "m_1050",
    "sender": "Ankita",
    "time": "20:50",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "Sudhu Analog baki",
    "type": "text"
  },
  {
    "id": "m_1051",
    "sender": "Ratnadwip",
    "time": "20:50",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "dara dichhi. 10 min",
    "type": "text"
  },
  {
    "id": "m_1052",
    "sender": "Ankita",
    "time": "20:50",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "Otar suggestions de",
    "type": "text"
  },
  {
    "id": "m_1053",
    "sender": "Ankita",
    "time": "20:50",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "Wowww",
    "type": "text"
  },
  {
    "id": "m_1054",
    "sender": "Ankita",
    "time": "20:50",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "8 ta to 9 ta🥲",
    "type": "text"
  },
  {
    "id": "m_1055",
    "sender": "Ankita",
    "time": "20:50",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "Question de ans ami banabo",
    "type": "text"
  },
  {
    "id": "m_1056",
    "sender": "Ankita",
    "time": "20:50",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "🤣🤣",
    "type": "text"
  },
  {
    "id": "m_1057",
    "sender": "Ratnadwip",
    "time": "20:50",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "ok",
    "type": "text"
  },
  {
    "id": "m_1058",
    "sender": "Ankita",
    "time": "20:50",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "Exam ao tai korbo",
    "type": "text"
  },
  {
    "id": "m_1059",
    "sender": "Ratnadwip",
    "time": "20:51",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "STK-20260830-WA0010.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260830-WA0010.webp"
  },
  {
    "id": "m_1060",
    "sender": "Ankita",
    "time": "20:52",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": ") What do\n  you mean by Data Structure?  \nii) What is abstract\ndata type (ADT)?\niii) Process\n  of removing an element from the stack is called ________.\niv) How are elements\nstored in a 2D array in memory?\nv)  What is the advantage of using array data\nstructure?\nvi) If a linear queue\nis implemented using an array of size MAX_SIZE, what condition indicates that\nthe queue is completely full?\nvii) The type of\nexpression in which operator succeeds its operands is?\nQ2. Write down the\nalgorithm of PUSH and POP operation for Stack Data Structure?\nQ3. Evaluate\n  the postfix expression using stack: 2 3 1 * + 9 -\nQ4. State\n  the difference between stack and queue data structure.\nQ5. Write down the\nalgorithm for enqueue and dequeue operation of linear queue?\nQ6. Convert the following\ninfix expression into postfix expression using the stack data structure with\ndetailed explanation: A – (B / C + (D % E * F) / G)* H.\nQ7. What is Stack ADT?\nExplain their operations.\nQ8. What is Stack Overflow and Stack Underflow",
    "type": "text"
  },
  {
    "id": "m_1061",
    "sender": "Ankita",
    "time": "20:52",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "Amader DSA te ai kota suggestions diyeche dekhlm sir",
    "type": "text"
  },
  {
    "id": "m_1062",
    "sender": "Ankita",
    "time": "20:52",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "Puro 25 narks dakh",
    "type": "text"
  },
  {
    "id": "m_1063",
    "sender": "Ankita",
    "time": "20:52",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "Calculation korle",
    "type": "text"
  },
  {
    "id": "m_1064",
    "sender": "Ratnadwip",
    "time": "20:56",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "1. 1's compliment substraction\n2. Realization of logic gate - (AND/OR) using NAND & NOR\n3. Application of boolean alegbra simplification\n4. Difference among - Op-amp classes (A/B/C/D)\n5. Difference among voltage amp v. current amp\n6. Class A power amp efficiency calculation, draw the diagram series phase power amp.\n\n- number system/conversion.",
    "type": "text"
  },
  {
    "id": "m_1065",
    "sender": "Ratnadwip",
    "time": "20:56",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "eta toh qsn paper.",
    "type": "text"
  },
  {
    "id": "m_1066",
    "sender": "Ratnadwip",
    "time": "20:56",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "W",
    "type": "text"
  },
  {
    "id": "m_1067",
    "sender": "Ankita",
    "time": "20:58",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "Yess",
    "type": "text"
  },
  {
    "id": "m_1068",
    "sender": "Ankita",
    "time": "20:58",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "Etai poro baba",
    "type": "text"
  },
  {
    "id": "m_1069",
    "sender": "Ratnadwip",
    "time": "20:58",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "STK-20260809-WA0027.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0027.webp"
  },
  {
    "id": "m_1070",
    "sender": "Ankita",
    "time": "20:58",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "STK-20260809-WA0021.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0021.webp"
  },
  {
    "id": "m_1071",
    "sender": "Ratnadwip",
    "time": "20:59",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "dara answer korte di ai ke",
    "type": "text"
  },
  {
    "id": "m_1072",
    "sender": "Ankita",
    "time": "20:59",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "Ai tuku diyeche oi mam ta ishh tar theke borong na porei jbo",
    "type": "text"
  },
  {
    "id": "m_1073",
    "sender": "Ankita",
    "time": "20:59",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "Kiser?",
    "type": "text"
  },
  {
    "id": "m_1074",
    "sender": "Ratnadwip",
    "time": "21:02",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "STK-20260809-WA0025.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0025.webp"
  },
  {
    "id": "m_1075",
    "sender": "Ratnadwip",
    "time": "21:02",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "dsa",
    "type": "text"
  },
  {
    "id": "m_1076",
    "sender": "Ankita",
    "time": "21:02",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "😋😋😶‍🌫️",
    "type": "text"
  },
  {
    "id": "m_1077",
    "sender": "Ratnadwip",
    "time": "21:10",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "https://docs.google.com/document/d/157oDOF-0luXe-zy2PLaSA6CmLSzfAPsNxakRj92_ZnI/edit?usp=sharing",
    "type": "link",
    "linkUrl": "https://docs.google.com/document/d/157oDOF-0luXe-zy2PLaSA6CmLSzfAPsNxakRj92_ZnI/edit?usp=sharing"
  },
  {
    "id": "m_1078",
    "sender": "Ankita",
    "time": "21:11",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "Sesh pora amr",
    "type": "text"
  },
  {
    "id": "m_1079",
    "sender": "Ankita",
    "time": "21:11",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "😋😋",
    "type": "text"
  },
  {
    "id": "m_1080",
    "sender": "Ratnadwip",
    "time": "21:11",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "STK-20260830-WA0009.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260830-WA0009.webp"
  },
  {
    "id": "m_1081",
    "sender": "Ankita",
    "time": "21:11",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "K eta?",
    "type": "text"
  },
  {
    "id": "m_1082",
    "sender": "Ratnadwip",
    "time": "21:11",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "sayan da",
    "type": "text"
  },
  {
    "id": "m_1083",
    "sender": "Ratnadwip",
    "time": "21:11",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "myrad",
    "type": "text"
  },
  {
    "id": "m_1084",
    "sender": "Ankita",
    "time": "21:11",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "Chini e na🫩🤦🏻‍♀️🤣",
    "type": "text"
  },
  {
    "id": "m_1085",
    "sender": "Ankita",
    "time": "21:12",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "Oo acchaa",
    "type": "text"
  },
  {
    "id": "m_1086",
    "sender": "Ankita",
    "time": "21:12",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "Ebr chinlm",
    "type": "text"
  },
  {
    "id": "m_1087",
    "sender": "Ratnadwip",
    "time": "21:12",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "lol",
    "type": "text"
  },
  {
    "id": "m_1088",
    "sender": "Ratnadwip",
    "time": "21:30",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "abar jhap deoar jaiga te bose chis",
    "type": "text"
  },
  {
    "id": "m_1089",
    "sender": "Ankita",
    "time": "21:31",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "STK-20260830-WA0008.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260830-WA0008.webp"
  },
  {
    "id": "m_1090",
    "sender": "Ankita",
    "time": "21:31",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "Uthte giye hoye gechilo amr",
    "type": "text"
  },
  {
    "id": "m_1091",
    "sender": "Ankita",
    "time": "21:31",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "Panchil ta atoh unchu",
    "type": "text"
  },
  {
    "id": "m_1092",
    "sender": "Ankita",
    "time": "21:31",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "😑😑",
    "type": "text"
  },
  {
    "id": "m_1093",
    "sender": "Ratnadwip",
    "time": "21:31",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "jhap ta cancelled till exam",
    "type": "text"
  },
  {
    "id": "m_1094",
    "sender": "Ankita",
    "time": "21:32",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "Hya",
    "type": "text"
  },
  {
    "id": "m_1095",
    "sender": "Ankita",
    "time": "21:32",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "Result er time a jhap dbo",
    "type": "text"
  },
  {
    "id": "m_1096",
    "sender": "Ankita",
    "time": "21:32",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "Ami toh tao utheychi",
    "type": "text"
  },
  {
    "id": "m_1097",
    "sender": "Ankita",
    "time": "21:32",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "Sumpi uthtei parey ni",
    "type": "text"
  },
  {
    "id": "m_1098",
    "sender": "Ratnadwip",
    "time": "21:32",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "STK-20260831-WA0032.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260831-WA0032.webp"
  },
  {
    "id": "m_1099",
    "sender": "Ankita",
    "time": "21:32",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "Hebbi moja peyechi",
    "type": "text"
  },
  {
    "id": "m_1100",
    "sender": "Ankita",
    "time": "21:32",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "STK-20260831-WA0033.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260831-WA0033.webp"
  },
  {
    "id": "m_1101",
    "sender": "Ratnadwip",
    "time": "21:32",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "STK-20260817-WA0039.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260817-WA0039.webp"
  },
  {
    "id": "m_1102",
    "sender": "Ankita",
    "time": "21:33",
    "date": "2026-08-31",
    "dateLabel": "31 August 2026",
    "text": "STK-20260830-WA0008.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260830-WA0008.webp"
  },
  {
    "id": "m_1103",
    "sender": "Ratnadwip",
    "time": "17:01",
    "date": "2026-09-01",
    "dateLabel": "1 September 2026",
    "text": "STK-20260728-WA0005.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260728-WA0005.webp"
  },
  {
    "id": "m_1104",
    "sender": "Ratnadwip",
    "time": "17:01",
    "date": "2026-09-01",
    "dateLabel": "1 September 2026",
    "text": "ki unprofessional reply",
    "type": "text"
  },
  {
    "id": "m_1105",
    "sender": "Ankita",
    "time": "17:02",
    "date": "2026-09-01",
    "dateLabel": "1 September 2026",
    "text": "😑",
    "type": "text"
  },
  {
    "id": "m_1106",
    "sender": "Ankita",
    "time": "17:02",
    "date": "2026-09-01",
    "dateLabel": "1 September 2026",
    "text": "Tui ki professional amr kaccheyy?",
    "type": "text"
  },
  {
    "id": "m_1107",
    "sender": "Ratnadwip",
    "time": "17:02",
    "date": "2026-09-01",
    "dateLabel": "1 September 2026",
    "text": "STK-20260830-WA0009.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260830-WA0009.webp"
  },
  {
    "id": "m_1108",
    "sender": "Ankita",
    "time": "17:02",
    "date": "2026-09-01",
    "dateLabel": "1 September 2026",
    "text": "STK-20260827-WA0007.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260827-WA0007.webp"
  },
  {
    "id": "m_1109",
    "sender": "Ratnadwip",
    "time": "17:02",
    "date": "2026-09-01",
    "dateLabel": "1 September 2026",
    "text": "kor kor, mosti mojak dorkar",
    "type": "text"
  },
  {
    "id": "m_1110",
    "sender": "Ratnadwip",
    "time": "17:03",
    "date": "2026-09-01",
    "dateLabel": "1 September 2026",
    "text": "besi serious hoye gache <This message was edited>",
    "type": "text"
  },
  {
    "id": "m_1111",
    "sender": "Ankita",
    "time": "17:03",
    "date": "2026-09-01",
    "dateLabel": "1 September 2026",
    "text": "Korbo na",
    "type": "text"
  },
  {
    "id": "m_1112",
    "sender": "Ankita",
    "time": "17:03",
    "date": "2026-09-01",
    "dateLabel": "1 September 2026",
    "text": "Erm blli r korbo na",
    "type": "text"
  },
  {
    "id": "m_1113",
    "sender": "Ratnadwip",
    "time": "17:03",
    "date": "2026-09-01",
    "dateLabel": "1 September 2026",
    "text": "STK-20260831-WA0021.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260831-WA0021.webp"
  },
  {
    "id": "m_1114",
    "sender": "Ankita",
    "time": "17:03",
    "date": "2026-09-01",
    "dateLabel": "1 September 2026",
    "text": "😒😒",
    "type": "text"
  },
  {
    "id": "m_1115",
    "sender": "Ankita",
    "time": "17:03",
    "date": "2026-09-01",
    "dateLabel": "1 September 2026",
    "text": "Reply e debo na dakh",
    "type": "text"
  },
  {
    "id": "m_1116",
    "sender": "Ratnadwip",
    "time": "17:03",
    "date": "2026-09-01",
    "dateLabel": "1 September 2026",
    "text": "grp chat er kotha bolchi",
    "type": "text"
  },
  {
    "id": "m_1117",
    "sender": "Ratnadwip",
    "time": "17:03",
    "date": "2026-09-01",
    "dateLabel": "1 September 2026",
    "text": "y ta t hoye gache",
    "type": "text"
  },
  {
    "id": "m_1118",
    "sender": "Ankita",
    "time": "17:05",
    "date": "2026-09-01",
    "dateLabel": "1 September 2026",
    "text": "🫩😒",
    "type": "text"
  },
  {
    "id": "m_1119",
    "sender": "Ankita",
    "time": "21:20",
    "date": "2026-09-01",
    "dateLabel": "1 September 2026",
    "text": "Maths er r suggestion ta de toh",
    "type": "text"
  },
  {
    "id": "m_1120",
    "sender": "Ankita",
    "time": "21:20",
    "date": "2026-09-01",
    "dateLabel": "1 September 2026",
    "text": "🫩",
    "type": "text"
  },
  {
    "id": "m_1121",
    "sender": "Ratnadwip",
    "time": "21:20",
    "date": "2026-09-01",
    "dateLabel": "1 September 2026",
    "text": "qsn paper",
    "type": "text"
  },
  {
    "id": "m_1122",
    "sender": "Ratnadwip",
    "time": "21:20",
    "date": "2026-09-01",
    "dateLabel": "1 September 2026",
    "text": "dara",
    "type": "text"
  },
  {
    "id": "m_1123",
    "sender": "Ankita",
    "time": "21:21",
    "date": "2026-09-01",
    "dateLabel": "1 September 2026",
    "text": "De",
    "type": "text"
  },
  {
    "id": "m_1124",
    "sender": "Ratnadwip",
    "time": "21:21",
    "date": "2026-09-01",
    "dateLabel": "1 September 2026",
    "text": "khata lagbe",
    "type": "text"
  },
  {
    "id": "m_1125",
    "sender": "Ratnadwip",
    "time": "21:21",
    "date": "2026-09-01",
    "dateLabel": "1 September 2026",
    "text": "ghurchi bike e",
    "type": "text"
  },
  {
    "id": "m_1126",
    "sender": "Ankita",
    "time": "21:22",
    "date": "2026-09-01",
    "dateLabel": "1 September 2026",
    "text": "Ki sob",
    "type": "text"
  },
  {
    "id": "m_1127",
    "sender": "Ankita",
    "time": "21:22",
    "date": "2026-09-01",
    "dateLabel": "1 September 2026",
    "text": "Free hole dis",
    "type": "text"
  },
  {
    "id": "m_1128",
    "sender": "Ratnadwip",
    "time": "21:22",
    "date": "2026-09-01",
    "dateLabel": "1 September 2026",
    "text": "haaaaa",
    "type": "text"
  },
  {
    "id": "m_1129",
    "sender": "Ratnadwip",
    "time": "21:44",
    "date": "2026-09-01",
    "dateLabel": "1 September 2026",
    "text": "",
    "type": "text"
  },
  {
    "id": "m_1130",
    "sender": "Ratnadwip",
    "time": "21:44",
    "date": "2026-09-01",
    "dateLabel": "1 September 2026",
    "text": "IMG-20260901-WA0029.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20260901-WA0029.jpg"
  },
  {
    "id": "m_1131",
    "sender": "Ratnadwip",
    "time": "21:44",
    "date": "2026-09-01",
    "dateLabel": "1 September 2026",
    "text": "IMG-20260901-WA0030.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20260901-WA0030.jpg"
  },
  {
    "id": "m_1132",
    "sender": "Ratnadwip",
    "time": "21:44",
    "date": "2026-09-01",
    "dateLabel": "1 September 2026",
    "text": "IMG-20260901-WA0031.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20260901-WA0031.jpg"
  },
  {
    "id": "m_1133",
    "sender": "Ratnadwip",
    "time": "21:44",
    "date": "2026-09-01",
    "dateLabel": "1 September 2026",
    "text": "IMG-20260901-WA0032.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20260901-WA0032.jpg"
  },
  {
    "id": "m_1134",
    "sender": "Ankita",
    "time": "21:46",
    "date": "2026-09-01",
    "dateLabel": "1 September 2026",
    "text": "Ayeinnn",
    "type": "text"
  },
  {
    "id": "m_1135",
    "sender": "Ankita",
    "time": "21:46",
    "date": "2026-09-01",
    "dateLabel": "1 September 2026",
    "text": "Ki egulo",
    "type": "text"
  },
  {
    "id": "m_1136",
    "sender": "Ratnadwip",
    "time": "21:46",
    "date": "2026-09-01",
    "dateLabel": "1 September 2026",
    "text": "qsn",
    "type": "text"
  },
  {
    "id": "m_1137",
    "sender": "Ankita",
    "time": "21:46",
    "date": "2026-09-01",
    "dateLabel": "1 September 2026",
    "text": "🫩sesh ami",
    "type": "text"
  },
  {
    "id": "m_1138",
    "sender": "Ratnadwip",
    "time": "21:46",
    "date": "2026-09-01",
    "dateLabel": "1 September 2026",
    "text": "STK-20260824-WA0003.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260824-WA0003.webp"
  },
  {
    "id": "m_1139",
    "sender": "Ratnadwip",
    "time": "08:29",
    "date": "2026-09-02",
    "dateLabel": "2 September 2026",
    "text": "STK-20260728-WA0005.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260728-WA0005.webp"
  },
  {
    "id": "m_1140",
    "sender": "Ankita",
    "time": "08:29",
    "date": "2026-09-02",
    "dateLabel": "2 September 2026",
    "text": "STK-20260829-WA0040.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260829-WA0040.webp"
  },
  {
    "id": "m_1141",
    "sender": "Ankita",
    "time": "19:10",
    "date": "2026-09-02",
    "dateLabel": "2 September 2026",
    "text": "Aa",
    "type": "text"
  },
  {
    "id": "m_1142",
    "sender": "Ankita",
    "time": "19:10",
    "date": "2026-09-02",
    "dateLabel": "2 September 2026",
    "text": "Economics er suggestion achey?",
    "type": "text"
  },
  {
    "id": "m_1143",
    "sender": "Ratnadwip",
    "time": "19:22",
    "date": "2026-09-02",
    "dateLabel": "2 September 2026",
    "text": "IMG-20260902-WA0015.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20260902-WA0015.jpg"
  },
  {
    "id": "m_1144",
    "sender": "Ratnadwip",
    "time": "17:52",
    "date": "2026-09-04",
    "dateLabel": "4 September 2026",
    "text": "STK-20260831-WA0021.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260831-WA0021.webp"
  },
  {
    "id": "m_1145",
    "sender": "Ankita",
    "time": "17:53",
    "date": "2026-09-04",
    "dateLabel": "4 September 2026",
    "text": "STK-20260809-WA0026.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0026.webp"
  },
  {
    "id": "m_1146",
    "sender": "Ratnadwip",
    "time": "20:24",
    "date": "2026-09-04",
    "dateLabel": "4 September 2026",
    "text": "https://hackspire26.devfolio.co/",
    "type": "link",
    "linkUrl": "https://hackspire26.devfolio.co/"
  },
  {
    "id": "m_1147",
    "sender": "Ratnadwip",
    "time": "20:24",
    "date": "2026-09-04",
    "dateLabel": "4 September 2026",
    "text": "f8bed50c67",
    "type": "text"
  },
  {
    "id": "m_1148",
    "sender": "Ratnadwip",
    "time": "20:24",
    "date": "2026-09-04",
    "dateLabel": "4 September 2026",
    "text": "eta team code",
    "type": "text"
  },
  {
    "id": "m_1149",
    "sender": "Ankita",
    "time": "20:24",
    "date": "2026-09-04",
    "dateLabel": "4 September 2026",
    "text": "Accha dara",
    "type": "text"
  },
  {
    "id": "m_1150",
    "sender": "Ankita",
    "time": "20:25",
    "date": "2026-09-04",
    "dateLabel": "4 September 2026",
    "text": "Korey janacchi",
    "type": "text"
  },
  {
    "id": "m_1151",
    "sender": "Ratnadwip",
    "time": "20:25",
    "date": "2026-09-04",
    "dateLabel": "4 September 2026",
    "text": "W",
    "type": "text"
  },
  {
    "id": "m_1152",
    "sender": "Ankita",
    "time": "20:27",
    "date": "2026-09-04",
    "dateLabel": "4 September 2026",
    "text": "Dakh toh",
    "type": "text"
  },
  {
    "id": "m_1153",
    "sender": "Ratnadwip",
    "time": "20:27",
    "date": "2026-09-04",
    "dateLabel": "4 September 2026",
    "text": "hoye gache",
    "type": "text"
  },
  {
    "id": "m_1154",
    "sender": "Ankita",
    "time": "20:27",
    "date": "2026-09-04",
    "dateLabel": "4 September 2026",
    "text": "Korechi",
    "type": "text"
  },
  {
    "id": "m_1155",
    "sender": "Ratnadwip",
    "time": "20:28",
    "date": "2026-09-04",
    "dateLabel": "4 September 2026",
    "text": "STK-20260728-WA0005.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260728-WA0005.webp"
  },
  {
    "id": "m_1156",
    "sender": "Ankita",
    "time": "20:28",
    "date": "2026-09-04",
    "dateLabel": "4 September 2026",
    "text": "Ok",
    "type": "text"
  },
  {
    "id": "m_1157",
    "sender": "Ankita",
    "time": "20:28",
    "date": "2026-09-04",
    "dateLabel": "4 September 2026",
    "text": "Ranit achey dekhlm",
    "type": "text"
  },
  {
    "id": "m_1158",
    "sender": "Ankita",
    "time": "20:28",
    "date": "2026-09-04",
    "dateLabel": "4 September 2026",
    "text": "🙂",
    "type": "text"
  },
  {
    "id": "m_1159",
    "sender": "Ratnadwip",
    "time": "20:28",
    "date": "2026-09-04",
    "dateLabel": "4 September 2026",
    "text": "yes",
    "type": "text"
  },
  {
    "id": "m_1160",
    "sender": "Ratnadwip",
    "time": "20:28",
    "date": "2026-09-04",
    "dateLabel": "4 September 2026",
    "text": "soumyajit o thakbe",
    "type": "text"
  },
  {
    "id": "m_1161",
    "sender": "Ratnadwip",
    "time": "20:28",
    "date": "2026-09-04",
    "dateLabel": "4 September 2026",
    "text": "onno team eta",
    "type": "text"
  },
  {
    "id": "m_1162",
    "sender": "Ankita",
    "time": "20:28",
    "date": "2026-09-04",
    "dateLabel": "4 September 2026",
    "text": "J gaan korey right?",
    "type": "text"
  },
  {
    "id": "m_1163",
    "sender": "Ratnadwip",
    "time": "20:28",
    "date": "2026-09-04",
    "dateLabel": "4 September 2026",
    "text": "haa",
    "type": "text"
  },
  {
    "id": "m_1164",
    "sender": "Ankita",
    "time": "20:28",
    "date": "2026-09-04",
    "dateLabel": "4 September 2026",
    "text": "Se bhaloi bujhechi",
    "type": "text"
  },
  {
    "id": "m_1165",
    "sender": "Ankita",
    "time": "20:28",
    "date": "2026-09-04",
    "dateLabel": "4 September 2026",
    "text": "STK-20260809-WA0021.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0021.webp"
  },
  {
    "id": "m_1166",
    "sender": "Ratnadwip",
    "time": "20:29",
    "date": "2026-09-04",
    "dateLabel": "4 September 2026",
    "text": "STK-20260809-WA0027.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0027.webp"
  },
  {
    "id": "m_1167",
    "sender": "Ratnadwip",
    "time": "16:46",
    "date": "2026-09-05",
    "dateLabel": "5 September 2026",
    "text": "মেঘবালিকার দল, crazy",
    "type": "text"
  },
  {
    "id": "m_1168",
    "sender": "Ankita",
    "time": "16:47",
    "date": "2026-09-05",
    "dateLabel": "5 September 2026",
    "text": "STK-20260811-WA0006.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260811-WA0006.webp"
  },
  {
    "id": "m_1169",
    "sender": "Ankita",
    "time": "12:53",
    "date": "2026-09-06",
    "dateLabel": "6 September 2026",
    "text": "LAB name -Computer Organization Lab\nCSE-2A (Gr-1) PCA1 will be held on 12.09.2026\n\nCSE-2A (Gr-2) PCA1 will be held on 10.09.2026",
    "type": "text"
  },
  {
    "id": "m_1170",
    "sender": "Ankita",
    "time": "12:53",
    "date": "2026-09-06",
    "dateLabel": "6 September 2026",
    "text": "Dakh amader eta",
    "type": "text"
  },
  {
    "id": "m_1171",
    "sender": "Ratnadwip",
    "time": "12:55",
    "date": "2026-09-06",
    "dateLabel": "6 September 2026",
    "text": "ki hobe kichu e bujhte parchi na",
    "type": "text"
  },
  {
    "id": "m_1172",
    "sender": "Ratnadwip",
    "time": "12:56",
    "date": "2026-09-06",
    "dateLabel": "6 September 2026",
    "text": "exam jodi hoi, then uniform pore jete hobe",
    "type": "text"
  },
  {
    "id": "m_1173",
    "sender": "Ratnadwip",
    "time": "12:56",
    "date": "2026-09-06",
    "dateLabel": "6 September 2026",
    "text": "🫩🫩",
    "type": "text"
  },
  {
    "id": "m_1174",
    "sender": "Ankita",
    "time": "12:59",
    "date": "2026-09-06",
    "dateLabel": "6 September 2026",
    "text": "PTT-20260906-WA0006.opus (file attached)",
    "type": "voice_note",
    "mediaName": "PTT-20260906-WA0006.opus"
  },
  {
    "id": "m_1175",
    "sender": "Ratnadwip",
    "time": "21:11",
    "date": "2026-09-06",
    "dateLabel": "6 September 2026",
    "text": "https://open.spotify.com/playlist/2LZj9tGCEb6PST8BL35PgQ?si=RRyIzyjvQUCMafep-dc_dA&utm_source=whatsapp&pi=LY_3fsBNR-uSr",
    "type": "link",
    "linkUrl": "https://open.spotify.com/playlist/2LZj9tGCEb6PST8BL35PgQ?si=RRyIzyjvQUCMafep-dc_dA&utm_source=whatsapp&pi=LY_3fsBNR-uSr"
  },
  {
    "id": "m_1176",
    "sender": "Ankita",
    "time": "21:12",
    "date": "2026-09-06",
    "dateLabel": "6 September 2026",
    "text": "STK-20260827-WA0007.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260827-WA0007.webp"
  },
  {
    "id": "m_1177",
    "sender": "Ratnadwip",
    "time": "21:12",
    "date": "2026-09-06",
    "dateLabel": "6 September 2026",
    "text": "😂",
    "type": "text"
  },
  {
    "id": "m_1178",
    "sender": "Ratnadwip",
    "time": "21:13",
    "date": "2026-09-06",
    "dateLabel": "6 September 2026",
    "text": "🐬",
    "type": "text"
  },
  {
    "id": "m_1179",
    "sender": "Ankita",
    "time": "21:14",
    "date": "2026-09-06",
    "dateLabel": "6 September 2026",
    "text": "STK-20260827-WA0007.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260827-WA0007.webp"
  },
  {
    "id": "m_1180",
    "sender": "Ratnadwip",
    "time": "21:15",
    "date": "2026-09-06",
    "dateLabel": "6 September 2026",
    "text": "STK-20260809-WA0027.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0027.webp"
  },
  {
    "id": "m_1181",
    "sender": "Ratnadwip",
    "time": "20:45",
    "date": "2026-09-07",
    "dateLabel": "7 September 2026",
    "text": "আমার একটা porshno আছে from admins , can I ask?",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1182",
    "sender": "Ratnadwip",
    "time": "20:45",
    "date": "2026-09-07",
    "dateLabel": "7 September 2026",
    "text": "Ei hackathon ta 36 hr অবধি চলবে এটা declear হয়েছে but Amara ঘুমাবো কোথায় ? Even fresh howa ba others 🙂",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1183",
    "sender": "Ratnadwip",
    "time": "20:45",
    "date": "2026-09-07",
    "dateLabel": "7 September 2026",
    "text": "@admins pls reply",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1184",
    "sender": "Ratnadwip",
    "time": "20:45",
    "date": "2026-09-07",
    "dateLabel": "7 September 2026",
    "text": "Rest naowar jayga ache seperately for boys and girls",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1185",
    "sender": "Ratnadwip",
    "time": "20:45",
    "date": "2026-09-07",
    "dateLabel": "7 September 2026",
    "text": "Fresh howar jonno o washrooms thakbe",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1186",
    "sender": "Ratnadwip",
    "time": "20:45",
    "date": "2026-09-07",
    "dateLabel": "7 September 2026",
    "text": "আর ঘুম?🙂",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1187",
    "sender": "Ratnadwip",
    "time": "20:45",
    "date": "2026-09-07",
    "dateLabel": "7 September 2026",
    "text": "Matress wagera sob thakbe",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1188",
    "sender": "Ratnadwip",
    "time": "20:45",
    "date": "2026-09-07",
    "dateLabel": "7 September 2026",
    "text": "Thank u 🙏",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1189",
    "sender": "Ratnadwip",
    "time": "20:45",
    "date": "2026-09-07",
    "dateLabel": "7 September 2026",
    "text": "🤣🤣🤣🤣🤣",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1190",
    "sender": "Ankita",
    "time": "20:56",
    "date": "2026-09-07",
    "dateLabel": "7 September 2026",
    "text": "R ki baki",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1191",
    "sender": "Ankita",
    "time": "20:56",
    "date": "2026-09-07",
    "dateLabel": "7 September 2026",
    "text": "Mod gaan r protection ig🤦🏻‍♀️🫩",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1192",
    "sender": "Ratnadwip",
    "time": "21:21",
    "date": "2026-09-07",
    "dateLabel": "7 September 2026",
    "text": "kaj keu korbe na",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1193",
    "sender": "Ratnadwip",
    "time": "21:21",
    "date": "2026-09-07",
    "dateLabel": "7 September 2026",
    "text": "STK-20260814-WA0029.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260814-WA0029.webp",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1194",
    "sender": "Ankita",
    "time": "21:22",
    "date": "2026-09-07",
    "dateLabel": "7 September 2026",
    "text": "Tai amra jitbo",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1195",
    "sender": "Ratnadwip",
    "time": "21:22",
    "date": "2026-09-07",
    "dateLabel": "7 September 2026",
    "text": "STK-20260820-WA0003.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260820-WA0003.webp",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1196",
    "sender": "Ankita",
    "time": "21:22",
    "date": "2026-09-07",
    "dateLabel": "7 September 2026",
    "text": "STK-20260830-WA0008.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260830-WA0008.webp",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1197",
    "sender": "Ratnadwip",
    "time": "20:22",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "😋",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1198",
    "sender": "Ankita",
    "time": "20:38",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "STK-20260830-WA0011.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260830-WA0011.webp",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1199",
    "sender": "Ratnadwip",
    "time": "20:41",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "pouche gechii",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1200",
    "sender": "Ratnadwip",
    "time": "20:41",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "STK-20260828-WA0005.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260828-WA0005.webp",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1201",
    "sender": "Ratnadwip",
    "time": "20:41",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "🫩",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1202",
    "sender": "Ankita",
    "time": "20:41",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "STK-20260830-WA0008.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260830-WA0008.webp",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1203",
    "sender": "Ratnadwip",
    "time": "20:41",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "😁",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1204",
    "sender": "Ankita",
    "time": "20:41",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "Accha",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1205",
    "sender": "Ankita",
    "time": "20:41",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "STK-20260908-WA0047.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260908-WA0047.webp",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1206",
    "sender": "Ratnadwip",
    "time": "20:41",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "STK-20260817-WA0039.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260817-WA0039.webp",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1207",
    "sender": "Ankita",
    "time": "20:41",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "Husss",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1208",
    "sender": "Ratnadwip",
    "time": "20:42",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "ginipig er sathe elam",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1209",
    "sender": "Ankita",
    "time": "20:42",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "How?",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1210",
    "sender": "Ratnadwip",
    "time": "20:44",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "dekhi ferry te uthche",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1211",
    "sender": "Ratnadwip",
    "time": "20:44",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "ami dekhe dak lam",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1212",
    "sender": "Ankita",
    "time": "20:46",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "Kii impossible",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1213",
    "sender": "Ankita",
    "time": "20:46",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "Dhop",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1214",
    "sender": "Ratnadwip",
    "time": "20:46",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "jantam etai bolbi",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1215",
    "sender": "Ankita",
    "time": "20:46",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "Oo naa ou toh oi dik diye asbe",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1216",
    "sender": "Ankita",
    "time": "20:46",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "😆",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1217",
    "sender": "Ankita",
    "time": "20:46",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "STK-20260830-WA0011.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260830-WA0011.webp",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1218",
    "sender": "Ratnadwip",
    "time": "20:46",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "oi tai",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1219",
    "sender": "Ankita",
    "time": "20:46",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "Ki kore?",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1220",
    "sender": "Ankita",
    "time": "20:46",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "Hyaa but bhab",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1221",
    "sender": "Ankita",
    "time": "20:46",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "What a coincidence",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1222",
    "sender": "Ratnadwip",
    "time": "20:47",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "because ami tomator",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1223",
    "sender": "Ratnadwip",
    "time": "20:47",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "yes yes",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1224",
    "sender": "Ankita",
    "time": "20:47",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "🙃🙃 <This message was edited>",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1225",
    "sender": "Ankita",
    "time": "20:47",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "😑😑",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1226",
    "sender": "Ratnadwip",
    "time": "20:48",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "STK-20260828-WA0005.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260828-WA0005.webp",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1227",
    "sender": "Ratnadwip",
    "time": "20:52",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "ghumaaaa",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1228",
    "sender": "Ankita",
    "time": "20:55",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "Kno??",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1229",
    "sender": "Ratnadwip",
    "time": "20:55",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "dorkar",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1230",
    "sender": "Ankita",
    "time": "20:55",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "Khai ni kichu khabo kheye ghumabo",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1231",
    "sender": "Ankita",
    "time": "20:55",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "STK-20260830-WA0011.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260830-WA0011.webp",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1232",
    "sender": "Ratnadwip",
    "time": "20:55",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "good",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1233",
    "sender": "Ankita",
    "time": "20:55",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "STK-20260809-WA0026.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0026.webp",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1234",
    "sender": "Ankita",
    "time": "21:03",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1235",
    "sender": "Ratnadwip",
    "time": "21:04",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "eta amake status dite hobe 🫩🫩",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1236",
    "sender": "Ankita",
    "time": "21:06",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "Hyaaa",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1237",
    "sender": "Ankita",
    "time": "21:06",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "STK-20260830-WA0011.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260830-WA0011.webp",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1238",
    "sender": "Ratnadwip",
    "time": "21:06",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "STK-20260812-WA0008.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260812-WA0008.webp",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1239",
    "sender": "Ankita",
    "time": "21:07",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "Mere dbo",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1240",
    "sender": "Ankita",
    "time": "21:07",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "De",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1241",
    "sender": "Ratnadwip",
    "time": "21:08",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "STK-20260809-WA0027.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0027.webp",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1242",
    "sender": "Ankita",
    "time": "21:09",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "STK-20260809-WA0021.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0021.webp",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1243",
    "sender": "Ankita",
    "time": "21:10",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "De tui",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1244",
    "sender": "Ankita",
    "time": "21:10",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "Naa😑🤌🏻pocha ami like bhalobese boli but tui bhalo pgl😑🫩",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1245",
    "sender": "Ratnadwip",
    "time": "21:11",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "STK-20260828-WA0005.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260828-WA0005.webp",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1246",
    "sender": "Ankita",
    "time": "21:12",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "STK-20260811-WA0006.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260811-WA0006.webp",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1247",
    "sender": "Ratnadwip",
    "time": "21:13",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "STK-20260827-WA0006.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260827-WA0006.webp",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1248",
    "sender": "Ankita",
    "time": "21:14",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "STK-20260811-WA0000.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260811-WA0000.webp",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1249",
    "sender": "Ratnadwip",
    "time": "21:14",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "khoa done ?",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1250",
    "sender": "Ankita",
    "time": "21:15",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "Naa ranna hoy ni",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1251",
    "sender": "Ankita",
    "time": "21:15",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "Ranna holei khabo",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1252",
    "sender": "Ankita",
    "time": "21:15",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "Then ghum",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1253",
    "sender": "Ratnadwip",
    "time": "21:17",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "nice",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1254",
    "sender": "Ankita",
    "time": "21:17",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "Kno?",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1255",
    "sender": "Ratnadwip",
    "time": "21:17",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "ami biriyani khabo 😋",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1256",
    "sender": "Ankita",
    "time": "21:17",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "R maa chicken banacchey",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1257",
    "sender": "Ankita",
    "time": "21:17",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "Yeaahh",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1258",
    "sender": "Ankita",
    "time": "21:18",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "STK-20260830-WA0011.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260830-WA0011.webp",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1259",
    "sender": "Ratnadwip",
    "time": "21:18",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "noiceee",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1260",
    "sender": "Ratnadwip",
    "time": "21:18",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "kheye ghum",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1261",
    "sender": "Ankita",
    "time": "21:18",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "Hehehe😋🎀",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1262",
    "sender": "Ankita",
    "time": "21:18",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "Hyaa sera ghum dbo",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1263",
    "sender": "Ankita",
    "time": "21:18",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "Paye byatha korche khub",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1264",
    "sender": "Ankita",
    "time": "21:18",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "🫩🥲",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1265",
    "sender": "Ratnadwip",
    "time": "21:19",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "aaaah, artu tipe dite hoto",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1266",
    "sender": "Ankita",
    "time": "21:19",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "😶kihh?!!!",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1267",
    "sender": "Ratnadwip",
    "time": "21:19",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "paa",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1268",
    "sender": "Ankita",
    "time": "21:19",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "Oo",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1269",
    "sender": "Ankita",
    "time": "21:19",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "🤦🏻‍♀️",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1270",
    "sender": "Ratnadwip",
    "time": "21:20",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "STK-20260827-WA0005.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260827-WA0005.webp",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1271",
    "sender": "Ankita",
    "time": "21:20",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "Acchaa jntm na aj janlm",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1272",
    "sender": "Ankita",
    "time": "21:20",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "STK-20260908-WA0054.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260908-WA0054.webp",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1273",
    "sender": "Ratnadwip",
    "time": "21:20",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "haat e daag bose ni",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1274",
    "sender": "Ankita",
    "time": "21:20",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "Jni bosbeo na",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1275",
    "sender": "Ratnadwip",
    "time": "21:20",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "💀",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1276",
    "sender": "Ankita",
    "time": "21:20",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "Ami jorey kamor di ni moteo <This message was edited>",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1277",
    "sender": "Ankita",
    "time": "21:20",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "🫩😒",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1278",
    "sender": "Ratnadwip",
    "time": "21:21",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "tokhon khub laglo. but haa khub besi laage ni",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1279",
    "sender": "Ankita",
    "time": "21:21",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "Patla na tui tai",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1280",
    "sender": "Ratnadwip",
    "time": "21:22",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "off compliment crazy.",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1281",
    "sender": "Ankita",
    "time": "21:22",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "Skin dhorey chibiyechi 🤣😆",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1282",
    "sender": "Ankita",
    "time": "21:22",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "STK-20260830-WA0008.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260830-WA0008.webp",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1283",
    "sender": "Ankita",
    "time": "21:22",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "STK-20260831-WA0033.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260831-WA0033.webp",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1284",
    "sender": "Ankita",
    "time": "22:05",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1285",
    "sender": "Ratnadwip",
    "time": "22:07",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "koiiii",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1286",
    "sender": "Ankita",
    "time": "22:07",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "Bhul likheychilm toh",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1287",
    "sender": "Ankita",
    "time": "22:07",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "Rulish likheychiln",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1288",
    "sender": "Ratnadwip",
    "time": "22:07",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "ouh",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1289",
    "sender": "Ankita",
    "time": "22:08",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "🫩",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1290",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "thik kore de",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1291",
    "sender": "Ankita",
    "time": "22:08",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "Dara",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1292",
    "sender": "Ratnadwip",
    "time": "22:09",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "🧍‍♂️",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1293",
    "sender": "Ankita",
    "time": "22:10",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1294",
    "sender": "Ankita",
    "time": "22:10",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "Ki holo?",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1295",
    "sender": "Ankita",
    "time": "22:11",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "😂",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1296",
    "sender": "Ratnadwip",
    "time": "22:11",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "dariye achi",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1297",
    "sender": "Ankita",
    "time": "22:11",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "Bang ki win?",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1298",
    "sender": "Ankita",
    "time": "22:12",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "🤦🏻‍♀️",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1299",
    "sender": "Ratnadwip",
    "time": "22:12",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "😋😋",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1300",
    "sender": "Ankita",
    "time": "22:12",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "Mere debo",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1301",
    "sender": "Ankita",
    "time": "22:13",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "Khub kelabo",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1302",
    "sender": "Ankita",
    "time": "22:13",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "😒",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1303",
    "sender": "Ratnadwip",
    "time": "22:14",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "😔😁😁",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1304",
    "sender": "Ankita",
    "time": "22:14",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "Kosto peli naki moja peli?",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1305",
    "sender": "Ratnadwip",
    "time": "22:15",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "bhalo laglo",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1306",
    "sender": "Ankita",
    "time": "22:16",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "STK-20260811-WA0000.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260811-WA0000.webp",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1307",
    "sender": "Ankita",
    "time": "22:26",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "Ai tui amr theke next day 167 cash nibi",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1308",
    "sender": "Ankita",
    "time": "22:26",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "🫩",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1309",
    "sender": "Ankita",
    "time": "22:26",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "Saswata 200 online korbe",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1310",
    "sender": "Ankita",
    "time": "22:27",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "R Pronay 100 debe",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1311",
    "sender": "Ankita",
    "time": "22:27",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "Amr theke cash nibi mone kore",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1312",
    "sender": "Ratnadwip",
    "time": "22:29",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "ok",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1313",
    "sender": "Ratnadwip",
    "time": "22:30",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "😎😎",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1314",
    "sender": "Ankita",
    "time": "22:31",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "Hmn",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1315",
    "sender": "Ratnadwip",
    "time": "22:36",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "IMG-20260908-WA0067.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20260908-WA0067.jpg",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1316",
    "sender": "Ankita",
    "time": "22:36",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "🤦🏻‍♀️",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1317",
    "sender": "Ratnadwip",
    "time": "22:54",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "gn",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1318",
    "sender": "Ratnadwip",
    "time": "22:55",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "🫩🫩",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1319",
    "sender": "Ankita",
    "time": "22:57",
    "date": "2026-09-08",
    "dateLabel": "8 September 2026",
    "text": "Gn8 😴",
    "type": "text",
    "milestone": "Teacher's Day"
  },
  {
    "id": "m_1320",
    "sender": "Ankita",
    "time": "14:01",
    "date": "2026-09-11",
    "dateLabel": "11 September 2026",
    "text": "Name- Debosmita Paul \nGmail- koyelpaul4507@gmail.com",
    "type": "text"
  },
  {
    "id": "m_1321",
    "sender": "Ankita",
    "time": "10:54",
    "date": "2026-09-16",
    "dateLabel": "16 September 2026",
    "text": "",
    "type": "text"
  },
  {
    "id": "m_1322",
    "sender": "Ankita",
    "time": "10:54",
    "date": "2026-09-16",
    "dateLabel": "16 September 2026",
    "text": "Ki darun na??",
    "type": "text"
  },
  {
    "id": "m_1323",
    "sender": "Ratnadwip",
    "time": "11:13",
    "date": "2026-09-16",
    "dateLabel": "16 September 2026",
    "text": "STK-20260828-WA0005.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260828-WA0005.webp"
  },
  {
    "id": "m_1324",
    "sender": "Ankita",
    "time": "11:14",
    "date": "2026-09-16",
    "dateLabel": "16 September 2026",
    "text": "STK-20260830-WA0011.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260830-WA0011.webp"
  },
  {
    "id": "m_1325",
    "sender": "Ratnadwip",
    "time": "19:45",
    "date": "2026-09-16",
    "dateLabel": "16 September 2026",
    "text": "It is for the information of all students that *Khichudi Bhog* will be served as prasad in the Prasad Sevan Program on the day of Holy Viswakarma Puja on 18th September 2026, as per the earlier notice today. Hence, all students are requested to give their consent to participate in the Prasad Sevan Program on the same day using the following Google Form at the earliest by *5:00 PM today* . Your cooperation is appreciated to help us conduct the Viswakarma Puja smoothly on the college campus.\n\n*Vishwakarma Puja 2026 (18.09.2026) Student Consent Link:* *https://forms.gle/XWUNZ9LLGerz6Xts8*\n\n\nSd/-\nPrincipal",
    "type": "link",
    "linkUrl": "https://forms.gle/XWUNZ9LLGerz6Xts8*"
  },
  {
    "id": "m_1326",
    "sender": "Ratnadwip",
    "time": "09:41",
    "date": "2026-09-19",
    "dateLabel": "19 September 2026",
    "text": "😭",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1327",
    "sender": "Ankita",
    "time": "14:25",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "😶‍🌫️😒",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1328",
    "sender": "Ratnadwip",
    "time": "14:25",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "ki holo ? 😶",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1329",
    "sender": "Ankita",
    "time": "14:27",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "Kichu na",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1330",
    "sender": "Ankita",
    "time": "14:27",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "😒",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1331",
    "sender": "Ankita",
    "time": "14:45",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "STK-20260908-WA0047.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260908-WA0047.webp",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1332",
    "sender": "Ratnadwip",
    "time": "14:55",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "STK-20260809-WA0024.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0024.webp",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1333",
    "sender": "Ankita",
    "time": "19:33",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1334",
    "sender": "Ankita",
    "time": "19:33",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "Kmon?",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1335",
    "sender": "Ratnadwip",
    "time": "19:34",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "nice",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1336",
    "sender": "Ankita",
    "time": "19:34",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "Na thle bhlo na",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1337",
    "sender": "Ankita",
    "time": "19:34",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "Nebo na",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1338",
    "sender": "Ratnadwip",
    "time": "19:34",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "crazy noi",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1339",
    "sender": "Ratnadwip",
    "time": "19:34",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "thik thak",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1340",
    "sender": "Ankita",
    "time": "19:34",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "Yes",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1341",
    "sender": "Ankita",
    "time": "19:35",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1342",
    "sender": "Ratnadwip",
    "time": "19:37",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "eta better 😋",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1343",
    "sender": "Ankita",
    "time": "19:38",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "Tar mne aro kharab",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1344",
    "sender": "Ratnadwip",
    "time": "19:38",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "naa",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1345",
    "sender": "Ratnadwip",
    "time": "19:38",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "bhalo lagche",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1346",
    "sender": "Ankita",
    "time": "19:38",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "Hya nebo na thle",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1347",
    "sender": "Ratnadwip",
    "time": "19:38",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "🫩🫩",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1348",
    "sender": "Ankita",
    "time": "19:38",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "😋😋",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1349",
    "sender": "Ankita",
    "time": "19:39",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "Nebo na",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1350",
    "sender": "Ankita",
    "time": "19:39",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "Chobi tuley bari",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1351",
    "sender": "Ankita",
    "time": "19:39",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "Tui khrp bolis ni tai",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1352",
    "sender": "Ratnadwip",
    "time": "19:39",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "🧍🏻",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1353",
    "sender": "Ankita",
    "time": "19:39",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "Instatnt dakh",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1354",
    "sender": "Ratnadwip",
    "time": "22:41",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "vulture.745482.xyz\neta page ta\n\nvulture.745482.xyz/admin\nid - aaich8036@gmail.com\npass - pocha_chele",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1355",
    "sender": "Ankita",
    "time": "22:42",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "Kihh",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1356",
    "sender": "Ankita",
    "time": "22:43",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "Korbo",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1357",
    "sender": "Ankita",
    "time": "22:43",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "Bol",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1358",
    "sender": "Ratnadwip",
    "time": "22:43",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "login kore dekh hochhe kina",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1359",
    "sender": "Ratnadwip",
    "time": "22:43",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "second link ta",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1360",
    "sender": "Ratnadwip",
    "time": "22:43",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "ar hackspire ta pore bolchi",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1361",
    "sender": "Ankita",
    "time": "22:43",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "Accha",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1362",
    "sender": "Ankita",
    "time": "22:44",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "Password bhul bollo",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1363",
    "sender": "Ratnadwip",
    "time": "22:45",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "tai ?",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1364",
    "sender": "Ankita",
    "time": "22:45",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "Hya",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1365",
    "sender": "Ratnadwip",
    "time": "22:45",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "ota thik kore de",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1366",
    "sender": "Ankita",
    "time": "22:45",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "Dilm",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1367",
    "sender": "Ankita",
    "time": "22:45",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "5 bar",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1368",
    "sender": "Ankita",
    "time": "22:45",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "Korlm",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1369",
    "sender": "Ratnadwip",
    "time": "22:45",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "😬😬",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1370",
    "sender": "Ankita",
    "time": "22:45",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "Bhul bollo",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1371",
    "sender": "Ankita",
    "time": "22:45",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "😑😑",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1372",
    "sender": "Ratnadwip",
    "time": "22:45",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "pocha_chele",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1373",
    "sender": "Ratnadwip",
    "time": "22:46",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "eta password",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1374",
    "sender": "Ankita",
    "time": "22:46",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "Dara last bar",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1375",
    "sender": "Ankita",
    "time": "22:47",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "Hoyeche",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1376",
    "sender": "Ratnadwip",
    "time": "22:47",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "😋",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1377",
    "sender": "Ankita",
    "time": "22:47",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": ".com ta .coma likhechilm",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1378",
    "sender": "Ankita",
    "time": "22:47",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "😑😑",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1379",
    "sender": "Ratnadwip",
    "time": "22:47",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "🫩",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1380",
    "sender": "Ankita",
    "time": "22:47",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "STK-20260830-WA0011.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260830-WA0011.webp",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1381",
    "sender": "Ankita",
    "time": "22:47",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "Chollyyy",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1382",
    "sender": "Ratnadwip",
    "time": "22:47",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "baki sobar ta diye di ebar",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1383",
    "sender": "Ankita",
    "time": "22:47",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "Ki??",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1384",
    "sender": "Ankita",
    "time": "22:47",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "Dibi",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1385",
    "sender": "Ratnadwip",
    "time": "22:55",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "id/pass",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1386",
    "sender": "Ankita",
    "time": "22:55",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "Oohh",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1387",
    "sender": "Ratnadwip",
    "time": "22:56",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "https://www.rynne.live/\n\nhttps://anakin.io/",
    "type": "link",
    "linkUrl": "https://www.rynne.live/",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1388",
    "sender": "Ratnadwip",
    "time": "22:57",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "https://github.com/Mantitup-Org/vista",
    "type": "link",
    "linkUrl": "https://github.com/Mantitup-Org/vista",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1389",
    "sender": "Ankita",
    "time": "22:59",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "2nd er ta ki korbo??",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1390",
    "sender": "Ankita",
    "time": "22:59",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "2nd er link ta??",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1391",
    "sender": "Ratnadwip",
    "time": "23:00",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "get started kore, google diye login kor",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1392",
    "sender": "Ankita",
    "time": "23:00",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "Korechi",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1393",
    "sender": "Ankita",
    "time": "23:00",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "Done 2 toi",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1394",
    "sender": "Ratnadwip",
    "time": "23:00",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "ei ta ke star korte hobe",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1395",
    "sender": "Ankita",
    "time": "23:00",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "Accha dara korchi",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1396",
    "sender": "Ankita",
    "time": "23:01",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "Korey diyechi dakh",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1397",
    "sender": "Ratnadwip",
    "time": "23:01",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "tor github username ki chilo ?",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1398",
    "sender": "Ratnadwip",
    "time": "23:01",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "damn_ankitaaaa ?",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1399",
    "sender": "Ankita",
    "time": "23:01",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "Bhuley gecchi dara dekhi",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1400",
    "sender": "Ankita",
    "time": "23:02",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "Dakh na",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1401",
    "sender": "Ankita",
    "time": "23:03",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "Khujey pacchi naa",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1402",
    "sender": "Ratnadwip",
    "time": "23:03",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "dekhchi dara, amio khujchi",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1403",
    "sender": "Ankita",
    "time": "23:03",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "🙄🙄",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1404",
    "sender": "Ankita",
    "time": "23:03",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "Hya amr ta rakhbi na duniyar loker ta rakhbi",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1405",
    "sender": "Ratnadwip",
    "time": "23:04",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "ankitaaichhh29",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1406",
    "sender": "Ratnadwip",
    "time": "23:04",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "peye gechi",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1407",
    "sender": "Ratnadwip",
    "time": "23:04",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "STK-20260809-WA0008.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0008.webp",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1408",
    "sender": "Ankita",
    "time": "23:04",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "Good",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1409",
    "sender": "Ankita",
    "time": "23:04",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "😒",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1410",
    "sender": "Ratnadwip",
    "time": "23:05",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "STK-20260809-WA0006.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0006.webp",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1411",
    "sender": "Ankita",
    "time": "23:40",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "STK-20260920-WA0015.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260920-WA0015.webp",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1412",
    "sender": "Ratnadwip",
    "time": "23:48",
    "date": "2026-09-20",
    "dateLabel": "20 September 2026",
    "text": "🤨🤨",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1413",
    "sender": "Ratnadwip",
    "time": "18:35",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "shaving cream er gondho bhalo lage ? 🤨",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1414",
    "sender": "Ankita",
    "time": "18:48",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Ha lge",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1415",
    "sender": "Ankita",
    "time": "18:49",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Tor theke pai na seta",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1416",
    "sender": "Ratnadwip",
    "time": "18:51",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "ami use kori na tai 😶",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1417",
    "sender": "Ankita",
    "time": "18:52",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Pocha tai tui",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1418",
    "sender": "Ankita",
    "time": "18:52",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "😒",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1419",
    "sender": "Ratnadwip",
    "time": "18:52",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "STK-20260831-WA0021.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260831-WA0021.webp",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1420",
    "sender": "Ankita",
    "time": "18:53",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Kotha bolchi na eta kheyal korechis?",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1421",
    "sender": "Ratnadwip",
    "time": "18:53",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "? 😶",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1422",
    "sender": "Ratnadwip",
    "time": "21:27",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "ai",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1423",
    "sender": "Ratnadwip",
    "time": "21:27",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "iei membership ki ?",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1424",
    "sender": "Ankita",
    "time": "21:28",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Jni na",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1425",
    "sender": "Ankita",
    "time": "21:28",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Kori ni ami",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1426",
    "sender": "Ankita",
    "time": "21:28",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "🥲",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1427",
    "sender": "Ratnadwip",
    "time": "21:28",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "korte hobe na ?",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1428",
    "sender": "Ankita",
    "time": "21:28",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Onek din agey thekei korche",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1429",
    "sender": "Ankita",
    "time": "21:28",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Poysa lgbe",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1430",
    "sender": "Ankita",
    "time": "21:28",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Ig",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1431",
    "sender": "Ankita",
    "time": "21:28",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Alada kono membership",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1432",
    "sender": "Ratnadwip",
    "time": "21:28",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "😮",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1433",
    "sender": "Ankita",
    "time": "21:28",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Ask korle keu e boley na tai kori ni byass",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1434",
    "sender": "Ratnadwip",
    "time": "21:28",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "korte hobe ?",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1435",
    "sender": "Ankita",
    "time": "21:29",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Na bad de",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1436",
    "sender": "Ankita",
    "time": "21:29",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Idt that this one is important",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1437",
    "sender": "Ratnadwip",
    "time": "21:29",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "oi poisa r biriyani khabo",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1438",
    "sender": "Ratnadwip",
    "time": "21:29",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "😋",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1439",
    "sender": "Ankita",
    "time": "21:29",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Hya 😋",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1440",
    "sender": "Ankita",
    "time": "21:30",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "😒",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1441",
    "sender": "Ratnadwip",
    "time": "21:30",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "😭😭😭😭",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1442",
    "sender": "Ratnadwip",
    "time": "21:30",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "please",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1443",
    "sender": "Ankita",
    "time": "21:30",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "😒",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1444",
    "sender": "Ratnadwip",
    "time": "21:30",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "🫦",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1445",
    "sender": "Ankita",
    "time": "21:30",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Ki sob😒",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1446",
    "sender": "Ratnadwip",
    "time": "21:30",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "🫦❤️",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1447",
    "sender": "Ankita",
    "time": "21:30",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Ishhh",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1448",
    "sender": "Ratnadwip",
    "time": "21:31",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "😋😂",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1449",
    "sender": "Ankita",
    "time": "21:31",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "😒",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1450",
    "sender": "Ankita",
    "time": "21:31",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Boddo mar khbi",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1451",
    "sender": "Ratnadwip",
    "time": "21:31",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "STK-20260921-WA0012.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260921-WA0012.webp",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1452",
    "sender": "Ankita",
    "time": "21:31",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Kal ayy",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1453",
    "sender": "Ratnadwip",
    "time": "21:31",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "STK-20260921-WA0013.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260921-WA0013.webp",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1454",
    "sender": "Ankita",
    "time": "21:31",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Ishh chomu public",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1455",
    "sender": "Ratnadwip",
    "time": "21:31",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "STK-20260921-WA0014.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260921-WA0014.webp",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1456",
    "sender": "Ankita",
    "time": "21:31",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "😒",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1457",
    "sender": "Ratnadwip",
    "time": "21:32",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "STK-20260921-WA0015.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260921-WA0015.webp",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1458",
    "sender": "Ankita",
    "time": "21:32",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "😒",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1459",
    "sender": "Ratnadwip",
    "time": "21:32",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "narcissist behaviour, nijer sticker banano",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1460",
    "sender": "Ankita",
    "time": "21:32",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Pgl tui",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1461",
    "sender": "Ratnadwip",
    "time": "21:32",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "#tor_jonno",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1462",
    "sender": "Ratnadwip",
    "time": "21:32",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "STK-20260809-WA0025.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0025.webp",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1463",
    "sender": "Ankita",
    "time": "21:32",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "🤦🏻‍♀️",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1464",
    "sender": "Ratnadwip",
    "time": "21:33",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "cringe + delulu (28% gst)",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1465",
    "sender": "Ankita",
    "time": "21:33",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Tui",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1466",
    "sender": "Ankita",
    "time": "21:33",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Ami na",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1467",
    "sender": "Ratnadwip",
    "time": "21:33",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "STK-20260921-WA0016.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260921-WA0016.webp",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1468",
    "sender": "Ankita",
    "time": "21:33",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "STK-20260827-WA0006.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260827-WA0006.webp",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1469",
    "sender": "Ratnadwip",
    "time": "21:33",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "emaaa",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1470",
    "sender": "Ankita",
    "time": "21:34",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Ki",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1471",
    "sender": "Ratnadwip",
    "time": "21:34",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "petu dekha jache toh",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1472",
    "sender": "Ratnadwip",
    "time": "21:34",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "nom nom",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1473",
    "sender": "Ankita",
    "time": "21:34",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Amr pet na ota",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1474",
    "sender": "Ankita",
    "time": "21:34",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "😒",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1475",
    "sender": "Ratnadwip",
    "time": "21:35",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "STK-20260817-WA0039.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260817-WA0039.webp",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1476",
    "sender": "Ankita",
    "time": "21:35",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Ki sob🤦🏻‍♀️😒",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1477",
    "sender": "Ankita",
    "time": "21:35",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Khali bje nojor",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1478",
    "sender": "Ankita",
    "time": "21:35",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Dara aunty k bolbo",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1479",
    "sender": "Ratnadwip",
    "time": "21:35",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "🧍🏻‍♂️",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1480",
    "sender": "Ratnadwip",
    "time": "21:35",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "naa",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1481",
    "sender": "Ankita",
    "time": "21:35",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Hyaa",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1482",
    "sender": "Ratnadwip",
    "time": "21:35",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "🫩😶‍🌫️",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1483",
    "sender": "Ratnadwip",
    "time": "21:36",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "tor PCA hobe kal",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1484",
    "sender": "Ratnadwip",
    "time": "21:36",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "amar toh kichu nei",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1485",
    "sender": "Ankita",
    "time": "21:39",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Jas na",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1486",
    "sender": "Ankita",
    "time": "21:39",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Best",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1487",
    "sender": "Ratnadwip",
    "time": "21:39",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "bhabchi tai",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1488",
    "sender": "Ankita",
    "time": "21:40",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Asis na akdom asbi na r clg",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1489",
    "sender": "Ratnadwip",
    "time": "21:40",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "STK-20260809-WA0008.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0008.webp",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1490",
    "sender": "Ankita",
    "time": "21:40",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Amr lekha likhey dibi ?",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1491",
    "sender": "Ankita",
    "time": "21:40",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Thaak lagbe na",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1492",
    "sender": "Ratnadwip",
    "time": "21:40",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "handwriting milbe na, de",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1493",
    "sender": "Ankita",
    "time": "21:40",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Sob kintu",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1494",
    "sender": "Ankita",
    "time": "21:40",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Thaak eder k diye lekhabo",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1495",
    "sender": "Ratnadwip",
    "time": "21:41",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "😬😬",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1496",
    "sender": "Ankita",
    "time": "21:41",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Handwriting check kore na",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1497",
    "sender": "Ratnadwip",
    "time": "21:41",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "but sob page e writing style change hole kirom lagbe ?",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1498",
    "sender": "Ankita",
    "time": "21:41",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Hobe na likhte",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1499",
    "sender": "Ankita",
    "time": "21:41",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Tokey",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1500",
    "sender": "Ankita",
    "time": "21:41",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Ami sob pari",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1501",
    "sender": "Ratnadwip",
    "time": "21:41",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "yes",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1502",
    "sender": "Ankita",
    "time": "21:41",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Earki marlm",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1503",
    "sender": "Ratnadwip",
    "time": "21:42",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "STK-20260809-WA0006.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0006.webp",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1504",
    "sender": "Ratnadwip",
    "time": "21:43",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "ekta legendary move pull korechi",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1505",
    "sender": "Ankita",
    "time": "21:45",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Ki move?",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1506",
    "sender": "Ratnadwip",
    "time": "21:45",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1507",
    "sender": "Ankita",
    "time": "21:46",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Wahhh morbi ebr?",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1508",
    "sender": "Ratnadwip",
    "time": "21:46",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "mone hochhe",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1509",
    "sender": "Ankita",
    "time": "21:46",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Aro mesh amr sathey",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1510",
    "sender": "Ratnadwip",
    "time": "21:46",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "okk 🥰😋",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1511",
    "sender": "Ankita",
    "time": "21:46",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Amr thekei gacchey jor ta tor kacchey",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1512",
    "sender": "Ratnadwip",
    "time": "21:46",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "good",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1513",
    "sender": "Ankita",
    "time": "21:47",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Koris na",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1514",
    "sender": "Ankita",
    "time": "21:47",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Rest ne",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1515",
    "sender": "Ankita",
    "time": "21:47",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Aste hobe na kal",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1516",
    "sender": "Ratnadwip",
    "time": "21:47",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "naaaa",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1517",
    "sender": "Ratnadwip",
    "time": "21:47",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "dekhchi",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1518",
    "sender": "Ratnadwip",
    "time": "21:47",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "choto khato bapar",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1519",
    "sender": "Ankita",
    "time": "21:47",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Mar khbi?",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1520",
    "sender": "Ratnadwip",
    "time": "21:47",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "haa, kal giye",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1521",
    "sender": "Ankita",
    "time": "21:47",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Na asbi na kal",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1522",
    "sender": "Ratnadwip",
    "time": "21:47",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "osudh kheyechi",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1523",
    "sender": "Ankita",
    "time": "21:47",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Amro gola byatha khub",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1524",
    "sender": "Ankita",
    "time": "21:48",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Ghuma baba",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1525",
    "sender": "Ankita",
    "time": "21:48",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "🫩🙏",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1526",
    "sender": "Ratnadwip",
    "time": "21:48",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "naa, kome jabe",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1527",
    "sender": "Ratnadwip",
    "time": "21:48",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "kal jabo",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1528",
    "sender": "Ankita",
    "time": "21:48",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Na asbi na",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1529",
    "sender": "Ratnadwip",
    "time": "21:49",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "sorir thik hoye gele jabo",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1530",
    "sender": "Ankita",
    "time": "21:49",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Kichu nei jokhon asbi kno?",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1531",
    "sender": "Ratnadwip",
    "time": "21:49",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "jodi kal beche thaki",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1532",
    "sender": "Ratnadwip",
    "time": "21:49",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "mone hochhe thakbo",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1533",
    "sender": "Ankita",
    "time": "21:49",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Na rest ne sorir thik thakleo asbi na",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1534",
    "sender": "Ratnadwip",
    "time": "21:49",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "pujo deep fried mone hochhe 🥰🥰",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1535",
    "sender": "Ankita",
    "time": "21:49",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Khali baje kotha",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1536",
    "sender": "Ratnadwip",
    "time": "21:50",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "lab toh ache",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1537",
    "sender": "Ankita",
    "time": "21:50",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "😑",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1538",
    "sender": "Ankita",
    "time": "21:50",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Amro sorir khrp noyto na phone korey jhartam",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1539",
    "sender": "Ankita",
    "time": "21:50",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Aste hobe na",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1540",
    "sender": "Ratnadwip",
    "time": "21:50",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "🙏🏻🙏🏻",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1541",
    "sender": "Ratnadwip",
    "time": "21:50",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "i only listen to beautiful women.",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1542",
    "sender": "Ratnadwip",
    "time": "21:50",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "tui bolchis tale jabo na",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1543",
    "sender": "Ankita",
    "time": "21:50",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Hya asis na",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1544",
    "sender": "Ankita",
    "time": "21:51",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "R btw ami beautiful noi",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1545",
    "sender": "Ratnadwip",
    "time": "21:51",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "beautiful - est ?",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1546",
    "sender": "Ankita",
    "time": "21:51",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Na",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1547",
    "sender": "Ratnadwip",
    "time": "21:51",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "😋",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1548",
    "sender": "Ratnadwip",
    "time": "21:51",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "janis na tui",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1549",
    "sender": "Ankita",
    "time": "21:52",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Ki?",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1550",
    "sender": "Ratnadwip",
    "time": "21:52",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "bolbo naaa",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1551",
    "sender": "Ratnadwip",
    "time": "21:52",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "😋😋",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1552",
    "sender": "Ankita",
    "time": "21:52",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Ki bol",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1553",
    "sender": "Ratnadwip",
    "time": "21:52",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "bolbo naaa",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1554",
    "sender": "Ankita",
    "time": "21:52",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Bolosh na",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1555",
    "sender": "Ankita",
    "time": "21:52",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Janteo chai na",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1556",
    "sender": "Ratnadwip",
    "time": "21:52",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "beautifulest hoy naaa, most beautiful hoi",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1557",
    "sender": "Ratnadwip",
    "time": "21:52",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "🫩",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1558",
    "sender": "Ankita",
    "time": "21:52",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Oo",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1559",
    "sender": "Ratnadwip",
    "time": "21:53",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "dhussssss",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1560",
    "sender": "Ratnadwip",
    "time": "21:53",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "sorir thik thakle jabo kal",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1561",
    "sender": "Ankita",
    "time": "22:36",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "😑😑",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1562",
    "sender": "Ankita",
    "time": "22:36",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Asbi na",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1563",
    "sender": "Ratnadwip",
    "time": "22:41",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "🫩🫩",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1564",
    "sender": "Ankita",
    "time": "22:46",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Likhchi dara",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1565",
    "sender": "Ratnadwip",
    "time": "22:58",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "lekh lekh",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1566",
    "sender": "Ratnadwip",
    "time": "22:58",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "amio lekha tei theke jabo mone hoi",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1567",
    "sender": "Ankita",
    "time": "23:01",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Mne??",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1568",
    "sender": "Ratnadwip",
    "time": "23:04",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "luchi khete ichha korche 🫩",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1569",
    "sender": "Ratnadwip",
    "time": "23:04",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "bhalo lagche na",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1570",
    "sender": "Ankita",
    "time": "23:05",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Kal time nei porsu banabo na hpy",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1571",
    "sender": "Ratnadwip",
    "time": "23:05",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "kal ami ar thakbo na mone hoi",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1572",
    "sender": "Ankita",
    "time": "23:05",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Sorir khrp khub?",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1573",
    "sender": "Ratnadwip",
    "time": "23:05",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "haa",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1574",
    "sender": "Ankita",
    "time": "23:06",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Ghumo na ektu..",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1575",
    "sender": "Ratnadwip",
    "time": "23:06",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "asche na",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1576",
    "sender": "Ankita",
    "time": "23:06",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Pore phone ghatis",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1577",
    "sender": "Ankita",
    "time": "23:06",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Ki jala",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1578",
    "sender": "Ankita",
    "time": "23:06",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Kal aste hobe na thle",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1579",
    "sender": "Ratnadwip",
    "time": "23:06",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "dhuss",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1580",
    "sender": "Ratnadwip",
    "time": "23:07",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "ga jolche mone hoche",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1581",
    "sender": "Ankita",
    "time": "23:07",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Ki dhus?",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1582",
    "sender": "Ankita",
    "time": "23:07",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Snan kor ektu",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1583",
    "sender": "Ankita",
    "time": "23:07",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Mathay jol de",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1584",
    "sender": "Ratnadwip",
    "time": "23:07",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "uthte parchi na",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1585",
    "sender": "Ankita",
    "time": "23:07",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Dekhbi jor nambe",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1586",
    "sender": "Ankita",
    "time": "23:07",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Aunty kothay?",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1587",
    "sender": "Ratnadwip",
    "time": "23:07",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "bari",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1588",
    "sender": "Ankita",
    "time": "23:07",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Tui kothay?",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1589",
    "sender": "Ratnadwip",
    "time": "23:07",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "bari",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1590",
    "sender": "Ankita",
    "time": "23:07",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Aunty k call kor",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1591",
    "sender": "Ratnadwip",
    "time": "23:08",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "🫩",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1592",
    "sender": "Ankita",
    "time": "23:08",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Bol aste",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1593",
    "sender": "Ratnadwip",
    "time": "23:08",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "snaan kori",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1594",
    "sender": "Ankita",
    "time": "23:08",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Mar khabi khub lekha bondho kore tokey msg korchi chupchap call kor",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1595",
    "sender": "Ankita",
    "time": "23:08",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Ja snan kor",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1596",
    "sender": "Ratnadwip",
    "time": "23:08",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "lekh",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1597",
    "sender": "Ratnadwip",
    "time": "23:34",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "aii",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1598",
    "sender": "Ratnadwip",
    "time": "23:35",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "lekha done ?",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1599",
    "sender": "Ankita",
    "time": "23:35",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Ai holo",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1600",
    "sender": "Ankita",
    "time": "23:35",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Akhon e holo",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1601",
    "sender": "Ratnadwip",
    "time": "23:36",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "okkk",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1602",
    "sender": "Ratnadwip",
    "time": "23:36",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "ghumiye porlam",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1603",
    "sender": "Ankita",
    "time": "23:36",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Hmn ghuma tui",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1604",
    "sender": "Ankita",
    "time": "23:36",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Sorir bhalo na thakle aste hobeyy na",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1605",
    "sender": "Ratnadwip",
    "time": "23:36",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "kal jabo na 🥲",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1606",
    "sender": "Ankita",
    "time": "23:36",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Hyaa",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1607",
    "sender": "Ankita",
    "time": "23:36",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Thik achey",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1608",
    "sender": "Ratnadwip",
    "time": "23:36",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "sabdhane jas",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1609",
    "sender": "Ankita",
    "time": "23:36",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Rest ne",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1610",
    "sender": "Ankita",
    "time": "23:36",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Hmn",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1611",
    "sender": "Ratnadwip",
    "time": "23:37",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "gn",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1612",
    "sender": "Ankita",
    "time": "23:37",
    "date": "2026-09-21",
    "dateLabel": "21 September 2026",
    "text": "Gn8",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1613",
    "sender": "Ankita",
    "time": "08:44",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "Gm",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1614",
    "sender": "Ratnadwip",
    "time": "08:44",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "gola diye awaj beroche na amar",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1615",
    "sender": "Ratnadwip",
    "time": "08:44",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "gm ❤️",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1616",
    "sender": "Ankita",
    "time": "08:44",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "Uss",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1617",
    "sender": "Ankita",
    "time": "08:44",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "🫩",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1618",
    "sender": "Ratnadwip",
    "time": "08:45",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "jas ni clg ?",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1619",
    "sender": "Ankita",
    "time": "08:45",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "Naa",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1620",
    "sender": "Ankita",
    "time": "08:45",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "Tui?",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1621",
    "sender": "Ankita",
    "time": "08:45",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "Ghumalam e 5 tar por",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1622",
    "sender": "Ratnadwip",
    "time": "08:45",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "ami parbo na",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1623",
    "sender": "Ratnadwip",
    "time": "08:45",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "keno ?",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1624",
    "sender": "Ankita",
    "time": "08:45",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "😶",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1625",
    "sender": "Ratnadwip",
    "time": "08:46",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "ami kal saan kore ese ghumiye porechi",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1626",
    "sender": "Ratnadwip",
    "time": "08:46",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "ektu jor komechilo",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1627",
    "sender": "Ankita",
    "time": "08:46",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "Hmn jni",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1628",
    "sender": "Ratnadwip",
    "time": "08:46",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "ekhon kom, kintu ache jor",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1629",
    "sender": "Ankita",
    "time": "08:47",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "Amro",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1630",
    "sender": "Ankita",
    "time": "08:47",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "Jor achey",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1631",
    "sender": "Ratnadwip",
    "time": "08:47",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "ki korchili ?",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1632",
    "sender": "Ankita",
    "time": "08:47",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "Gola byatha korche etai problem",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1633",
    "sender": "Ankita",
    "time": "08:47",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "Bola jbe na",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1634",
    "sender": "Ratnadwip",
    "time": "08:47",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "🫩🫩",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1635",
    "sender": "Ankita",
    "time": "08:48",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "Bishaal byatha",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1636",
    "sender": "Ankita",
    "time": "08:48",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "Ice-cream kheyei bhul kori",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1637",
    "sender": "Ratnadwip",
    "time": "08:48",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "thik",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1638",
    "sender": "Ankita",
    "time": "08:48",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "Ki?",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1639",
    "sender": "Ratnadwip",
    "time": "08:48",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "🫩🫩",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1640",
    "sender": "Ratnadwip",
    "time": "08:48",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "amake keno bolbi",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1641",
    "sender": "Ratnadwip",
    "time": "08:48",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "thikache",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1642",
    "sender": "Ankita",
    "time": "08:48",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "Uff",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1643",
    "sender": "Ankita",
    "time": "08:49",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "Khali bje kotha",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1644",
    "sender": "Ratnadwip",
    "time": "08:49",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "🙏🏻",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1645",
    "sender": "Ankita",
    "time": "08:49",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "Kichu na sorir bhlo lgchilo na",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1646",
    "sender": "Ankita",
    "time": "08:49",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "Ghum pacchilio e na",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1647",
    "sender": "Ratnadwip",
    "time": "08:49",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "nijer advice ta korte hoto, snaan korte hoto",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1648",
    "sender": "Ratnadwip",
    "time": "08:50",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "2nd half e jaa",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1649",
    "sender": "Ratnadwip",
    "time": "08:50",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "pca ta diye aai",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1650",
    "sender": "Ankita",
    "time": "08:50",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "Hya majh ratey snan korbo emni gym theke ese snan kori",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1651",
    "sender": "Ankita",
    "time": "08:50",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "Na sir k mail korbo ektu pore",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1652",
    "sender": "Ankita",
    "time": "08:50",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "Ba call kore debo",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1653",
    "sender": "Ratnadwip",
    "time": "08:50",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "🧍🏻‍♂️",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1654",
    "sender": "Ankita",
    "time": "08:50",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "Ki?",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1655",
    "sender": "Ankita",
    "time": "08:51",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "Reels dakh",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1656",
    "sender": "Ankita",
    "time": "08:51",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "Suye suye",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1657",
    "sender": "Ratnadwip",
    "time": "08:51",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "tui fake acc khulechis ?",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1658",
    "sender": "Ratnadwip",
    "time": "08:51",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "aditi gupta?",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1659",
    "sender": "Ankita",
    "time": "08:51",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "Na",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1660",
    "sender": "Ankita",
    "time": "08:51",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "Time nei osob er",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1661",
    "sender": "Ratnadwip",
    "time": "08:51",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "🫩",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1662",
    "sender": "Ankita",
    "time": "08:52",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "Hya",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1663",
    "sender": "Ankita",
    "time": "08:52",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "Ami na ota",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1664",
    "sender": "Ratnadwip",
    "time": "08:52",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "tui naa",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1665",
    "sender": "Ratnadwip",
    "time": "08:52",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "IMG-20260922-WA0000.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20260922-WA0000.jpg",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1666",
    "sender": "Ankita",
    "time": "08:52",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "Na ami naa",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1667",
    "sender": "Ratnadwip",
    "time": "08:53",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "jani",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1668",
    "sender": "Ratnadwip",
    "time": "08:53",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "mone ache call korechilo",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1669",
    "sender": "Ankita",
    "time": "08:54",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "Hya",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1670",
    "sender": "Ratnadwip",
    "time": "08:54",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "ki muskil",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1671",
    "sender": "Ankita",
    "time": "08:54",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "Soumo k na bole toke kno bolche?",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1672",
    "sender": "Ratnadwip",
    "time": "08:54",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "ke jane",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1673",
    "sender": "Ankita",
    "time": "08:54",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "😒",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1674",
    "sender": "Ratnadwip",
    "time": "08:54",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "soumya daa abar",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1675",
    "sender": "Ankita",
    "time": "08:55",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "Thle amr fake account bhabli kno?",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1676",
    "sender": "Ankita",
    "time": "08:55",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "🤦🏻‍♀️🤣",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1677",
    "sender": "Ratnadwip",
    "time": "08:55",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "are emni bollam",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1678",
    "sender": "Ankita",
    "time": "08:55",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "😑😒",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1679",
    "sender": "Ratnadwip",
    "time": "08:55",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "sokal sokal meye der msg request <This message was edited>",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1680",
    "sender": "Ankita",
    "time": "08:55",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "😒",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1681",
    "sender": "Ankita",
    "time": "08:55",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "Sorir ta khrp noyto kothai bltm na",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1682",
    "sender": "Ratnadwip",
    "time": "08:56",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "🫩🫩",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1683",
    "sender": "Ankita",
    "time": "08:56",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "😒😒😒",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1684",
    "sender": "Ratnadwip",
    "time": "08:56",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "dhok gilte kosto hochhe",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1685",
    "sender": "Ratnadwip",
    "time": "08:56",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "🥲",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1686",
    "sender": "Ankita",
    "time": "08:56",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "Point",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1687",
    "sender": "Ratnadwip",
    "time": "18:57",
    "date": "2026-09-22",
    "dateLabel": "22 September 2026",
    "text": "Gorom pani diya golar moddhe grrgrrr koro",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1688",
    "sender": "Ratnadwip",
    "time": "02:05",
    "date": "2026-09-23",
    "dateLabel": "23 September 2026",
    "text": "sosta nesha",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1689",
    "sender": "Ratnadwip",
    "time": "02:06",
    "date": "2026-09-23",
    "dateLabel": "23 September 2026",
    "text": "😋",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1690",
    "sender": "Ratnadwip",
    "time": "22:48",
    "date": "2026-09-23",
    "dateLabel": "23 September 2026",
    "text": "https://github.com/ankitaaichhh29/",
    "type": "link",
    "linkUrl": "https://github.com/ankitaaichhh29/",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1691",
    "sender": "Ankita",
    "time": "01:32",
    "date": "2026-09-24",
    "dateLabel": "24 September 2026",
    "text": "IMG-20260924-WA0003.jpg (file attached)\nCheck out this product on Blinkit - Mother Dairy Choco Brownie Ice Cream Tub\nhttps://blinkit.com/prn/x/prid/560112",
    "type": "image",
    "mediaName": "IMG-20260924-WA0003.jpg",
    "linkUrl": "https://blinkit.com/prn/x/prid/560112",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1692",
    "sender": "Ankita",
    "time": "01:33",
    "date": "2026-09-24",
    "dateLabel": "24 September 2026",
    "text": "IMG-20260924-WA0004.jpg (file attached)\nCheck out this product on Blinkit - Hocco Hazelnut Mudslide Ice Cream Cone\nhttps://blinkit.com/prn/x/prid/591479",
    "type": "image",
    "mediaName": "IMG-20260924-WA0004.jpg",
    "linkUrl": "https://blinkit.com/prn/x/prid/591479",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1693",
    "sender": "Ratnadwip",
    "time": "23:51",
    "date": "2026-09-24",
    "dateLabel": "24 September 2026",
    "text": "#good_night",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1694",
    "sender": "Ankita",
    "time": "00:10",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "😤",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1695",
    "sender": "Ankita",
    "time": "00:10",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "Jege ami",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1696",
    "sender": "Ratnadwip",
    "time": "00:10",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "kenooooooo",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1697",
    "sender": "Ratnadwip",
    "time": "00:10",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "sorry",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1698",
    "sender": "Ankita",
    "time": "00:10",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "Sob jama bhijey",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1699",
    "sender": "Ratnadwip",
    "time": "00:10",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "???",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1700",
    "sender": "Ankita",
    "time": "00:10",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "😒",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1701",
    "sender": "Ankita",
    "time": "00:11",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "Dhuye diyechilm",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1702",
    "sender": "Ratnadwip",
    "time": "00:11",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "ac chaliye sukha 🫪",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1703",
    "sender": "Ankita",
    "time": "00:11",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "Tai korchi",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1704",
    "sender": "Ratnadwip",
    "time": "00:11",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "onno jama por",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1705",
    "sender": "Ankita",
    "time": "00:11",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "Juto r laces poralm",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1706",
    "sender": "Ankita",
    "time": "00:11",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "Sob mne sob",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1707",
    "sender": "Ratnadwip",
    "time": "00:11",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "aglet",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1708",
    "sender": "Ratnadwip",
    "time": "00:11",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "🫪🫪",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1709",
    "sender": "Ankita",
    "time": "00:11",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "🫩",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1710",
    "sender": "Ratnadwip",
    "time": "00:11",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "saree",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1711",
    "sender": "Ratnadwip",
    "time": "00:11",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "🤣🤣",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1712",
    "sender": "Ankita",
    "time": "00:12",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "Mar khbi?",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1713",
    "sender": "Ratnadwip",
    "time": "00:12",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "🫡🫡",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1714",
    "sender": "Ankita",
    "time": "00:12",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "Marbo na r tok",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1715",
    "sender": "Ratnadwip",
    "time": "00:12",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "😭😭😭",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1716",
    "sender": "Ankita",
    "time": "00:12",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "😒",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1717",
    "sender": "Ankita",
    "time": "00:12",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "Hmn",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1718",
    "sender": "Ratnadwip",
    "time": "00:12",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "😭😭😭",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1719",
    "sender": "Ankita",
    "time": "00:12",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "R marbo na",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1720",
    "sender": "Ratnadwip",
    "time": "00:12",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "😭😭😭😭😭😭",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1721",
    "sender": "Ankita",
    "time": "00:12",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "Kaaj holo?",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1722",
    "sender": "Ratnadwip",
    "time": "00:12",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "raag koris naaaa maaaa",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1723",
    "sender": "Ratnadwip",
    "time": "00:13",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "onno idea explore korchi",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1724",
    "sender": "Ratnadwip",
    "time": "00:13",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "🫩",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1725",
    "sender": "Ankita",
    "time": "00:13",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "Korle tor ki?",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1726",
    "sender": "Ratnadwip",
    "time": "00:13",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "sob kichu",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1727",
    "sender": "Ankita",
    "time": "00:13",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "Oe kor",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1728",
    "sender": "Ankita",
    "time": "00:13",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "Na",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1729",
    "sender": "Ankita",
    "time": "00:13",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "Kono kichui noy",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1730",
    "sender": "Ratnadwip",
    "time": "00:13",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "not gate(na)",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1731",
    "sender": "Ankita",
    "time": "00:13",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "😒",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1732",
    "sender": "Ratnadwip",
    "time": "00:13",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "ble ta jhamela boddo",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1733",
    "sender": "Ankita",
    "time": "00:13",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "Birokto kor",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1734",
    "sender": "Ratnadwip",
    "time": "00:13",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "🫪",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1735",
    "sender": "Ankita",
    "time": "00:14",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "Agei bolechilo",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1736",
    "sender": "Ankita",
    "time": "00:14",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "Ginipig",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1737",
    "sender": "Ratnadwip",
    "time": "00:14",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "difficult part ta hoye gache",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1738",
    "sender": "Ratnadwip",
    "time": "00:14",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "easy ta hochhe na",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1739",
    "sender": "Ratnadwip",
    "time": "00:14",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "hochhe na toh hochhe e na",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1740",
    "sender": "Ankita",
    "time": "00:14",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "🫩🫩",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1741",
    "sender": "Ankita",
    "time": "00:14",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "Hobey hobey",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1742",
    "sender": "Ankita",
    "time": "00:14",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "Try kor",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1743",
    "sender": "Ratnadwip",
    "time": "00:15",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "korchiiii",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1744",
    "sender": "Ankita",
    "time": "00:15",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "Aj kotha bolchi na karon pasey maa noyto call kortam",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1745",
    "sender": "Ratnadwip",
    "time": "00:15",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "ok 🫡",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1746",
    "sender": "Ratnadwip",
    "time": "00:15",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "janis, 27 tarik bank khola thakbe 🫪",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1747",
    "sender": "Ankita",
    "time": "00:15",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "Mere uriye debe jdi ogo kigo sone🤣",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1748",
    "sender": "Ratnadwip",
    "time": "00:15",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "SBI",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1749",
    "sender": "Ankita",
    "time": "00:15",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "Jni",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1750",
    "sender": "Ankita",
    "time": "00:16",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "Jni",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1751",
    "sender": "Ankita",
    "time": "00:16",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "Sob bank",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1752",
    "sender": "Ankita",
    "time": "00:16",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "Not only SBI",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1753",
    "sender": "Ratnadwip",
    "time": "00:16",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "😅😅",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1754",
    "sender": "Ratnadwip",
    "time": "00:16",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "keno ?",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1755",
    "sender": "Ankita",
    "time": "00:16",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "PNB and etc.",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1756",
    "sender": "Ankita",
    "time": "00:16",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "3 days strike",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1757",
    "sender": "Ankita",
    "time": "00:16",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "That's whyy",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1758",
    "sender": "Ratnadwip",
    "time": "00:16",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "ooooh",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1759",
    "sender": "Ankita",
    "time": "00:16",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "Sob bank strike",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1760",
    "sender": "Ratnadwip",
    "time": "00:16",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "jantam naa",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1761",
    "sender": "Ankita",
    "time": "00:17",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "Jnbi ki kore amr theke mon sorale toh jnbi",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1762",
    "sender": "Ratnadwip",
    "time": "00:17",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "STK-20260921-WA0016.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260921-WA0016.webp",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1763",
    "sender": "Ankita",
    "time": "00:19",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "STK-20260925-WA0002.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260925-WA0002.webp",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1764",
    "sender": "Ratnadwip",
    "time": "00:19",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "eta kih 🤣",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1765",
    "sender": "Ankita",
    "time": "00:19",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "Tui agey guiter niye thaktu",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1766",
    "sender": "Ankita",
    "time": "00:19",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "R akhon tui bhab",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1767",
    "sender": "Ratnadwip",
    "time": "00:19",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "aj purono bou ke bar korechilam",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1768",
    "sender": "Ratnadwip",
    "time": "00:20",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "balika badhu",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1769",
    "sender": "Ankita",
    "time": "00:20",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "Akhon sudhu jalash amy",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1770",
    "sender": "Ratnadwip",
    "time": "00:20",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "🧍🏻‍♂️",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1771",
    "sender": "Ankita",
    "time": "00:20",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "🤦🏻‍♀️",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1772",
    "sender": "Ankita",
    "time": "00:20",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "Koris na esob",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1773",
    "sender": "Ratnadwip",
    "time": "00:20",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "STK-20260812-WA0008.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260812-WA0008.webp",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1774",
    "sender": "Ankita",
    "time": "00:20",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "Kal jdi dekhi esob mere uriye dbo",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1775",
    "sender": "Ratnadwip",
    "time": "00:21",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "🫩",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1776",
    "sender": "Ratnadwip",
    "time": "00:21",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "age project ta sort out korte hobe",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1777",
    "sender": "Ratnadwip",
    "time": "00:21",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "tarpor",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1778",
    "sender": "Ratnadwip",
    "time": "00:22",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "ghumaaa, kal. ghumate debo na ami",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1779",
    "sender": "Ankita",
    "time": "00:22",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "Kihh??",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1780",
    "sender": "Ratnadwip",
    "time": "00:22",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "kal ami ghumabo... tora korbi project",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1781",
    "sender": "Ankita",
    "time": "00:22",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "Taii??",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1782",
    "sender": "Ratnadwip",
    "time": "00:23",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "🙋🏻",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1783",
    "sender": "Ankita",
    "time": "00:23",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "Ami ki ki korte pari jnis?",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1784",
    "sender": "Ratnadwip",
    "time": "00:23",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "ki gooo ?",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1785",
    "sender": "Ankita",
    "time": "00:23",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "😒",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1786",
    "sender": "Ankita",
    "time": "00:23",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "Ota bolle toh team jitey jbe",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1787",
    "sender": "Ankita",
    "time": "00:23",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "Ig",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1788",
    "sender": "Ratnadwip",
    "time": "00:23",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "🫪",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1789",
    "sender": "Ankita",
    "time": "00:24",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "Mne ki goo jdi bli",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1790",
    "sender": "Ankita",
    "time": "00:24",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "STK-20260831-WA0033.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260831-WA0033.webp",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1791",
    "sender": "Ratnadwip",
    "time": "00:24",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "🫪🫪",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1792",
    "sender": "Ankita",
    "time": "00:24",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "Ki holo?",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1793",
    "sender": "Ankita",
    "time": "00:24",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "Ghum nei chokey?",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1794",
    "sender": "Ratnadwip",
    "time": "00:24",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "haa",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1795",
    "sender": "Ratnadwip",
    "time": "00:25",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "pgl er moto obostha",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1796",
    "sender": "Ankita",
    "time": "00:25",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "Then ghuma skl a bike chalabi",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1797",
    "sender": "Ankita",
    "time": "00:25",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "Ghum pabe",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1798",
    "sender": "Ankita",
    "time": "00:25",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "Keu thakbe na sathey",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1799",
    "sender": "Ratnadwip",
    "time": "00:25",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "😭😭",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1800",
    "sender": "Ankita",
    "time": "00:26",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "Gari chalate prblm hobe",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1801",
    "sender": "Ankita",
    "time": "00:26",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "Trpr deri hobe",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1802",
    "sender": "Ratnadwip",
    "time": "00:26",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "deri hobe na",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1803",
    "sender": "Ratnadwip",
    "time": "00:26",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "ekdom time e asbo",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1804",
    "sender": "Ankita",
    "time": "00:26",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "Jni",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1805",
    "sender": "Ankita",
    "time": "00:26",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "But ghumo",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1806",
    "sender": "Ankita",
    "time": "00:26",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "Ami ghumalam",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1807",
    "sender": "Ratnadwip",
    "time": "00:27",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "okiee ❤️",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1808",
    "sender": "Ratnadwip",
    "time": "00:27",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "10 min",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1809",
    "sender": "Ratnadwip",
    "time": "00:27",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "ghumiye porbo",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1810",
    "sender": "Ankita",
    "time": "00:27",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "Ki sob emoji🤦🏻‍♀️",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1811",
    "sender": "Ankita",
    "time": "00:27",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "Hmn",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1812",
    "sender": "Ratnadwip",
    "time": "00:27",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "🥰",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1813",
    "sender": "Ankita",
    "time": "00:27",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "Ghumalm ami",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1814",
    "sender": "Ankita",
    "time": "00:27",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "Chii",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1815",
    "sender": "Ratnadwip",
    "time": "00:27",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "🐬",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1816",
    "sender": "Ratnadwip",
    "time": "02:26",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "damn",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1817",
    "sender": "Ankita",
    "time": "15:53",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "Ki?",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1818",
    "sender": "Ratnadwip",
    "time": "15:54",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "ogoo",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1819",
    "sender": "Ankita",
    "time": "15:54",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "Koris na kaney kaney kotha start",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1820",
    "sender": "Ratnadwip",
    "time": "15:54",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "STK-20260809-WA0012.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0012.webp",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1821",
    "sender": "Ankita",
    "time": "15:55",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "STK-20260811-WA0000.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260811-WA0000.webp",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1822",
    "sender": "Ankita",
    "time": "18:28",
    "date": "2026-09-25",
    "dateLabel": "25 September 2026",
    "text": "",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1823",
    "sender": "Ratnadwip",
    "time": "06:13",
    "date": "2026-09-26",
    "dateLabel": "26 September 2026",
    "text": "Vulture-Android15-debug.apk (file attached)\nVulture-Android15-debug.apk",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1824",
    "sender": "Ankita",
    "time": "22:19",
    "date": "2026-09-26",
    "dateLabel": "26 September 2026",
    "text": "",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1825",
    "sender": "Ratnadwip",
    "time": "10:51",
    "date": "2026-09-28",
    "dateLabel": "28 September 2026",
    "text": "😂",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1826",
    "sender": "Ratnadwip",
    "time": "19:58",
    "date": "2026-09-29",
    "dateLabel": "29 September 2026",
    "text": "https://eps.eshiksa.net/DirectFeesv3/HooghlyEngineeringCollege",
    "type": "link",
    "linkUrl": "https://eps.eshiksa.net/DirectFeesv3/HooghlyEngineeringCollege",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1827",
    "sender": "Ratnadwip",
    "time": "20:59",
    "date": "2026-09-29",
    "dateLabel": "29 September 2026",
    "text": "6530972705008528",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1828",
    "sender": "Ankita",
    "time": "21:23",
    "date": "2026-09-29",
    "dateLabel": "29 September 2026",
    "text": "IMG-20260929-WA0007.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20260929-WA0007.jpg",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1829",
    "sender": "Ratnadwip",
    "time": "21:58",
    "date": "2026-09-29",
    "dateLabel": "29 September 2026",
    "text": "<Media omitted>",
    "type": "image",
    "mediaName": "Photo",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1830",
    "sender": "Ratnadwip",
    "time": "21:59",
    "date": "2026-09-29",
    "dateLabel": "29 September 2026",
    "text": "wait",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1831",
    "sender": "Ankita",
    "time": "21:59",
    "date": "2026-09-29",
    "dateLabel": "29 September 2026",
    "text": "Ki wait?",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1832",
    "sender": "Ratnadwip",
    "time": "00:03",
    "date": "2026-09-30",
    "dateLabel": "30 September 2026",
    "text": "STK-20260929-WA0010.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260929-WA0010.webp",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1833",
    "sender": "Ankita",
    "time": "00:04",
    "date": "2026-09-30",
    "dateLabel": "30 September 2026",
    "text": "STK-20260830-WA0008.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260830-WA0008.webp",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1834",
    "sender": "Ratnadwip",
    "time": "17:02",
    "date": "2026-09-30",
    "dateLabel": "30 September 2026",
    "text": "I already have an existing SIH presentation open in Google Slides.\nIMPORTANT:\nModify the existing presentation. Do NOT create a new presentation from scratch.\nThe existing deck already contains the team information, names, college details, logos and other identity information.\nDo not modify the team information unless absolutely necessary.\nKeep the existing visual identity, typography, spacing and overall design language wherever possible.\nThe presentation must now be adapted for:\nSIH26231\nDigital Companion for Field Drug Testing\nOur product name is:\nFIELDTEST\nFieldTest is a digital companion that works alongside existing colorimetric field drug-testing kits.\nThe final presentation must contain exactly these six content slides:\n1. TITLE\n2. FIELDTEST — THE CORE PROBLEM\n3. TECHNICAL APPROACH\n4. FEASIBILITY & VIABILITY\n5. IMPACT & BENEFITS\n6. RESEARCH & REFERENCES\nDo not add unnecessary slides.\nSLIDE 1 — TITLE\nDO NOT CHANGE THE EXISTING TEAM INFORMATION.\nPreserve the current title-slide layout and team details.\nOnly ensure that the project title is correctly represented as:\nSIH26231\nFIELDTEST\nDigital Companion for Field Drug Testing\nIf the existing slide already contains the SIH problem statement number, organization, team name, college and member information, preserve those elements.\nDo not redesign the team section.\nThe title should visually establish:\nFIELDTEST\nas the product name.\nA suitable short descriptor:\nDigital intelligence around the field test.\nDo not overcrowd the slide.\nSLIDE 2 — FIELDTEST\nTHE CORE PROBLEM\nThis is the most important conceptual slide.\nThe slide should immediately answer:\nWhat problem are we solving?\nUse the heading:\nFIELDTEST\nThe gap isn't the test. It's everything around it.\nExplain that existing colorimetric field-testing kits already provide a physical test mechanism.\nThe problem is the surrounding workflow:\nTODAY\nPhysical test\n↓\nOfficer visually interprets colour\n↓\nPhotograph / manual observation\n↓\nManual documentation\n↓\nFragmented record\n↓\nSupervisor receives information later\nThis creates several operational gaps:\n- Colour interpretation can vary with lighting and environmental conditions.\n- Captured test images may lack standardised context.\n- Operator, timestamp, location and test result may be recorded separately.\n- Supervisors have limited real-time visibility.\n- Historical tests are difficult to search and compare systematically.\n- There is no single tamper-evident digital record connecting the test, image and audit history.\nThen introduce FieldTest:\nFIELDTEST\nCapture → Calibrate → Analyse → Verify → Record\nFieldTest does NOT replace the physical test kit.\nIt creates a digital layer around it.\nUse a concise statement:\nFieldTest transforms a physical field reaction into a structured, traceable and tamper-evident digital record.\nIMPORTANT:\nDo NOT claim that the current field-testing process is invalid or unreliable.\nThe problem is digitisation, standardisation and traceability, not the existence of the physical test itself.\nDo not use unsupported statistics.\nSLIDE 3 — TECHNICAL APPROACH\nThis slide must explain exactly how FieldTest works technically.\nDo not make this a generic technology-stack slide.\nThe evaluator should understand the actual technical pipeline.\nCreate a central pipeline:\n01 — CAPTURE\nSmartphone camera captures the field-test reaction.\nMetadata:\n- operator\n- timestamp\n- GPS\n- test-kit type\n- sample reference\n↓\n02 — IMAGE QUALITY\nThe system checks:\n- sharpness\n- exposure\n- glare\n- framing\n- reference-card visibility\n- test-region visibility\nIf quality is insufficient:\nRETAKE\nThe system does not force a classification from a bad image.\n↓\n03 — COLOUR CALIBRATION\nA reference colour card is detected.\nThe image is normalised against known reference colours.\nUse colour spaces such as:\nRGB → HSV / LAB\nThis reduces the effect of lighting and camera conditions.\n↓\n04 — TEST REGION DETECTION\nThe system identifies the relevant reaction region.\nShow:\nCaptured Image\n→\nReference Card\n→\nTest ROI\n↓\n05 — CLASSIFICATION\nThe calibrated colour response is analysed.\nOutput:\nPOSITIVE\nNEGATIVE\nor\nINCONCLUSIVE\nwith a classification confidence.\nIMPORTANT:\nUse:\nPRESUMPTIVE FIELD-TEST RESULT\nDo NOT say:\n\"confirmed drug detection.\"\n↓\n06 — DIGITAL RECORD\nGenerate:\n- Test ID\n- result\n- confidence\n- timestamp\n- location\n- operator\n- image hash\n- record hash\n- classifier version\n↓\n07 — INTEGRITY\nUse SHA-256 hashing.\nCreate a hash-linked audit trail:\nEVENT 01\n↓\nEVENT 02\n↓\nEVENT 03\n↓\nEVENT 04\nResult:\nINTEGRITY VERIFIED\nTECHNOLOGY STACK\nPlace this as a compact strip at the bottom rather than dominating the slide:\nReact + TypeScript + Vite\nComputer Vision / Image Processing\nSupabase / PostgreSQL\nWeb Crypto API / SHA-256\nOffline Storage\nVercel\nIf there is enough space, show:\nField Layer\nSmartphone + Camera + GPS\nIntelligence Layer\nComputer Vision + Calibration + Classification\nData Layer\nSupabase + PostgreSQL\nOperations Layer\nWall Mode Dashboard\nSLIDE 4 — FEASIBILITY & VIABILITY\nThis slide must answer:\nCan this actually be built and deployed?\nDivide the slide into four sections.\n01 — TECHNICAL FEASIBILITY\nFieldTest uses technologies already available on modern smartphones:\n- Camera\n- GPS\n- Local storage\n- Browser/mobile computing\nThe image-analysis pipeline can begin with deterministic computer-vision methods such as:\n- colour-space conversion\n- reference calibration\n- colour distance\n- region sampling\n- threshold-based classification\nThe architecture is modular, allowing validated models to replace or augment the prototype classifier later.\n02 — OPERATIONAL FEASIBILITY\nThe workflow is designed around the existing field procedure.\nThe officer does not need to learn an entirely new testing process.\nInstead:\nExisting test kit\n- \nFieldTest mobile workflow\n=\nDigitised field test\nLarge touch targets and a short guided workflow make the application suitable for field use.\n03 — OFFLINE-FIRST\nField environments may have unreliable connectivity.\nFieldTest therefore supports:\nCAPTURE OFFLINE\n↓\nSTORE LOCALLY\n↓\nQUEUE RECORD\n↓\nNETWORK AVAILABLE\n↓\nSYNCHRONISE\nThe application should never falsely report a record as uploaded when it has not been synchronized.\n04 — VIABILITY & DEPLOYMENT\nNo specialised hardware is required for the software prototype.\nDeployment architecture:\nSmartphone\n→\nFieldTest\n→\nCloud / Local Sync\n→\nCentral Database\n→\nSupervisor Wall Dashboard\nThe same architecture can support multiple field teams.\nSCALABILITY\nInclude a small visual at the bottom:\n1 OFFICER\n→\nFIELD TEAM\n→\nDISTRICT\n→\nSTATE\n→\nNATIONAL\nExplain:\nThe frontend can be deployed centrally.\nThe database can scale horizontally.\nAnalysis services can be separated from the application.\nAdditional validated test-kit configurations can be introduced without redesigning the entire system.\nSLIDE 5 — IMPACT & BENEFITS\nThis slide should focus on real operational impact, not generic statements.\nUse four columns or quadrants.\nFIELD OFFICER\nFaster documentation\n- Guided test workflow\n- Automated metadata capture\n- Reduced manual entry\n- Immediate test-record creation\nSUPERVISOR\nReal-time visibility\n- Wall Mode dashboard\n- Live field activity\n- Searchable records\n- Inconclusive/flagged test visibility\nORGANIZATION\nTraceability\n- Standardised records\n- Centralised test history\n- Operator accountability\n- Audit trail\nSYSTEM\nVerifiable records\n- Original image retained\n- SHA-256 image hash\n- Record hash\n- Hash-linked audit events\n- Integrity verification\nBEFORE → AFTER\nCreate a strong visual comparison:\nBEFORE\nPhysical test\n↓\nManual observation\n↓\nPhotograph\n↓\nPaper / fragmented record\n↓\nDelayed review\nversus\nFIELDTEST\nPhysical test\n↓\nStandardised capture\n↓\nCalibration\n↓\nPresumptive classification\n↓\nDigital record\n↓\nReal-time supervisor visibility\n↓\nIntegrity verification\nSCALE IMPACT\nAt the bottom:\nOne application can connect individual field tests to a searchable operational system.\nPotential long-term benefits:\n- standardised digital workflows\n- faster supervisory review\n- better record traceability\n- structured operational data\n- easier auditing\n- scalable field deployment\nDo NOT invent numerical claims about percentage improvements.\nDo NOT claim proven nationwide impact.\nUse language such as:\n\"Potential impact at scale\"\nwhere appropriate.\nSLIDE 6 — RESEARCH & REFERENCES\nThis slide should establish that FieldTest is based on actual technical concepts rather than a purely conceptual hackathon idea.\nTitle:\nRESEARCH & REFERENCES\nDivide references into four categories.\n01 — FIELD DRUG TESTING\nInclude credible references concerning:\n- colourimetric presumptive drug testing\n- field-testing procedures\n- limitations of visual colour interpretation\n- forensic drug screening\nUse authoritative sources wherever possible, particularly:\nUNODC\nNIST\nSWGDRUG\nDEA / relevant forensic guidance\nDo not invent paper titles.\n02 — COMPUTER VISION & COLOUR ANALYSIS\nReference established technical concepts:\n- RGB / HSV / CIELAB colour spaces\n- colour difference / ΔE\n- image colour calibration\n- image quality assessment\n- region-of-interest detection\nUse peer-reviewed papers or authoritative technical documentation.\n03 — DIGITAL INTEGRITY\nReference:\nNIST\nfor cryptographic hashing / SHA-256 concepts.\nExplain briefly:\nSHA-256 is used to generate deterministic fingerprints of captured data and records, enabling tamper detection.\nDo not describe hashing as encryption.\nDo not describe hashing as blockchain.\n04 — OFFLINE / DISTRIBUTED SYSTEM DESIGN\nReference technical concepts around:\n- offline-first applications\n- local persistence\n- eventual synchronization\n- resilient mobile applications\nREFERENCE RULE\nUse real, verifiable references only.\nDo not create fake citations.\nDo not fabricate research papers.\nDo not use random SEO websites.\nPrefer:\n- government sources\n- standards organizations\n- peer-reviewed research\n- university publications\n- official technical documentation\nKeep the reference text small but readable.\nIf there are too many references, select the most relevant 6–10.\nVISUAL STYLE\nPreserve the existing presentation's visual identity.\nDo not redesign the entire deck.\nHowever, adapt the visuals to FieldTest.\nThe visual language should communicate:\nFIELD\nTECHNOLOGY\nTRACEABILITY\nFORENSICS\nOPERATIONS\nAvoid generic AI imagery.\nDo NOT use:\n- glowing AI brains\n- humanoid robots\n- random laboratory stock photography\n- DNA graphics unrelated to the solution\n- excessive 3D elements\n- blockchain imagery\n- generic \"AI\" icons\nPrefer:\n- smartphone UI\n- physical test-kit representation\n- camera frame\n- colour reference card\n- image-analysis overlays\n- workflow diagrams\n- wall dashboard\n- audit timeline\n- hash verification\n- operational maps\nPRODUCT VISUAL\nThe product is called:\nFIELDTEST\nUse this name consistently.\nSuggested descriptor:\nDigital Companion for Field Drug Testing\nSuggested short positioning:\nDigitising the field-test workflow without replacing the field test.\nCRITICAL SCIENTIFIC POSITIONING\nThis must be consistent across the entire deck.\nFieldTest does NOT claim to chemically identify a drug with laboratory certainty.\nThe system produces a:\nPRESUMPTIVE FIELD-TEST RESULT\nThe physical test remains the underlying chemical reaction.\nThe software:\n- captures\n- standardises\n- analyses\n- documents\n- verifies\n- stores\nthe result.\nUse:\n\"Laboratory confirmation remains necessary where required.\"\nDo not use:\n\"100% accurate\"\n\"confirmed drug detection\"\n\"forensically proven\"\n\"legally admissible\"\n\"replaces laboratory testing\"\nunless explicitly supported by a future validation study.\nPRESENTATION STORY\nThe six slides should tell one continuous story:\nSLIDE 1\nWhat is FieldTest?\n↓\nSLIDE 2\nWhat problem does it solve?\n↓\nSLIDE 3\nHow does the technology solve it?\n↓\nSLIDE 4\nCan it actually work and scale?\n↓\nSLIDE 5\nWhat changes if it is deployed?\n↓\nSLIDE 6\nWhat research and technical foundations support it?\nThe evaluator should understand the entire project after these six slides without needing additional explanation.\nIMPORTANT EDITING RULES\nDo not change existing:\n- team names\n- member information\n- college information\n- registration information\n- logos\n- required SIH identity information\nunless they contain information directly belonging to the old project.\nRemove only content that belongs to the old project.\nReplace old project-specific:\n- diagrams\n- screenshots\n- terminology\n- metrics\n- architecture\n- problem statements\n- workflows\nwith FieldTest equivalents.\nMaintain the current slide dimensions.\nMaintain the current font hierarchy.\nMaintain the current visual rhythm.\nDo not turn the deck into a generic new template.\nFINAL QUALITY CHECK\nBefore finishing, inspect every slide.\nThere must be exactly:\n6 slides\n1\nTITLE\n2\nFIELDTEST — THE CORE PROBLEM\n3\nTECHNICAL APPROACH\n4\nFEASIBILITY & VIABILITY\n5\nIMPACT & BENEFITS\n6\nRESEARCH & REFERENCES\nThe presentation should feel like:\na serious SIH engineering proposal\nrather than:\na marketing presentation.\nThe most important visual element should be the FieldTest workflow:\nPHYSICAL TEST\n→\nCAPTURE\n→\nCALIBRATE\n→\nANALYSE\n→\nVERIFY\n→\nDIGITAL RECORD\n→\nWALL MODE\nMake the deck concise, technically credible and visually strong.\nDo not invent data.\nDo not invent research.\nDo not invent deployment statistics.\nDo not overclaim accuracy.\nMake the evaluator understand the problem, the engineering, the feasibility and the potential impact within six slides. EXPORT AS A PDF",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1835",
    "sender": "Ratnadwip",
    "time": "17:03",
    "date": "2026-09-30",
    "dateLabel": "30 September 2026",
    "text": "<Media omitted>\nlayout.pptx",
    "type": "image",
    "mediaName": "Photo",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1836",
    "sender": "Ratnadwip",
    "time": "22:13",
    "date": "2026-09-30",
    "dateLabel": "30 September 2026",
    "text": "https://hackinverse-s1.devfolio.co/application",
    "type": "link",
    "linkUrl": "https://hackinverse-s1.devfolio.co/application",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1837",
    "sender": "Ratnadwip",
    "time": "22:14",
    "date": "2026-09-30",
    "dateLabel": "30 September 2026",
    "text": "<Media omitted>\nfalacy.pptx",
    "type": "image",
    "mediaName": "Photo",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1838",
    "sender": "Ratnadwip",
    "time": "22:14",
    "date": "2026-09-30",
    "dateLabel": "30 September 2026",
    "text": "31865be21a",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1839",
    "sender": "Ratnadwip",
    "time": "23:44",
    "date": "2026-09-30",
    "dateLabel": "30 September 2026",
    "text": "kal clg jacchi na, sesh achi aaj",
    "type": "text",
    "milestone": "Hackathon & Closeness"
  },
  {
    "id": "m_1840",
    "sender": "Ankita",
    "time": "07:44",
    "date": "2026-10-01",
    "dateLabel": "1 October 2026",
    "text": "Ayyy naaa",
    "type": "text",
    "milestone": "Durga Puja Outing"
  },
  {
    "id": "m_1841",
    "sender": "Ratnadwip",
    "time": "17:51",
    "date": "2026-10-02",
    "dateLabel": "2 October 2026",
    "text": "DOC-20261002-WA0013.pdf (file attached)",
    "type": "document",
    "mediaName": "DOC-20261002-WA0013.pdf",
    "milestone": "Durga Puja Outing"
  },
  {
    "id": "m_1842",
    "sender": "Ankita",
    "time": "18:16",
    "date": "2026-10-02",
    "dateLabel": "2 October 2026",
    "text": "🙄",
    "type": "text",
    "milestone": "Durga Puja Outing"
  },
  {
    "id": "m_1843",
    "sender": "Ankita",
    "time": "21:05",
    "date": "2026-10-02",
    "dateLabel": "2 October 2026",
    "text": "",
    "type": "text",
    "milestone": "Durga Puja Outing"
  },
  {
    "id": "m_1844",
    "sender": "Ratnadwip",
    "time": "21:05",
    "date": "2026-10-02",
    "dateLabel": "2 October 2026",
    "text": "",
    "type": "text",
    "milestone": "Durga Puja Outing"
  },
  {
    "id": "m_1845",
    "sender": "Ratnadwip",
    "time": "22:23",
    "date": "2026-10-03",
    "dateLabel": "3 October 2026",
    "text": "",
    "type": "text",
    "milestone": "Durga Puja Outing"
  },
  {
    "id": "m_1846",
    "sender": "Ratnadwip",
    "time": "14:01",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "577fb4c9fe",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1847",
    "sender": "Ratnadwip",
    "time": "14:06",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "https://devnexus2.devfolio.co/application",
    "type": "link",
    "linkUrl": "https://devnexus2.devfolio.co/application",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1848",
    "sender": "Ankita",
    "time": "17:59",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1849",
    "sender": "Ratnadwip",
    "time": "17:59",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "niye ne",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1850",
    "sender": "Ankita",
    "time": "18:00",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "Poysa nei",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1851",
    "sender": "Ankita",
    "time": "18:00",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "😑",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1852",
    "sender": "Ratnadwip",
    "time": "18:00",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "koto ?",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1853",
    "sender": "Ankita",
    "time": "18:00",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "Jni na",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1854",
    "sender": "Ratnadwip",
    "time": "18:01",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "jigasa kor",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1855",
    "sender": "Ankita",
    "time": "18:01",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "120 bolche",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1856",
    "sender": "Ratnadwip",
    "time": "18:01",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "niye ne",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1857",
    "sender": "Ratnadwip",
    "time": "18:02",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "qr send kore de amake <This message was edited>",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1858",
    "sender": "Ankita",
    "time": "18:02",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "Huss na",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1859",
    "sender": "Ankita",
    "time": "18:02",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "Besi daam",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1860",
    "sender": "Ankita",
    "time": "18:02",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "Na nebo na",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1861",
    "sender": "Ratnadwip",
    "time": "18:02",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "naah",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1862",
    "sender": "Ankita",
    "time": "18:02",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "Bekar jinis",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1863",
    "sender": "Ankita",
    "time": "18:02",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "Hya",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1864",
    "sender": "Ankita",
    "time": "18:02",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "Thaak",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1865",
    "sender": "Ankita",
    "time": "18:02",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "Lgbe na",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1866",
    "sender": "Ratnadwip",
    "time": "18:02",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "🤨🤨",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1867",
    "sender": "Ratnadwip",
    "time": "18:02",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "bhalo e toh",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1868",
    "sender": "Ankita",
    "time": "18:03",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "Bhlo but nebo na",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1869",
    "sender": "Ratnadwip",
    "time": "18:03",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "nee",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1870",
    "sender": "Ratnadwip",
    "time": "18:03",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "pore diye dis amake taka",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1871",
    "sender": "Ankita",
    "time": "18:03",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "Na choley gacchey",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1872",
    "sender": "Ankita",
    "time": "18:03",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "Na",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1873",
    "sender": "Ratnadwip",
    "time": "18:03",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "🧍🏻‍♂️",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1874",
    "sender": "Ankita",
    "time": "18:03",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "😑",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1875",
    "sender": "Ratnadwip",
    "time": "18:03",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "deke aan",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1876",
    "sender": "Ankita",
    "time": "18:03",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "😑😑",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1877",
    "sender": "Ankita",
    "time": "18:03",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "Naa",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1878",
    "sender": "Ratnadwip",
    "time": "18:03",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "🤨",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1879",
    "sender": "Ankita",
    "time": "18:03",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "Bari nambo",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1880",
    "sender": "Ratnadwip",
    "time": "18:03",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "orchid ta kothay bp te ?",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1881",
    "sender": "Ankita",
    "time": "18:03",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "Hya ig",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1882",
    "sender": "Ankita",
    "time": "18:04",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "Kno?",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1883",
    "sender": "Ratnadwip",
    "time": "18:04",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "jabi ?",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1884",
    "sender": "Ankita",
    "time": "18:04",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "Kobe?",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1885",
    "sender": "Ratnadwip",
    "time": "18:04",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "ke jane, tui bol",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1886",
    "sender": "Ankita",
    "time": "18:04",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "Poysa nei",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1887",
    "sender": "Ankita",
    "time": "18:04",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "Jbo na",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1888",
    "sender": "Ratnadwip",
    "time": "18:04",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "ouh",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1889",
    "sender": "Ankita",
    "time": "18:04",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "Hm",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1890",
    "sender": "Ratnadwip",
    "time": "18:04",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "dhuss, jata kotha barta",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1891",
    "sender": "Ratnadwip",
    "time": "18:04",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "ei bolchili je haa bolbi",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1892",
    "sender": "Ratnadwip",
    "time": "18:05",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "esob ki type er excuse",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1893",
    "sender": "Ankita",
    "time": "18:06",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "😒",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1894",
    "sender": "Ratnadwip",
    "time": "18:06",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "🫪🫪",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1895",
    "sender": "Ankita",
    "time": "18:07",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "Orchid a amr dada r aiburo bhat hoye chilo",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1896",
    "sender": "Ankita",
    "time": "18:07",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "😶‍🌫️😶‍🌫️",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1897",
    "sender": "Ankita",
    "time": "18:07",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "Akhon mone porlo",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1898",
    "sender": "Ankita",
    "time": "18:07",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "😶‍🌫️😶‍🌫️",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1899",
    "sender": "Ratnadwip",
    "time": "18:08",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "🐬",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1900",
    "sender": "Ankita",
    "time": "18:08",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "Giye ki korbo bol?",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1901",
    "sender": "Ratnadwip",
    "time": "18:08",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "tash khelbi",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1902",
    "sender": "Ankita",
    "time": "18:08",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "Tash toh mathey boseo khela jay",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1903",
    "sender": "Ankita",
    "time": "18:08",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "🤦🏻‍♀️🤦🏻‍♀️",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1904",
    "sender": "Ratnadwip",
    "time": "18:08",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "ishhhh",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1905",
    "sender": "Ankita",
    "time": "18:08",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "Rastateo bose khela jay",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1906",
    "sender": "Ratnadwip",
    "time": "18:09",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "😶‍🌫️😶‍🌫️",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1907",
    "sender": "Ankita",
    "time": "18:09",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "Bol bol suni ektu",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1908",
    "sender": "Ratnadwip",
    "time": "18:10",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "🫦",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1909",
    "sender": "Ratnadwip",
    "time": "18:10",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "\"dekha jabe\"",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1910",
    "sender": "Ankita",
    "time": "18:13",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "Kobe jbi?",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1911",
    "sender": "Ratnadwip",
    "time": "18:13",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "🫪",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1912",
    "sender": "Ratnadwip",
    "time": "18:13",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "bol",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1913",
    "sender": "Ankita",
    "time": "19:14",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "Ki bolbo?",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1914",
    "sender": "Ratnadwip",
    "time": "19:19",
    "date": "2026-10-08",
    "dateLabel": "8 October 2026",
    "text": "😶😶",
    "type": "text",
    "milestone": "Pacing & Vulnerability"
  },
  {
    "id": "m_1915",
    "sender": "Ratnadwip",
    "time": "13:49",
    "date": "2026-10-10",
    "dateLabel": "10 October 2026",
    "text": "14th e AOT te hackday ache, saswata bolche",
    "type": "text"
  },
  {
    "id": "m_1916",
    "sender": "Ankita",
    "time": "14:28",
    "date": "2026-10-10",
    "dateLabel": "10 October 2026",
    "text": "Oo",
    "type": "text"
  },
  {
    "id": "m_1917",
    "sender": "Ankita",
    "time": "14:28",
    "date": "2026-10-10",
    "dateLabel": "10 October 2026",
    "text": "Jete hobe?",
    "type": "text"
  },
  {
    "id": "m_1918",
    "sender": "Ratnadwip",
    "time": "14:29",
    "date": "2026-10-10",
    "dateLabel": "10 October 2026",
    "text": "jabi ?",
    "type": "text"
  },
  {
    "id": "m_1919",
    "sender": "Ankita",
    "time": "14:30",
    "date": "2026-10-10",
    "dateLabel": "10 October 2026",
    "text": "Jabo",
    "type": "text"
  },
  {
    "id": "m_1920",
    "sender": "Ankita",
    "time": "14:31",
    "date": "2026-10-10",
    "dateLabel": "10 October 2026",
    "text": "K k jbe?",
    "type": "text"
  },
  {
    "id": "m_1921",
    "sender": "Ratnadwip",
    "time": "14:31",
    "date": "2026-10-10",
    "dateLabel": "10 October 2026",
    "text": "saswata, aska",
    "type": "text"
  },
  {
    "id": "m_1922",
    "sender": "Ankita",
    "time": "14:31",
    "date": "2026-10-10",
    "dateLabel": "10 October 2026",
    "text": "Ok",
    "type": "text"
  },
  {
    "id": "m_1923",
    "sender": "Ankita",
    "time": "14:31",
    "date": "2026-10-10",
    "dateLabel": "10 October 2026",
    "text": "Jbo",
    "type": "text"
  },
  {
    "id": "m_1924",
    "sender": "Ratnadwip",
    "time": "14:31",
    "date": "2026-10-10",
    "dateLabel": "10 October 2026",
    "text": "STK-20260728-WA0005.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260728-WA0005.webp"
  },
  {
    "id": "m_1925",
    "sender": "Ankita",
    "time": "14:31",
    "date": "2026-10-10",
    "dateLabel": "10 October 2026",
    "text": "Done",
    "type": "text"
  },
  {
    "id": "m_1926",
    "sender": "Ankita",
    "time": "23:12",
    "date": "2026-10-10",
    "dateLabel": "10 October 2026",
    "text": "Share one project you are proud of. *\nTell us about a project you have previously built or contributed to. Briefly mention what you built, your role, and what makes the project meaningful to you. You may also include a GitHub repository, live demo, portfolio, or other relevant link.",
    "type": "text"
  },
  {
    "id": "m_1927",
    "sender": "Ankita",
    "time": "23:12",
    "date": "2026-10-10",
    "dateLabel": "10 October 2026",
    "text": "Etar ans de",
    "type": "text"
  },
  {
    "id": "m_1928",
    "sender": "Ratnadwip",
    "time": "23:12",
    "date": "2026-10-10",
    "dateLabel": "10 October 2026",
    "text": "One project I’m proud of is VULTURE (Versatile Unified Local Technology for Ubiquitous Reasoning & Exchange), an experiment in decentralized, local-first computing.\n\nI’m building a system where multiple Android devices communicate over Bluetooth Low Energy (BLE) to form a local mesh network, coordinated by a PC or server. The idea is to distribute small AI workloads across available devices and explore how useful computing can work without depending entirely on cloud infrastructure.\n\nI focus on the architecture, development, and overall product experience. What makes VULTURE meaningful to me is that it explores a practical alternative to always-online computing, making use of hardware people already own rather than assuming access to expensive infrastructure.\n\nLive project: https://vulture.745482.xyz/  \nGitHub: https://github.com/RealRatnadwip/Vulture",
    "type": "link",
    "linkUrl": "https://vulture.745482.xyz/"
  },
  {
    "id": "m_1929",
    "sender": "Ankita",
    "time": "23:12",
    "date": "2026-10-10",
    "dateLabel": "10 October 2026",
    "text": "Eta debo",
    "type": "text"
  },
  {
    "id": "m_1930",
    "sender": "Ratnadwip",
    "time": "23:13",
    "date": "2026-10-10",
    "dateLabel": "10 October 2026",
    "text": "eta de project tai",
    "type": "text"
  },
  {
    "id": "m_1931",
    "sender": "Ankita",
    "time": "23:13",
    "date": "2026-10-10",
    "dateLabel": "10 October 2026",
    "text": "Lekha ta puro",
    "type": "text"
  },
  {
    "id": "m_1932",
    "sender": "Ratnadwip",
    "time": "23:13",
    "date": "2026-10-10",
    "dateLabel": "10 October 2026",
    "text": "hanji",
    "type": "text"
  },
  {
    "id": "m_1933",
    "sender": "Ankita",
    "time": "23:13",
    "date": "2026-10-10",
    "dateLabel": "10 October 2026",
    "text": "Ok",
    "type": "text"
  },
  {
    "id": "m_1934",
    "sender": "Ratnadwip",
    "time": "23:13",
    "date": "2026-10-10",
    "dateLabel": "10 October 2026",
    "text": "PayPer Tap. Pay. Done.\n\nImagine paying with crypto felt exactly like tapping your card at a tea stall. No apps to open, no QR codes to line up, no seed phrases, nothing to wait for while the person behind you sighs. You tap, and you're done.\n\nHere's how it works for you. You get a PayPer card and load it with crypto once, the way you'd recharge a metro card. After that, it's just a card. Walk up to any PayPer terminal, tap, and walk away with your chai. No phone needed. If your phone has NFC, you can skip the card entirely and just tap the phone. Nothing to install, nothing to set up. Prices show in rupees, so you never have to do crypto math at a counter.\n\nFor the shopkeeper, it's just as simple. One small terminal on the counter. A customer taps, the amount pops up on the screen, and the sale is done. Even if the internet is down. That's the real trick. The terminal doesn't need to phone home to approve your tap. It checks your card's signed balance right there on the spot, then settles everything with the blockchain later when it's back online. And your money can't be double spent, because every tap is counted and capped.\n\nUnder the hood it's a small, cheap device. A tiny computer, an NFC reader, and a touch screen. But you'd never know it. All the crypto complexity, the wallets, the gas fees, the confirmations, stays hidden. You just tap and pay.\n\nThe point is bigger than the device. Right now crypto is something people hold and trade. PayPer wants to make it something people actually spend. At canteens, street stalls, village markets, anywhere a card machine can't reach. Spendable, not just tradable.",
    "type": "text"
  },
  {
    "id": "m_1935",
    "sender": "Ratnadwip",
    "time": "23:13",
    "date": "2026-10-10",
    "dateLabel": "10 October 2026",
    "text": "eta idea te",
    "type": "text"
  },
  {
    "id": "m_1936",
    "sender": "Ankita",
    "time": "23:15",
    "date": "2026-10-10",
    "dateLabel": "10 October 2026",
    "text": "Hmn diyechi",
    "type": "text"
  },
  {
    "id": "m_1937",
    "sender": "Ratnadwip",
    "time": "23:15",
    "date": "2026-10-10",
    "dateLabel": "10 October 2026",
    "text": "STK-20261007-WA0008.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20261007-WA0008.webp"
  },
  {
    "id": "m_1938",
    "sender": "Ankita",
    "time": "23:16",
    "date": "2026-10-10",
    "dateLabel": "10 October 2026",
    "text": "Done amr",
    "type": "text"
  },
  {
    "id": "m_1939",
    "sender": "Ratnadwip",
    "time": "23:17",
    "date": "2026-10-10",
    "dateLabel": "10 October 2026",
    "text": "STK-20260817-WA0032.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260817-WA0032.webp"
  },
  {
    "id": "m_1940",
    "sender": "Ankita",
    "time": "23:19",
    "date": "2026-10-10",
    "dateLabel": "10 October 2026",
    "text": "",
    "type": "text"
  },
  {
    "id": "m_1941",
    "sender": "Ratnadwip",
    "time": "23:32",
    "date": "2026-10-10",
    "dateLabel": "10 October 2026",
    "text": "STK-20261007-WA0015.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20261007-WA0015.webp"
  },
  {
    "id": "m_1942",
    "sender": "Ratnadwip",
    "time": "16:26",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "STK-20261013-WA0002.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20261013-WA0002.webp"
  },
  {
    "id": "m_1943",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_1944",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_1945",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_1946",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_1947",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_1948",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_1949",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_1950",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_1951",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_1952",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_1953",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_1954",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_1955",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_1956",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_1957",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_1958",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_1959",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_1960",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_1961",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_1962",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_1963",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_1964",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_1965",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_1966",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_1967",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_1968",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_1969",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_1970",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_1971",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_1972",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_1973",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_1974",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_1975",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_1976",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_1977",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_1978",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_1979",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_1980",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_1981",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_1982",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_1983",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_1984",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_1985",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_1986",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_1987",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_1988",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_1989",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_1990",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_1991",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_1992",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_1993",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_1994",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_1995",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_1996",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_1997",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_1998",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_1999",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_2000",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_2001",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_2002",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_2003",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_2004",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_2005",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_2006",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_2007",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_2008",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_2009",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_2010",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_2011",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_2012",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_2013",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_2014",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_2015",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_2016",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_2017",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_2018",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_2019",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_2020",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_2021",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_2022",
    "sender": "Ratnadwip",
    "time": "22:09",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "ebar",
    "type": "text"
  },
  {
    "id": "m_2023",
    "sender": "Ankita",
    "time": "22:09",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "Etar jnno mar khbi",
    "type": "text"
  },
  {
    "id": "m_2024",
    "sender": "Ankita",
    "time": "22:10",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "Aro acchey",
    "type": "text"
  },
  {
    "id": "m_2025",
    "sender": "Ankita",
    "time": "22:10",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "Pathaa",
    "type": "text"
  },
  {
    "id": "m_2026",
    "sender": "Ratnadwip",
    "time": "22:10",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "jacche",
    "type": "text"
  },
  {
    "id": "m_2027",
    "sender": "Ankita",
    "time": "22:11",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "Ki ebr",
    "type": "text"
  },
  {
    "id": "m_2028",
    "sender": "Ankita",
    "time": "22:11",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "Net ta k fele de",
    "type": "text"
  },
  {
    "id": "m_2029",
    "sender": "Ankita",
    "time": "22:11",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "Debosmita r barite jhamela hoyeche",
    "type": "text"
  },
  {
    "id": "m_2030",
    "sender": "Ratnadwip",
    "time": "22:11",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_2031",
    "sender": "Ratnadwip",
    "time": "22:11",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_2032",
    "sender": "Ratnadwip",
    "time": "22:11",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_2033",
    "sender": "Ratnadwip",
    "time": "22:11",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_2034",
    "sender": "Ratnadwip",
    "time": "22:11",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_2035",
    "sender": "Ratnadwip",
    "time": "22:11",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_2036",
    "sender": "Ratnadwip",
    "time": "22:11",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_2037",
    "sender": "Ratnadwip",
    "time": "22:11",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_2038",
    "sender": "Ratnadwip",
    "time": "22:11",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_2039",
    "sender": "Ratnadwip",
    "time": "22:11",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_2040",
    "sender": "Ratnadwip",
    "time": "22:11",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_2041",
    "sender": "Ratnadwip",
    "time": "22:12",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "koto toh age chole gelo",
    "type": "text"
  },
  {
    "id": "m_2042",
    "sender": "Ankita",
    "time": "22:12",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "Ki eta🫩🙏",
    "type": "text"
  },
  {
    "id": "m_2043",
    "sender": "Ankita",
    "time": "22:12",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "Ki esob",
    "type": "text"
  },
  {
    "id": "m_2044",
    "sender": "Ankita",
    "time": "22:12",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "Dhussss",
    "type": "text"
  },
  {
    "id": "m_2045",
    "sender": "Ratnadwip",
    "time": "22:12",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "STK-20260828-WA0005.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260828-WA0005.webp"
  },
  {
    "id": "m_2046",
    "sender": "Ankita",
    "time": "22:14",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "Ki sob",
    "type": "text"
  },
  {
    "id": "m_2047",
    "sender": "Ankita",
    "time": "22:14",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "Bhlo gulo pathaaa",
    "type": "text"
  },
  {
    "id": "m_2048",
    "sender": "Ankita",
    "time": "22:14",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "Boddo marbo",
    "type": "text"
  },
  {
    "id": "m_2049",
    "sender": "Ratnadwip",
    "time": "22:15",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "sob sent",
    "type": "text"
  },
  {
    "id": "m_2050",
    "sender": "Ankita",
    "time": "22:17",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "Naa",
    "type": "text"
  },
  {
    "id": "m_2051",
    "sender": "Ankita",
    "time": "22:17",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "Selfie",
    "type": "text"
  },
  {
    "id": "m_2052",
    "sender": "Ankita",
    "time": "22:17",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "Tarpor",
    "type": "text"
  },
  {
    "id": "m_2053",
    "sender": "Ankita",
    "time": "22:17",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "Koto gulo pose a chobi tullm",
    "type": "text"
  },
  {
    "id": "m_2054",
    "sender": "Ankita",
    "time": "22:17",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "😑😑😑",
    "type": "text"
  },
  {
    "id": "m_2055",
    "sender": "Ankita",
    "time": "22:17",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "Dhusss",
    "type": "text"
  },
  {
    "id": "m_2056",
    "sender": "Ankita",
    "time": "22:17",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "Kothai bolbo na ja",
    "type": "text"
  },
  {
    "id": "m_2057",
    "sender": "Ratnadwip",
    "time": "22:18",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "sob abr send kori wait",
    "type": "text"
  },
  {
    "id": "m_2058",
    "sender": "Ankita",
    "time": "22:18",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "😑😑😑",
    "type": "text"
  },
  {
    "id": "m_2059",
    "sender": "Ratnadwip",
    "time": "22:18",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "ager gulo delete korchi, abar send korchi",
    "type": "text"
  },
  {
    "id": "m_2060",
    "sender": "Ankita",
    "time": "22:18",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "😑😑😑",
    "type": "text"
  },
  {
    "id": "m_2061",
    "sender": "Ankita",
    "time": "22:18",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "Na na",
    "type": "text"
  },
  {
    "id": "m_2062",
    "sender": "Ankita",
    "time": "22:18",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "Koris na delete",
    "type": "text"
  },
  {
    "id": "m_2063",
    "sender": "Ankita",
    "time": "22:18",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "Dara eseche",
    "type": "text"
  },
  {
    "id": "m_2064",
    "sender": "Ankita",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "Dhusss",
    "type": "text"
  },
  {
    "id": "m_2065",
    "sender": "Ankita",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "Patha abr sob",
    "type": "text"
  },
  {
    "id": "m_2066",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "",
    "type": "text"
  },
  {
    "id": "m_2067",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0177.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0177.jpg"
  },
  {
    "id": "m_2068",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0179.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0179.jpg"
  },
  {
    "id": "m_2069",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0178.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0178.jpg"
  },
  {
    "id": "m_2070",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0180.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0180.jpg"
  },
  {
    "id": "m_2071",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0181.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0181.jpg"
  },
  {
    "id": "m_2072",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0182.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0182.jpg"
  },
  {
    "id": "m_2073",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0183.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0183.jpg"
  },
  {
    "id": "m_2074",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0184.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0184.jpg"
  },
  {
    "id": "m_2075",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0186.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0186.jpg"
  },
  {
    "id": "m_2076",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0185.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0185.jpg"
  },
  {
    "id": "m_2077",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0187.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0187.jpg"
  },
  {
    "id": "m_2078",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0190.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0190.jpg"
  },
  {
    "id": "m_2079",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0221.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0221.jpg"
  },
  {
    "id": "m_2080",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0189.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0189.jpg"
  },
  {
    "id": "m_2081",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0188.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0188.jpg"
  },
  {
    "id": "m_2082",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0196.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0196.jpg"
  },
  {
    "id": "m_2083",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0199.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0199.jpg"
  },
  {
    "id": "m_2084",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0192.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0192.jpg"
  },
  {
    "id": "m_2085",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0195.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0195.jpg"
  },
  {
    "id": "m_2086",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0191.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0191.jpg"
  },
  {
    "id": "m_2087",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0193.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0193.jpg"
  },
  {
    "id": "m_2088",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0194.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0194.jpg"
  },
  {
    "id": "m_2089",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0273.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0273.jpg"
  },
  {
    "id": "m_2090",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0197.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0197.jpg"
  },
  {
    "id": "m_2091",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0198.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0198.jpg"
  },
  {
    "id": "m_2092",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0201.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0201.jpg"
  },
  {
    "id": "m_2093",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0282.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0282.jpg"
  },
  {
    "id": "m_2094",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0207.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0207.jpg"
  },
  {
    "id": "m_2095",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0200.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0200.jpg"
  },
  {
    "id": "m_2096",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0229.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0229.jpg"
  },
  {
    "id": "m_2097",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0202.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0202.jpg"
  },
  {
    "id": "m_2098",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0203.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0203.jpg"
  },
  {
    "id": "m_2099",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0248.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0248.jpg"
  },
  {
    "id": "m_2100",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0281.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0281.jpg"
  },
  {
    "id": "m_2101",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0204.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0204.jpg"
  },
  {
    "id": "m_2102",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0205.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0205.jpg"
  },
  {
    "id": "m_2103",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0242.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0242.jpg"
  },
  {
    "id": "m_2104",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0206.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0206.jpg"
  },
  {
    "id": "m_2105",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0209.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0209.jpg"
  },
  {
    "id": "m_2106",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0210.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0210.jpg"
  },
  {
    "id": "m_2107",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0208.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0208.jpg"
  },
  {
    "id": "m_2108",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0211.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0211.jpg"
  },
  {
    "id": "m_2109",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0271.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0271.jpg"
  },
  {
    "id": "m_2110",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0239.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0239.jpg"
  },
  {
    "id": "m_2111",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0213.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0213.jpg"
  },
  {
    "id": "m_2112",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0215.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0215.jpg"
  },
  {
    "id": "m_2113",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0214.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0214.jpg"
  },
  {
    "id": "m_2114",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0212.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0212.jpg"
  },
  {
    "id": "m_2115",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0216.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0216.jpg"
  },
  {
    "id": "m_2116",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0217.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0217.jpg"
  },
  {
    "id": "m_2117",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0346.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0346.jpg"
  },
  {
    "id": "m_2118",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0252.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0252.jpg"
  },
  {
    "id": "m_2119",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0219.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0219.jpg"
  },
  {
    "id": "m_2120",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0277.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0277.jpg"
  },
  {
    "id": "m_2121",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0218.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0218.jpg"
  },
  {
    "id": "m_2122",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0220.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0220.jpg"
  },
  {
    "id": "m_2123",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0361.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0361.jpg"
  },
  {
    "id": "m_2124",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0222.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0222.jpg"
  },
  {
    "id": "m_2125",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0338.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0338.jpg"
  },
  {
    "id": "m_2126",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0231.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0231.jpg"
  },
  {
    "id": "m_2127",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0223.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0223.jpg"
  },
  {
    "id": "m_2128",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0308.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0308.jpg"
  },
  {
    "id": "m_2129",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0224.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0224.jpg"
  },
  {
    "id": "m_2130",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0226.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0226.jpg"
  },
  {
    "id": "m_2131",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0227.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0227.jpg"
  },
  {
    "id": "m_2132",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0266.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0266.jpg"
  },
  {
    "id": "m_2133",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0246.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0246.jpg"
  },
  {
    "id": "m_2134",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0233.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0233.jpg"
  },
  {
    "id": "m_2135",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0225.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0225.jpg"
  },
  {
    "id": "m_2136",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0309.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0309.jpg"
  },
  {
    "id": "m_2137",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0228.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0228.jpg"
  },
  {
    "id": "m_2138",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0230.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0230.jpg"
  },
  {
    "id": "m_2139",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0331.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0331.jpg"
  },
  {
    "id": "m_2140",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0232.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0232.jpg"
  },
  {
    "id": "m_2141",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0237.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0237.jpg"
  },
  {
    "id": "m_2142",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0235.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0235.jpg"
  },
  {
    "id": "m_2143",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "VID-20261013-WA0269.mp4 (file attached)",
    "type": "video",
    "mediaName": "VID-20261013-WA0269.mp4"
  },
  {
    "id": "m_2144",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0236.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0236.jpg"
  },
  {
    "id": "m_2145",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0234.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0234.jpg"
  },
  {
    "id": "m_2146",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0238.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0238.jpg"
  },
  {
    "id": "m_2147",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0330.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0330.jpg"
  },
  {
    "id": "m_2148",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0351.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0351.jpg"
  },
  {
    "id": "m_2149",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0317.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0317.jpg"
  },
  {
    "id": "m_2150",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0240.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0240.jpg"
  },
  {
    "id": "m_2151",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0247.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0247.jpg"
  },
  {
    "id": "m_2152",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0254.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0254.jpg"
  },
  {
    "id": "m_2153",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0241.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0241.jpg"
  },
  {
    "id": "m_2154",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0245.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0245.jpg"
  },
  {
    "id": "m_2155",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0243.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0243.jpg"
  },
  {
    "id": "m_2156",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0244.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0244.jpg"
  },
  {
    "id": "m_2157",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0253.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0253.jpg"
  },
  {
    "id": "m_2158",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0249.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0249.jpg"
  },
  {
    "id": "m_2159",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0259.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0259.jpg"
  },
  {
    "id": "m_2160",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0250.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0250.jpg"
  },
  {
    "id": "m_2161",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0251.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0251.jpg"
  },
  {
    "id": "m_2162",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0356.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0356.jpg"
  },
  {
    "id": "m_2163",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0260.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0260.jpg"
  },
  {
    "id": "m_2164",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0257.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0257.jpg"
  },
  {
    "id": "m_2165",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0255.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0255.jpg"
  },
  {
    "id": "m_2166",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0258.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0258.jpg"
  },
  {
    "id": "m_2167",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0256.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0256.jpg"
  },
  {
    "id": "m_2168",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0288.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0288.jpg"
  },
  {
    "id": "m_2169",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0263.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0263.jpg"
  },
  {
    "id": "m_2170",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0364.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0364.jpg"
  },
  {
    "id": "m_2171",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0348.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0348.jpg"
  },
  {
    "id": "m_2172",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0262.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0262.jpg"
  },
  {
    "id": "m_2173",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0261.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0261.jpg"
  },
  {
    "id": "m_2174",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0270.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0270.jpg"
  },
  {
    "id": "m_2175",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0344.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0344.jpg"
  },
  {
    "id": "m_2176",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0345.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0345.jpg"
  },
  {
    "id": "m_2177",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0264.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0264.jpg"
  },
  {
    "id": "m_2178",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0265.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0265.jpg"
  },
  {
    "id": "m_2179",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0267.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0267.jpg"
  },
  {
    "id": "m_2180",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0359.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0359.jpg"
  },
  {
    "id": "m_2181",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0279.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0279.jpg"
  },
  {
    "id": "m_2182",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0268.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0268.jpg"
  },
  {
    "id": "m_2183",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0272.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0272.jpg"
  },
  {
    "id": "m_2184",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0286.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0286.jpg"
  },
  {
    "id": "m_2185",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0358.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0358.jpg"
  },
  {
    "id": "m_2186",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0350.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0350.jpg"
  },
  {
    "id": "m_2187",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0290.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0290.jpg"
  },
  {
    "id": "m_2188",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0275.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0275.jpg"
  },
  {
    "id": "m_2189",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0274.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0274.jpg"
  },
  {
    "id": "m_2190",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0276.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0276.jpg"
  },
  {
    "id": "m_2191",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0341.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0341.jpg"
  },
  {
    "id": "m_2192",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0278.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0278.jpg"
  },
  {
    "id": "m_2193",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0357.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0357.jpg"
  },
  {
    "id": "m_2194",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0280.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0280.jpg"
  },
  {
    "id": "m_2195",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "VID-20261013-WA0305.mp4 (file attached)",
    "type": "video",
    "mediaName": "VID-20261013-WA0305.mp4"
  },
  {
    "id": "m_2196",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0283.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0283.jpg"
  },
  {
    "id": "m_2197",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0284.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0284.jpg"
  },
  {
    "id": "m_2198",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0285.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0285.jpg"
  },
  {
    "id": "m_2199",
    "sender": "Ratnadwip",
    "time": "22:19",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0352.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0352.jpg"
  },
  {
    "id": "m_2200",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0287.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0287.jpg"
  },
  {
    "id": "m_2201",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0326.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0326.jpg"
  },
  {
    "id": "m_2202",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0289.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0289.jpg"
  },
  {
    "id": "m_2203",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0294.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0294.jpg"
  },
  {
    "id": "m_2204",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0365.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0365.jpg"
  },
  {
    "id": "m_2205",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0291.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0291.jpg"
  },
  {
    "id": "m_2206",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0292.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0292.jpg"
  },
  {
    "id": "m_2207",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0293.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0293.jpg"
  },
  {
    "id": "m_2208",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0342.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0342.jpg"
  },
  {
    "id": "m_2209",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0295.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0295.jpg"
  },
  {
    "id": "m_2210",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0296.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0296.jpg"
  },
  {
    "id": "m_2211",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0362.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0362.jpg"
  },
  {
    "id": "m_2212",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0297.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0297.jpg"
  },
  {
    "id": "m_2213",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0337.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0337.jpg"
  },
  {
    "id": "m_2214",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0298.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0298.jpg"
  },
  {
    "id": "m_2215",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0354.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0354.jpg"
  },
  {
    "id": "m_2216",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0347.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0347.jpg"
  },
  {
    "id": "m_2217",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0299.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0299.jpg"
  },
  {
    "id": "m_2218",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0329.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0329.jpg"
  },
  {
    "id": "m_2219",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0300.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0300.jpg"
  },
  {
    "id": "m_2220",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0324.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0324.jpg"
  },
  {
    "id": "m_2221",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0301.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0301.jpg"
  },
  {
    "id": "m_2222",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0302.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0302.jpg"
  },
  {
    "id": "m_2223",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0332.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0332.jpg"
  },
  {
    "id": "m_2224",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0303.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0303.jpg"
  },
  {
    "id": "m_2225",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0306.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0306.jpg"
  },
  {
    "id": "m_2226",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0307.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0307.jpg"
  },
  {
    "id": "m_2227",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0328.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0328.jpg"
  },
  {
    "id": "m_2228",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0321.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0321.jpg"
  },
  {
    "id": "m_2229",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0304.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0304.jpg"
  },
  {
    "id": "m_2230",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0363.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0363.jpg"
  },
  {
    "id": "m_2231",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0310.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0310.jpg"
  },
  {
    "id": "m_2232",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0311.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0311.jpg"
  },
  {
    "id": "m_2233",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0353.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0353.jpg"
  },
  {
    "id": "m_2234",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0314.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0314.jpg"
  },
  {
    "id": "m_2235",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0372.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0372.jpg"
  },
  {
    "id": "m_2236",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0312.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0312.jpg"
  },
  {
    "id": "m_2237",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0336.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0336.jpg"
  },
  {
    "id": "m_2238",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0370.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0370.jpg"
  },
  {
    "id": "m_2239",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0318.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0318.jpg"
  },
  {
    "id": "m_2240",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0313.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0313.jpg"
  },
  {
    "id": "m_2241",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0315.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0315.jpg"
  },
  {
    "id": "m_2242",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0316.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0316.jpg"
  },
  {
    "id": "m_2243",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0319.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0319.jpg"
  },
  {
    "id": "m_2244",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "VID-20261013-WA0334.mp4 (file attached)",
    "type": "video",
    "mediaName": "VID-20261013-WA0334.mp4"
  },
  {
    "id": "m_2245",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0355.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0355.jpg"
  },
  {
    "id": "m_2246",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0322.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0322.jpg"
  },
  {
    "id": "m_2247",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0366.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0366.jpg"
  },
  {
    "id": "m_2248",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0343.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0343.jpg"
  },
  {
    "id": "m_2249",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0367.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0367.jpg"
  },
  {
    "id": "m_2250",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0320.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0320.jpg"
  },
  {
    "id": "m_2251",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0325.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0325.jpg"
  },
  {
    "id": "m_2252",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0369.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0369.jpg"
  },
  {
    "id": "m_2253",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0323.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0323.jpg"
  },
  {
    "id": "m_2254",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0327.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0327.jpg"
  },
  {
    "id": "m_2255",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "VID-20261013-WA0368.mp4 (file attached)",
    "type": "video",
    "mediaName": "VID-20261013-WA0368.mp4"
  },
  {
    "id": "m_2256",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0333.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0333.jpg"
  },
  {
    "id": "m_2257",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0339.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0339.jpg"
  },
  {
    "id": "m_2258",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0335.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0335.jpg"
  },
  {
    "id": "m_2259",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0340.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0340.jpg"
  },
  {
    "id": "m_2260",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0349.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0349.jpg"
  },
  {
    "id": "m_2261",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0360.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0360.jpg"
  },
  {
    "id": "m_2262",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "VID-20261013-WA0371.mp4 (file attached)",
    "type": "video",
    "mediaName": "VID-20261013-WA0371.mp4"
  },
  {
    "id": "m_2263",
    "sender": "Ratnadwip",
    "time": "22:20",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "VID-20261013-WA0373.mp4 (file attached)",
    "type": "video",
    "mediaName": "VID-20261013-WA0373.mp4"
  },
  {
    "id": "m_2264",
    "sender": "Ratnadwip",
    "time": "22:21",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "",
    "type": "text"
  },
  {
    "id": "m_2265",
    "sender": "Ratnadwip",
    "time": "22:21",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0374.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0374.jpg"
  },
  {
    "id": "m_2266",
    "sender": "Ratnadwip",
    "time": "22:21",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0327.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0327.jpg"
  },
  {
    "id": "m_2267",
    "sender": "Ratnadwip",
    "time": "22:21",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0323.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0323.jpg"
  },
  {
    "id": "m_2268",
    "sender": "Ratnadwip",
    "time": "22:21",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0376.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0376.jpg"
  },
  {
    "id": "m_2269",
    "sender": "Ratnadwip",
    "time": "22:21",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0377.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0377.jpg"
  },
  {
    "id": "m_2270",
    "sender": "Ratnadwip",
    "time": "22:21",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0375.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0375.jpg"
  },
  {
    "id": "m_2271",
    "sender": "Ratnadwip",
    "time": "22:21",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0304.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0304.jpg"
  },
  {
    "id": "m_2272",
    "sender": "Ratnadwip",
    "time": "22:21",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0379.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0379.jpg"
  },
  {
    "id": "m_2273",
    "sender": "Ratnadwip",
    "time": "22:21",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0378.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0378.jpg"
  },
  {
    "id": "m_2274",
    "sender": "Ratnadwip",
    "time": "22:21",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0380.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0380.jpg"
  },
  {
    "id": "m_2275",
    "sender": "Ratnadwip",
    "time": "22:21",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0349.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0349.jpg"
  },
  {
    "id": "m_2276",
    "sender": "Ratnadwip",
    "time": "22:21",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0382.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0382.jpg"
  },
  {
    "id": "m_2277",
    "sender": "Ratnadwip",
    "time": "22:21",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0381.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0381.jpg"
  },
  {
    "id": "m_2278",
    "sender": "Ratnadwip",
    "time": "22:21",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0340.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0340.jpg"
  },
  {
    "id": "m_2279",
    "sender": "Ratnadwip",
    "time": "22:21",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "IMG-20261013-WA0383.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261013-WA0383.jpg"
  },
  {
    "id": "m_2280",
    "sender": "Ankita",
    "time": "22:28",
    "date": "2026-10-13",
    "dateLabel": "13 October 2026",
    "text": "Oo accha",
    "type": "text"
  },
  {
    "id": "m_2281",
    "sender": "Ankita",
    "time": "00:47",
    "date": "2026-10-14",
    "dateLabel": "14 October 2026",
    "text": "",
    "type": "text"
  },
  {
    "id": "m_2282",
    "sender": "Ratnadwip",
    "time": "09:26",
    "date": "2026-10-14",
    "dateLabel": "14 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_2283",
    "sender": "Ratnadwip",
    "time": "09:27",
    "date": "2026-10-14",
    "dateLabel": "14 October 2026",
    "text": "STK-20261014-WA0000.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20261014-WA0000.webp"
  },
  {
    "id": "m_2284",
    "sender": "Ankita",
    "time": "09:29",
    "date": "2026-10-14",
    "dateLabel": "14 October 2026",
    "text": "STK-20260927-WA0015.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260927-WA0015.webp"
  },
  {
    "id": "m_2285",
    "sender": "Ratnadwip",
    "time": "09:30",
    "date": "2026-10-14",
    "dateLabel": "14 October 2026",
    "text": "kokhon aschis kalyani ?",
    "type": "text"
  },
  {
    "id": "m_2286",
    "sender": "Ankita",
    "time": "09:32",
    "date": "2026-10-14",
    "dateLabel": "14 October 2026",
    "text": "12 tay berobo but akhono confirm noi",
    "type": "text"
  },
  {
    "id": "m_2287",
    "sender": "Ankita",
    "time": "09:32",
    "date": "2026-10-14",
    "dateLabel": "14 October 2026",
    "text": "Ashole maa r sorir ta khrp with amaro",
    "type": "text"
  },
  {
    "id": "m_2288",
    "sender": "Ankita",
    "time": "09:33",
    "date": "2026-10-14",
    "dateLabel": "14 October 2026",
    "text": "Dekhi maa k bole",
    "type": "text"
  },
  {
    "id": "m_2289",
    "sender": "Ankita",
    "time": "09:33",
    "date": "2026-10-14",
    "dateLabel": "14 October 2026",
    "text": "Ki bole",
    "type": "text"
  },
  {
    "id": "m_2290",
    "sender": "Ankita",
    "time": "09:33",
    "date": "2026-10-14",
    "dateLabel": "14 October 2026",
    "text": "Jodi bole jete na thle bolbo na besi kichu..",
    "type": "text"
  },
  {
    "id": "m_2291",
    "sender": "Ankita",
    "time": "09:33",
    "date": "2026-10-14",
    "dateLabel": "14 October 2026",
    "text": "But maa ki bole",
    "type": "text"
  },
  {
    "id": "m_2292",
    "sender": "Ratnadwip",
    "time": "09:33",
    "date": "2026-10-14",
    "dateLabel": "14 October 2026",
    "text": "amake 11 ta nagad janas",
    "type": "text"
  },
  {
    "id": "m_2293",
    "sender": "Ankita",
    "time": "09:33",
    "date": "2026-10-14",
    "dateLabel": "14 October 2026",
    "text": "Maa jdi bole na maa r besi sorir khrp then bari thakte hobe",
    "type": "text"
  },
  {
    "id": "m_2294",
    "sender": "Ankita",
    "time": "09:34",
    "date": "2026-10-14",
    "dateLabel": "14 October 2026",
    "text": "Ok",
    "type": "text"
  },
  {
    "id": "m_2295",
    "sender": "Ratnadwip",
    "time": "09:34",
    "date": "2026-10-14",
    "dateLabel": "14 October 2026",
    "text": "ok ok",
    "type": "text"
  },
  {
    "id": "m_2296",
    "sender": "Ankita",
    "time": "22:25",
    "date": "2026-10-14",
    "dateLabel": "14 October 2026",
    "text": "Bolis na",
    "type": "text"
  },
  {
    "id": "m_2297",
    "sender": "Ankita",
    "time": "22:25",
    "date": "2026-10-14",
    "dateLabel": "14 October 2026",
    "text": "Bhuleo bolis na",
    "type": "text"
  },
  {
    "id": "m_2298",
    "sender": "Ankita",
    "time": "22:25",
    "date": "2026-10-14",
    "dateLabel": "14 October 2026",
    "text": "Noyto asbei naa",
    "type": "text"
  },
  {
    "id": "m_2299",
    "sender": "Ratnadwip",
    "time": "23:24",
    "date": "2026-10-14",
    "dateLabel": "14 October 2026",
    "text": "😮",
    "type": "text"
  },
  {
    "id": "m_2300",
    "sender": "Ratnadwip",
    "time": "23:25",
    "date": "2026-10-14",
    "dateLabel": "14 October 2026",
    "text": "kota chobi de toh 🫩, ager din er thakur er chobi o dis",
    "type": "text"
  },
  {
    "id": "m_2301",
    "sender": "Ratnadwip",
    "time": "23:25",
    "date": "2026-10-14",
    "dateLabel": "14 October 2026",
    "text": "",
    "type": "text"
  },
  {
    "id": "m_2302",
    "sender": "Ratnadwip",
    "time": "23:25",
    "date": "2026-10-14",
    "dateLabel": "14 October 2026",
    "text": "IMG-20261014-WA0005.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261014-WA0005.jpg"
  },
  {
    "id": "m_2303",
    "sender": "Ratnadwip",
    "time": "23:25",
    "date": "2026-10-14",
    "dateLabel": "14 October 2026",
    "text": "IMG-20261014-WA0004.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261014-WA0004.jpg"
  },
  {
    "id": "m_2304",
    "sender": "Ratnadwip",
    "time": "23:25",
    "date": "2026-10-14",
    "dateLabel": "14 October 2026",
    "text": "IMG-20261014-WA0006.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261014-WA0006.jpg"
  },
  {
    "id": "m_2305",
    "sender": "Ratnadwip",
    "time": "23:25",
    "date": "2026-10-14",
    "dateLabel": "14 October 2026",
    "text": "IMG-20261014-WA0009.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261014-WA0009.jpg"
  },
  {
    "id": "m_2306",
    "sender": "Ratnadwip",
    "time": "23:25",
    "date": "2026-10-14",
    "dateLabel": "14 October 2026",
    "text": "IMG-20261014-WA0007.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261014-WA0007.jpg"
  },
  {
    "id": "m_2307",
    "sender": "Ratnadwip",
    "time": "23:25",
    "date": "2026-10-14",
    "dateLabel": "14 October 2026",
    "text": "IMG-20261014-WA0008.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261014-WA0008.jpg"
  },
  {
    "id": "m_2308",
    "sender": "Ratnadwip",
    "time": "21:55",
    "date": "2026-10-15",
    "dateLabel": "15 October 2026",
    "text": "ded inside",
    "type": "text"
  },
  {
    "id": "m_2309",
    "sender": "Ratnadwip",
    "time": "21:55",
    "date": "2026-10-15",
    "dateLabel": "15 October 2026",
    "text": "omaaagooooo",
    "type": "text"
  },
  {
    "id": "m_2310",
    "sender": "Ankita",
    "time": "21:57",
    "date": "2026-10-15",
    "dateLabel": "15 October 2026",
    "text": "",
    "type": "text"
  },
  {
    "id": "m_2311",
    "sender": "Ankita",
    "time": "21:58",
    "date": "2026-10-15",
    "dateLabel": "15 October 2026",
    "text": "",
    "type": "text"
  },
  {
    "id": "m_2312",
    "sender": "Ratnadwip",
    "time": "22:02",
    "date": "2026-10-15",
    "dateLabel": "15 October 2026",
    "text": "eta crazy chilo",
    "type": "text"
  },
  {
    "id": "m_2313",
    "sender": "Ankita",
    "time": "22:03",
    "date": "2026-10-15",
    "dateLabel": "15 October 2026",
    "text": "",
    "type": "text"
  },
  {
    "id": "m_2314",
    "sender": "Ratnadwip",
    "time": "22:04",
    "date": "2026-10-15",
    "dateLabel": "15 October 2026",
    "text": "😋🫩👅🎀",
    "type": "text"
  },
  {
    "id": "m_2315",
    "sender": "Ankita",
    "time": "22:07",
    "date": "2026-10-15",
    "dateLabel": "15 October 2026",
    "text": "",
    "type": "text"
  },
  {
    "id": "m_2316",
    "sender": "Ratnadwip",
    "time": "22:07",
    "date": "2026-10-15",
    "dateLabel": "15 October 2026",
    "text": "sohid 🫩",
    "type": "text"
  },
  {
    "id": "m_2317",
    "sender": "Ankita",
    "time": "22:08",
    "date": "2026-10-15",
    "dateLabel": "15 October 2026",
    "text": "",
    "type": "text"
  },
  {
    "id": "m_2318",
    "sender": "Ratnadwip",
    "time": "22:10",
    "date": "2026-10-15",
    "dateLabel": "15 October 2026",
    "text": "🫡",
    "type": "text"
  },
  {
    "id": "m_2319",
    "sender": "Ankita",
    "time": "14:28",
    "date": "2026-10-16",
    "dateLabel": "16 October 2026",
    "text": "",
    "type": "text"
  },
  {
    "id": "m_2320",
    "sender": "Ratnadwip",
    "time": "14:53",
    "date": "2026-10-16",
    "dateLabel": "16 October 2026",
    "text": "hookah er dhoa r emoji",
    "type": "text"
  },
  {
    "id": "m_2321",
    "sender": "Ankita",
    "time": "15:24",
    "date": "2026-10-16",
    "dateLabel": "16 October 2026",
    "text": "STK-20261016-WA0003.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20261016-WA0003.webp"
  },
  {
    "id": "m_2322",
    "sender": "Ankita",
    "time": "01:13",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "",
    "type": "text"
  },
  {
    "id": "m_2323",
    "sender": "Ratnadwip",
    "time": "01:13",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "STK-20261014-WA0000.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20261014-WA0000.webp"
  },
  {
    "id": "m_2324",
    "sender": "Ankita",
    "time": "01:18",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "STK-20261017-WA0003.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20261017-WA0003.webp"
  },
  {
    "id": "m_2325",
    "sender": "Ratnadwip",
    "time": "01:19",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_2326",
    "sender": "Ankita",
    "time": "01:19",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "Sts dewoa ta mandatory",
    "type": "text"
  },
  {
    "id": "m_2327",
    "sender": "Ratnadwip",
    "time": "01:19",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "STK-20260817-WA0032.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260817-WA0032.webp"
  },
  {
    "id": "m_2328",
    "sender": "Ankita",
    "time": "01:19",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "Noyto ami delete korchi best",
    "type": "text"
  },
  {
    "id": "m_2329",
    "sender": "Ratnadwip",
    "time": "01:19",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "ooou ami debo ?",
    "type": "text"
  },
  {
    "id": "m_2330",
    "sender": "Ratnadwip",
    "time": "01:20",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "ofc, wait",
    "type": "text"
  },
  {
    "id": "m_2331",
    "sender": "Ankita",
    "time": "01:20",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "Na",
    "type": "text"
  },
  {
    "id": "m_2332",
    "sender": "Ankita",
    "time": "01:20",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "R parbi na",
    "type": "text"
  },
  {
    "id": "m_2333",
    "sender": "Ankita",
    "time": "01:20",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "Time sesh",
    "type": "text"
  },
  {
    "id": "m_2334",
    "sender": "Ankita",
    "time": "01:20",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "Fuck off",
    "type": "text"
  },
  {
    "id": "m_2335",
    "sender": "Ratnadwip",
    "time": "01:20",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "😭😭😭😭",
    "type": "text"
  },
  {
    "id": "m_2336",
    "sender": "Ratnadwip",
    "time": "01:20",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "😭😭😭😭😭",
    "type": "text"
  },
  {
    "id": "m_2337",
    "sender": "Ratnadwip",
    "time": "01:20",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "😭😭😭😭😭",
    "type": "text"
  },
  {
    "id": "m_2338",
    "sender": "Ratnadwip",
    "time": "01:20",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "😭😭😭😭😭😭😭😭😭",
    "type": "text"
  },
  {
    "id": "m_2339",
    "sender": "Ankita",
    "time": "01:20",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "U pate buddy",
    "type": "text"
  },
  {
    "id": "m_2340",
    "sender": "Ratnadwip",
    "time": "01:20",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "😭😭😭",
    "type": "text"
  },
  {
    "id": "m_2341",
    "sender": "Ankita",
    "time": "01:20",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "Gn8",
    "type": "text"
  },
  {
    "id": "m_2342",
    "sender": "Ratnadwip",
    "time": "01:20",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "sorry",
    "type": "text"
  },
  {
    "id": "m_2343",
    "sender": "Ratnadwip",
    "time": "01:20",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "oiiii",
    "type": "text"
  },
  {
    "id": "m_2344",
    "sender": "Ratnadwip",
    "time": "01:20",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "oiii",
    "type": "text"
  },
  {
    "id": "m_2345",
    "sender": "Ratnadwip",
    "time": "01:20",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "oiii",
    "type": "text"
  },
  {
    "id": "m_2346",
    "sender": "Ratnadwip",
    "time": "01:20",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "oii",
    "type": "text"
  },
  {
    "id": "m_2347",
    "sender": "Ratnadwip",
    "time": "01:20",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "sorry",
    "type": "text"
  },
  {
    "id": "m_2348",
    "sender": "Ratnadwip",
    "time": "01:21",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "😭😭😭😭",
    "type": "text"
  },
  {
    "id": "m_2349",
    "sender": "Ratnadwip",
    "time": "01:21",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "plssss",
    "type": "text"
  },
  {
    "id": "m_2350",
    "sender": "Ratnadwip",
    "time": "01:21",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "STK-20260809-WA0008.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0008.webp"
  },
  {
    "id": "m_2351",
    "sender": "Ratnadwip",
    "time": "01:21",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "dichhilam toh",
    "type": "text"
  },
  {
    "id": "m_2352",
    "sender": "Ratnadwip",
    "time": "01:21",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "😭😭😭😭",
    "type": "text"
  },
  {
    "id": "m_2353",
    "sender": "Ratnadwip",
    "time": "01:21",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "😭😭😭😭",
    "type": "text"
  },
  {
    "id": "m_2354",
    "sender": "Ratnadwip",
    "time": "01:21",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "sorry",
    "type": "text"
  },
  {
    "id": "m_2355",
    "sender": "Ratnadwip",
    "time": "01:21",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "sorry",
    "type": "text"
  },
  {
    "id": "m_2356",
    "sender": "Ratnadwip",
    "time": "01:22",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "😭😭😭",
    "type": "text"
  },
  {
    "id": "m_2357",
    "sender": "Ratnadwip",
    "time": "01:22",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "😭",
    "type": "text"
  },
  {
    "id": "m_2358",
    "sender": "Ratnadwip",
    "time": "01:22",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "😭😭",
    "type": "text"
  },
  {
    "id": "m_2359",
    "sender": "Ratnadwip",
    "time": "01:24",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "STK-20260809-WA0008.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0008.webp"
  },
  {
    "id": "m_2360",
    "sender": "Ratnadwip",
    "time": "01:28",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "🫩🫩",
    "type": "text"
  },
  {
    "id": "m_2361",
    "sender": "Ratnadwip",
    "time": "01:28",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "raat ghum ta gelo",
    "type": "text"
  },
  {
    "id": "m_2362",
    "sender": "Ratnadwip",
    "time": "01:28",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_2363",
    "sender": "Ratnadwip",
    "time": "01:28",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "You deleted this message",
    "type": "text"
  },
  {
    "id": "m_2364",
    "sender": "Ratnadwip",
    "time": "01:29",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "STK-20261014-WA0000.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20261014-WA0000.webp"
  },
  {
    "id": "m_2365",
    "sender": "Ratnadwip",
    "time": "01:36",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "",
    "type": "text"
  },
  {
    "id": "m_2366",
    "sender": "Ratnadwip",
    "time": "01:36",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "IMG-20261017-WA0004.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261017-WA0004.jpg"
  },
  {
    "id": "m_2367",
    "sender": "Ratnadwip",
    "time": "01:36",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "IMG-20261017-WA0005.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261017-WA0005.jpg"
  },
  {
    "id": "m_2368",
    "sender": "Ratnadwip",
    "time": "01:36",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "IMG-20261017-WA0006.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261017-WA0006.jpg"
  },
  {
    "id": "m_2369",
    "sender": "Ratnadwip",
    "time": "01:36",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "IMG-20261017-WA0008.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261017-WA0008.jpg"
  },
  {
    "id": "m_2370",
    "sender": "Ratnadwip",
    "time": "01:36",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "IMG-20261017-WA0007.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261017-WA0007.jpg"
  },
  {
    "id": "m_2371",
    "sender": "Ratnadwip",
    "time": "01:36",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "IMG-20261017-WA0010.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261017-WA0010.jpg"
  },
  {
    "id": "m_2372",
    "sender": "Ratnadwip",
    "time": "01:36",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "IMG-20261017-WA0009.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261017-WA0009.jpg"
  },
  {
    "id": "m_2373",
    "sender": "Ratnadwip",
    "time": "01:36",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "IMG-20261017-WA0012.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261017-WA0012.jpg"
  },
  {
    "id": "m_2374",
    "sender": "Ratnadwip",
    "time": "01:36",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "IMG-20261017-WA0011.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261017-WA0011.jpg"
  },
  {
    "id": "m_2375",
    "sender": "Ratnadwip",
    "time": "01:36",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "IMG-20261017-WA0013.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261017-WA0013.jpg"
  },
  {
    "id": "m_2376",
    "sender": "Ratnadwip",
    "time": "01:36",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "IMG-20261017-WA0014.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261017-WA0014.jpg"
  },
  {
    "id": "m_2377",
    "sender": "Ratnadwip",
    "time": "01:36",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "IMG-20261017-WA0015.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261017-WA0015.jpg"
  },
  {
    "id": "m_2378",
    "sender": "Ratnadwip",
    "time": "01:36",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "IMG-20261017-WA0016.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261017-WA0016.jpg"
  },
  {
    "id": "m_2379",
    "sender": "Ratnadwip",
    "time": "01:36",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "IMG-20261017-WA0018.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261017-WA0018.jpg"
  },
  {
    "id": "m_2380",
    "sender": "Ratnadwip",
    "time": "01:36",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "IMG-20261017-WA0017.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261017-WA0017.jpg"
  },
  {
    "id": "m_2381",
    "sender": "Ratnadwip",
    "time": "01:36",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "IMG-20261017-WA0034.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261017-WA0034.jpg"
  },
  {
    "id": "m_2382",
    "sender": "Ratnadwip",
    "time": "01:36",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "IMG-20261017-WA0023.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261017-WA0023.jpg"
  },
  {
    "id": "m_2383",
    "sender": "Ratnadwip",
    "time": "01:36",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "IMG-20261017-WA0031.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261017-WA0031.jpg"
  },
  {
    "id": "m_2384",
    "sender": "Ratnadwip",
    "time": "01:36",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "IMG-20261017-WA0020.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261017-WA0020.jpg"
  },
  {
    "id": "m_2385",
    "sender": "Ratnadwip",
    "time": "01:36",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "IMG-20261017-WA0019.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261017-WA0019.jpg"
  },
  {
    "id": "m_2386",
    "sender": "Ratnadwip",
    "time": "01:36",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "IMG-20261017-WA0026.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261017-WA0026.jpg"
  },
  {
    "id": "m_2387",
    "sender": "Ratnadwip",
    "time": "01:36",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "IMG-20261017-WA0041.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261017-WA0041.jpg"
  },
  {
    "id": "m_2388",
    "sender": "Ratnadwip",
    "time": "01:36",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "IMG-20261017-WA0025.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261017-WA0025.jpg"
  },
  {
    "id": "m_2389",
    "sender": "Ratnadwip",
    "time": "01:36",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "IMG-20261017-WA0033.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261017-WA0033.jpg"
  },
  {
    "id": "m_2390",
    "sender": "Ratnadwip",
    "time": "01:36",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "IMG-20261017-WA0029.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261017-WA0029.jpg"
  },
  {
    "id": "m_2391",
    "sender": "Ratnadwip",
    "time": "01:36",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "IMG-20261017-WA0021.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261017-WA0021.jpg"
  },
  {
    "id": "m_2392",
    "sender": "Ratnadwip",
    "time": "01:36",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "IMG-20261017-WA0022.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261017-WA0022.jpg"
  },
  {
    "id": "m_2393",
    "sender": "Ratnadwip",
    "time": "01:36",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "IMG-20261017-WA0038.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261017-WA0038.jpg"
  },
  {
    "id": "m_2394",
    "sender": "Ratnadwip",
    "time": "01:36",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "IMG-20261017-WA0036.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261017-WA0036.jpg"
  },
  {
    "id": "m_2395",
    "sender": "Ratnadwip",
    "time": "01:36",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "IMG-20261017-WA0024.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261017-WA0024.jpg"
  },
  {
    "id": "m_2396",
    "sender": "Ratnadwip",
    "time": "01:36",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "IMG-20261017-WA0028.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261017-WA0028.jpg"
  },
  {
    "id": "m_2397",
    "sender": "Ratnadwip",
    "time": "01:36",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "IMG-20261017-WA0027.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261017-WA0027.jpg"
  },
  {
    "id": "m_2398",
    "sender": "Ratnadwip",
    "time": "01:36",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "IMG-20261017-WA0032.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261017-WA0032.jpg"
  },
  {
    "id": "m_2399",
    "sender": "Ratnadwip",
    "time": "01:36",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "IMG-20261017-WA0030.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261017-WA0030.jpg"
  },
  {
    "id": "m_2400",
    "sender": "Ratnadwip",
    "time": "01:36",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "IMG-20261017-WA0040.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261017-WA0040.jpg"
  },
  {
    "id": "m_2401",
    "sender": "Ratnadwip",
    "time": "01:36",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "IMG-20261017-WA0042.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261017-WA0042.jpg"
  },
  {
    "id": "m_2402",
    "sender": "Ratnadwip",
    "time": "01:36",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "IMG-20261017-WA0043.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261017-WA0043.jpg"
  },
  {
    "id": "m_2403",
    "sender": "Ratnadwip",
    "time": "01:36",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "IMG-20261017-WA0035.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261017-WA0035.jpg"
  },
  {
    "id": "m_2404",
    "sender": "Ratnadwip",
    "time": "01:36",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "IMG-20261017-WA0037.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261017-WA0037.jpg"
  },
  {
    "id": "m_2405",
    "sender": "Ratnadwip",
    "time": "01:36",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "IMG-20261017-WA0039.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261017-WA0039.jpg"
  },
  {
    "id": "m_2406",
    "sender": "Ratnadwip",
    "time": "01:56",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "STK-20260809-WA0006.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0006.webp"
  },
  {
    "id": "m_2407",
    "sender": "Ratnadwip",
    "time": "02:26",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "STK-20261017-WA0045.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20261017-WA0045.webp"
  },
  {
    "id": "m_2408",
    "sender": "Ankita",
    "time": "13:17",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "STK-20261017-WA0003.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20261017-WA0003.webp"
  },
  {
    "id": "m_2409",
    "sender": "Ratnadwip",
    "time": "13:26",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "omg ke tule dilo, crazy image",
    "type": "text"
  },
  {
    "id": "m_2410",
    "sender": "Ratnadwip",
    "time": "13:26",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "STK-20261014-WA0000.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20261014-WA0000.webp"
  },
  {
    "id": "m_2411",
    "sender": "Ankita",
    "time": "13:33",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "Ami tulechilm",
    "type": "text"
  },
  {
    "id": "m_2412",
    "sender": "Ratnadwip",
    "time": "13:36",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "STK-20260812-WA0007.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260812-WA0007.webp"
  },
  {
    "id": "m_2413",
    "sender": "Ratnadwip",
    "time": "14:55",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "",
    "type": "text"
  },
  {
    "id": "m_2414",
    "sender": "Ankita",
    "time": "15:03",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "Kotha nei tor sathey",
    "type": "text"
  },
  {
    "id": "m_2415",
    "sender": "Ratnadwip",
    "time": "15:05",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "keno ki sundor video taaa",
    "type": "text"
  },
  {
    "id": "m_2416",
    "sender": "Ratnadwip",
    "time": "15:05",
    "date": "2026-10-17",
    "dateLabel": "17 October 2026",
    "text": "STK-20260828-WA0005.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260828-WA0005.webp"
  },
  {
    "id": "m_2417",
    "sender": "Ratnadwip",
    "time": "03:26",
    "date": "2026-10-18",
    "dateLabel": "18 October 2026",
    "text": "",
    "type": "text",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2418",
    "sender": "Ratnadwip",
    "time": "22:35",
    "date": "2026-10-18",
    "dateLabel": "18 October 2026",
    "text": "🤣🤣",
    "type": "text",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2419",
    "sender": "Ratnadwip",
    "time": "22:35",
    "date": "2026-10-18",
    "dateLabel": "18 October 2026",
    "text": "STK-20260728-WA0005.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260728-WA0005.webp",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2420",
    "sender": "Ratnadwip",
    "time": "22:35",
    "date": "2026-10-18",
    "dateLabel": "18 October 2026",
    "text": "🤣🤣",
    "type": "text",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2421",
    "sender": "Ratnadwip",
    "time": "22:43",
    "date": "2026-10-18",
    "dateLabel": "18 October 2026",
    "text": "🤣🤣🤣🤣",
    "type": "text",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2422",
    "sender": "Ankita",
    "time": "01:39",
    "date": "2026-10-19",
    "dateLabel": "19 October 2026",
    "text": "Homuman 🙋.vcf (file attached)",
    "type": "contact",
    "mediaName": "Homuman 🙋.vcf",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2423",
    "sender": "Ratnadwip",
    "time": "03:57",
    "date": "2026-10-19",
    "dateLabel": "19 October 2026",
    "text": "🫩",
    "type": "text",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2424",
    "sender": "Ratnadwip",
    "time": "18:28",
    "date": "2026-10-19",
    "dateLabel": "19 October 2026",
    "text": "",
    "type": "text",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2425",
    "sender": "Ratnadwip",
    "time": "18:31",
    "date": "2026-10-19",
    "dateLabel": "19 October 2026",
    "text": "network area r baire ki kore ??",
    "type": "text",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2426",
    "sender": "Ratnadwip",
    "time": "18:52",
    "date": "2026-10-19",
    "dateLabel": "19 October 2026",
    "text": "VID-20261019-WA0012.mp4 (file attached)",
    "type": "video",
    "mediaName": "VID-20261019-WA0012.mp4",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2427",
    "sender": "Ankita",
    "time": "18:53",
    "date": "2026-10-19",
    "dateLabel": "19 October 2026",
    "text": "STK-20261019-WA0014.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20261019-WA0014.webp",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2428",
    "sender": "Ratnadwip",
    "time": "21:19",
    "date": "2026-10-19",
    "dateLabel": "19 October 2026",
    "text": "STK-20261007-WA0008.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20261007-WA0008.webp",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2429",
    "sender": "Ratnadwip",
    "time": "22:00",
    "date": "2026-10-19",
    "dateLabel": "19 October 2026",
    "text": "oi",
    "type": "text",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2430",
    "sender": "Ratnadwip",
    "time": "22:07",
    "date": "2026-10-19",
    "dateLabel": "19 October 2026",
    "text": "",
    "type": "text",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2431",
    "sender": "Ratnadwip",
    "time": "22:08",
    "date": "2026-10-19",
    "dateLabel": "19 October 2026",
    "text": "STK-20260809-WA0024.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20260809-WA0024.webp",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2432",
    "sender": "Ankita",
    "time": "00:00",
    "date": "2026-10-20",
    "dateLabel": "20 October 2026",
    "text": "",
    "type": "text",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2433",
    "sender": "Ankita",
    "time": "00:01",
    "date": "2026-10-20",
    "dateLabel": "20 October 2026",
    "text": "",
    "type": "text",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2434",
    "sender": "Ratnadwip",
    "time": "00:06",
    "date": "2026-10-20",
    "dateLabel": "20 October 2026",
    "text": "IMG-20261020-WA0000.jpg (file attached)",
    "type": "image",
    "mediaName": "IMG-20261020-WA0000.jpg",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2435",
    "sender": "Ratnadwip",
    "time": "00:29",
    "date": "2026-10-20",
    "dateLabel": "20 October 2026",
    "text": "🥸",
    "type": "text",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2436",
    "sender": "Ratnadwip",
    "time": "00:29",
    "date": "2026-10-20",
    "dateLabel": "20 October 2026",
    "text": "kal sokal e sotti kotha bolabo kintu",
    "type": "text",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2437",
    "sender": "Ratnadwip",
    "time": "00:30",
    "date": "2026-10-20",
    "dateLabel": "20 October 2026",
    "text": "",
    "type": "text",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2438",
    "sender": "Ankita",
    "time": "00:36",
    "date": "2026-10-20",
    "dateLabel": "20 October 2026",
    "text": "Naaa",
    "type": "text",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2439",
    "sender": "Ratnadwip",
    "time": "00:36",
    "date": "2026-10-20",
    "dateLabel": "20 October 2026",
    "text": "kii ?",
    "type": "text",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2440",
    "sender": "Ankita",
    "time": "00:36",
    "date": "2026-10-20",
    "dateLabel": "20 October 2026",
    "text": "Aunty k manage kor tui",
    "type": "text",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2441",
    "sender": "Ratnadwip",
    "time": "00:36",
    "date": "2026-10-20",
    "dateLabel": "20 October 2026",
    "text": "okk",
    "type": "text",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2442",
    "sender": "Ratnadwip",
    "time": "00:37",
    "date": "2026-10-20",
    "dateLabel": "20 October 2026",
    "text": "eto taratari ghumiye porchis, crazy",
    "type": "text",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2443",
    "sender": "Ankita",
    "time": "00:37",
    "date": "2026-10-20",
    "dateLabel": "20 October 2026",
    "text": "Naa instay ektu por on ho",
    "type": "text",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2444",
    "sender": "Ratnadwip",
    "time": "00:38",
    "date": "2026-10-20",
    "dateLabel": "20 October 2026",
    "text": "STK-20261007-WA0008.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20261007-WA0008.webp",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2445",
    "sender": "Ankita",
    "time": "00:38",
    "date": "2026-10-20",
    "dateLabel": "20 October 2026",
    "text": "Bon pasey peko emni",
    "type": "text",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2446",
    "sender": "Ankita",
    "time": "10:05",
    "date": "2026-10-20",
    "dateLabel": "20 October 2026",
    "text": "",
    "type": "text",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2447",
    "sender": "Ratnadwip",
    "time": "10:06",
    "date": "2026-10-20",
    "dateLabel": "20 October 2026",
    "text": "",
    "type": "text",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2448",
    "sender": "Ankita",
    "time": "13:52",
    "date": "2026-10-20",
    "dateLabel": "20 October 2026",
    "text": "",
    "type": "text",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2449",
    "sender": "Ankita",
    "time": "16:16",
    "date": "2026-10-20",
    "dateLabel": "20 October 2026",
    "text": "Ai ai",
    "type": "text",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2450",
    "sender": "Ankita",
    "time": "16:16",
    "date": "2026-10-20",
    "dateLabel": "20 October 2026",
    "text": "Ki re",
    "type": "text",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2451",
    "sender": "Ankita",
    "time": "16:16",
    "date": "2026-10-20",
    "dateLabel": "20 October 2026",
    "text": "Oi",
    "type": "text",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2452",
    "sender": "Ankita",
    "time": "16:16",
    "date": "2026-10-20",
    "dateLabel": "20 October 2026",
    "text": "Huii",
    "type": "text",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2453",
    "sender": "Ankita",
    "time": "16:16",
    "date": "2026-10-20",
    "dateLabel": "20 October 2026",
    "text": "Oi",
    "type": "text",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2454",
    "sender": "Ratnadwip",
    "time": "16:22",
    "date": "2026-10-20",
    "dateLabel": "20 October 2026",
    "text": "ekhon o ekhan e",
    "type": "text",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2455",
    "sender": "Ratnadwip",
    "time": "16:22",
    "date": "2026-10-20",
    "dateLabel": "20 October 2026",
    "text": "toke call korchi pore",
    "type": "text",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2456",
    "sender": "Ratnadwip",
    "time": "16:22",
    "date": "2026-10-20",
    "dateLabel": "20 October 2026",
    "text": "tokhon call dhorte pari ni",
    "type": "text",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2457",
    "sender": "Ankita",
    "time": "16:24",
    "date": "2026-10-20",
    "dateLabel": "20 October 2026",
    "text": "Jni",
    "type": "text",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2458",
    "sender": "Ankita",
    "time": "16:24",
    "date": "2026-10-20",
    "dateLabel": "20 October 2026",
    "text": "Bolchi j",
    "type": "text",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2459",
    "sender": "Ratnadwip",
    "time": "16:24",
    "date": "2026-10-20",
    "dateLabel": "20 October 2026",
    "text": "bol",
    "type": "text",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2460",
    "sender": "Ratnadwip",
    "time": "16:27",
    "date": "2026-10-20",
    "dateLabel": "20 October 2026",
    "text": "ami bhetor e, beriye toke call korchi",
    "type": "text",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2461",
    "sender": "Ankita",
    "time": "16:51",
    "date": "2026-10-20",
    "dateLabel": "20 October 2026",
    "text": "🙃",
    "type": "text",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2462",
    "sender": "Ankita",
    "time": "17:12",
    "date": "2026-10-20",
    "dateLabel": "20 October 2026",
    "text": "IMG-20261020-WA0002.jpg (file attached)\nScan this to pay through PhonePe",
    "type": "image",
    "mediaName": "IMG-20261020-WA0002.jpg",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2463",
    "sender": "Ratnadwip",
    "time": "20:12",
    "date": "2026-10-20",
    "dateLabel": "20 October 2026",
    "text": "ghum dilam 🫩",
    "type": "text",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2464",
    "sender": "Ratnadwip",
    "time": "20:13",
    "date": "2026-10-20",
    "dateLabel": "20 October 2026",
    "text": "ekta tea ache",
    "type": "text",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2465",
    "sender": "Ratnadwip",
    "time": "20:13",
    "date": "2026-10-20",
    "dateLabel": "20 October 2026",
    "text": "kal bolbo",
    "type": "text",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2466",
    "sender": "Ankita",
    "time": "21:58",
    "date": "2026-10-20",
    "dateLabel": "20 October 2026",
    "text": "Accha",
    "type": "text",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2467",
    "sender": "Ankita",
    "time": "21:58",
    "date": "2026-10-20",
    "dateLabel": "20 October 2026",
    "text": "",
    "type": "text",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2468",
    "sender": "Ratnadwip",
    "time": "23:34",
    "date": "2026-10-20",
    "dateLabel": "20 October 2026",
    "text": "fahh",
    "type": "text",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2469",
    "sender": "Ratnadwip",
    "time": "23:34",
    "date": "2026-10-20",
    "dateLabel": "20 October 2026",
    "text": "jege ?",
    "type": "text",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2470",
    "sender": "Ratnadwip",
    "time": "23:54",
    "date": "2026-10-20",
    "dateLabel": "20 October 2026",
    "text": "STK-20261007-WA0008.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20261007-WA0008.webp",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2471",
    "sender": "Ratnadwip",
    "time": "23:56",
    "date": "2026-10-20",
    "dateLabel": "20 October 2026",
    "text": "STK-20261014-WA0000.webp (file attached)",
    "type": "sticker",
    "mediaName": "STK-20261014-WA0000.webp",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2472",
    "sender": "Ankita",
    "time": "00:31",
    "date": "2026-10-21",
    "dateLabel": "21 October 2026",
    "text": "Hyaaa",
    "type": "text",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2473",
    "sender": "Ankita",
    "time": "00:31",
    "date": "2026-10-21",
    "dateLabel": "21 October 2026",
    "text": "Jege",
    "type": "text",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2474",
    "sender": "Ratnadwip",
    "time": "00:31",
    "date": "2026-10-21",
    "dateLabel": "21 October 2026",
    "text": "sorry",
    "type": "text",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2475",
    "sender": "Ankita",
    "time": "00:31",
    "date": "2026-10-21",
    "dateLabel": "21 October 2026",
    "text": "Kiser jnno",
    "type": "text",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2476",
    "sender": "Ankita",
    "time": "00:31",
    "date": "2026-10-21",
    "dateLabel": "21 October 2026",
    "text": "?",
    "type": "text",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2477",
    "sender": "Ratnadwip",
    "time": "00:31",
    "date": "2026-10-21",
    "dateLabel": "21 October 2026",
    "text": "kal faltu faltu onek plan koralam",
    "type": "text",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2478",
    "sender": "Ratnadwip",
    "time": "00:31",
    "date": "2026-10-21",
    "dateLabel": "21 October 2026",
    "text": "🫩🫩",
    "type": "text",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2479",
    "sender": "Ankita",
    "time": "00:32",
    "date": "2026-10-21",
    "dateLabel": "21 October 2026",
    "text": "Call?",
    "type": "text",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2480",
    "sender": "Ratnadwip",
    "time": "00:32",
    "date": "2026-10-21",
    "dateLabel": "21 October 2026",
    "text": "koro",
    "type": "text",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2481",
    "sender": "Ankita",
    "time": "00:32",
    "date": "2026-10-21",
    "dateLabel": "21 October 2026",
    "text": "U",
    "type": "text",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2482",
    "sender": "Ratnadwip",
    "time": "00:32",
    "date": "2026-10-21",
    "dateLabel": "21 October 2026",
    "text": "korbo ?",
    "type": "text",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2483",
    "sender": "Ratnadwip",
    "time": "00:32",
    "date": "2026-10-21",
    "dateLabel": "21 October 2026",
    "text": "yes mam",
    "type": "text",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2484",
    "sender": "Ankita",
    "time": "00:32",
    "date": "2026-10-21",
    "dateLabel": "21 October 2026",
    "text": "😒",
    "type": "text",
    "milestone": "Kolkata Trip"
  },
  {
    "id": "m_2485",
    "sender": "Ratnadwip",
    "time": "00:54",
    "date": "2026-10-22",
    "dateLabel": "22 October 2026",
    "text": "hacknexxxxxx",
    "type": "text",
    "milestone": "October 23 Breakdown"
  },
  {
    "id": "m_2486",
    "sender": "Ratnadwip",
    "time": "14:17",
    "date": "2026-10-22",
    "dateLabel": "22 October 2026",
    "text": "oiii",
    "type": "text",
    "milestone": "October 23 Breakdown"
  },
  {
    "id": "m_2487",
    "sender": "Ratnadwip",
    "time": "14:17",
    "date": "2026-10-22",
    "dateLabel": "22 October 2026",
    "text": "ki holo",
    "type": "text",
    "milestone": "October 23 Breakdown"
  },
  {
    "id": "m_2488",
    "sender": "Ratnadwip",
    "time": "14:17",
    "date": "2026-10-22",
    "dateLabel": "22 October 2026",
    "text": "jai ni toh",
    "type": "text",
    "milestone": "October 23 Breakdown"
  },
  {
    "id": "m_2489",
    "sender": "Ratnadwip",
    "time": "14:17",
    "date": "2026-10-22",
    "dateLabel": "22 October 2026",
    "text": "oiii",
    "type": "text",
    "milestone": "October 23 Breakdown"
  },
  {
    "id": "m_2490",
    "sender": "Ratnadwip",
    "time": "22:28",
    "date": "2026-10-22",
    "dateLabel": "22 October 2026",
    "text": "😓😓",
    "type": "text",
    "milestone": "October 23 Breakdown"
  },
  {
    "id": "m_2491",
    "sender": "Ratnadwip",
    "time": "21:23",
    "date": "2026-10-23",
    "dateLabel": "23 October 2026",
    "text": "https://github.com/aakarim/OpenLore\nhttps://github.com/Arindam200/awesome-ai-apps\nhttps://github.com/Graphify-Labs/graphify",
    "type": "link",
    "linkUrl": "https://github.com/aakarim/OpenLore",
    "milestone": "October 23 Breakdown"
  },
  {
    "id": "m_2492",
    "sender": "Ankita",
    "time": "22:31",
    "date": "2026-10-23",
    "dateLabel": "23 October 2026",
    "text": "Dakh",
    "type": "text",
    "milestone": "October 23 Breakdown"
  },
  {
    "id": "m_2493",
    "sender": "Ratnadwip",
    "time": "22:31",
    "date": "2026-10-23",
    "dateLabel": "23 October 2026",
    "text": "kake ?",
    "type": "text",
    "milestone": "October 23 Breakdown"
  },
  {
    "id": "m_2494",
    "sender": "Ankita",
    "time": "22:31",
    "date": "2026-10-23",
    "dateLabel": "23 October 2026",
    "text": "Ami tor theke durey thakte chai",
    "type": "text",
    "milestone": "October 23 Breakdown"
  },
  {
    "id": "m_2495",
    "sender": "Ankita",
    "time": "22:31",
    "date": "2026-10-23",
    "dateLabel": "23 October 2026",
    "text": "Byass",
    "type": "text",
    "milestone": "October 23 Breakdown"
  },
  {
    "id": "m_2496",
    "sender": "Ratnadwip",
    "time": "22:31",
    "date": "2026-10-23",
    "dateLabel": "23 October 2026",
    "text": "kih ?",
    "type": "text",
    "milestone": "October 23 Breakdown"
  },
  {
    "id": "m_2497",
    "sender": "Ankita",
    "time": "22:31",
    "date": "2026-10-23",
    "dateLabel": "23 October 2026",
    "text": "Hya",
    "type": "text",
    "milestone": "October 23 Breakdown"
  },
  {
    "id": "m_2498",
    "sender": "Ankita",
    "time": "22:31",
    "date": "2026-10-23",
    "dateLabel": "23 October 2026",
    "text": "I'm not interested with u",
    "type": "text",
    "milestone": "October 23 Breakdown"
  },
  {
    "id": "m_2499",
    "sender": "Ankita",
    "time": "22:31",
    "date": "2026-10-23",
    "dateLabel": "23 October 2026",
    "text": "Sry for everything",
    "type": "text",
    "milestone": "October 23 Breakdown"
  },
  {
    "id": "m_2500",
    "sender": "Ratnadwip",
    "time": "22:31",
    "date": "2026-10-23",
    "dateLabel": "23 October 2026",
    "text": "se toh jani",
    "type": "text",
    "milestone": "October 23 Breakdown"
  },
  {
    "id": "m_2501",
    "sender": "Ratnadwip",
    "time": "22:31",
    "date": "2026-10-23",
    "dateLabel": "23 October 2026",
    "text": "kih?",
    "type": "text",
    "milestone": "October 23 Breakdown"
  },
  {
    "id": "m_2502",
    "sender": "Ankita",
    "time": "22:31",
    "date": "2026-10-23",
    "dateLabel": "23 October 2026",
    "text": "So ami disturb koris na",
    "type": "text",
    "milestone": "October 23 Breakdown"
  },
  {
    "id": "m_2503",
    "sender": "Ratnadwip",
    "time": "22:32",
    "date": "2026-10-23",
    "dateLabel": "23 October 2026",
    "text": "bruh",
    "type": "text",
    "milestone": "October 23 Breakdown"
  },
  {
    "id": "m_2504",
    "sender": "Ratnadwip",
    "time": "22:32",
    "date": "2026-10-23",
    "dateLabel": "23 October 2026",
    "text": "bondhu r moto e bollam",
    "type": "text",
    "milestone": "October 23 Breakdown"
  },
  {
    "id": "m_2505",
    "sender": "Ratnadwip",
    "time": "22:32",
    "date": "2026-10-23",
    "dateLabel": "23 October 2026",
    "text": "ar kal ele actually bhalo hoi",
    "type": "text",
    "milestone": "October 23 Breakdown"
  },
  {
    "id": "m_2506",
    "sender": "Ratnadwip",
    "time": "22:32",
    "date": "2026-10-23",
    "dateLabel": "23 October 2026",
    "text": "shon",
    "type": "text",
    "milestone": "October 23 Breakdown"
  },
  {
    "id": "m_2507",
    "sender": "Ankita",
    "time": "22:32",
    "date": "2026-10-23",
    "dateLabel": "23 October 2026",
    "text": "As a fd mjhey moddhey kotha bolte pari but roj ato phone calls msg koris na ami disturb hocchi plz",
    "type": "text",
    "milestone": "October 23 Breakdown"
  },
  {
    "id": "m_2508",
    "sender": "Ratnadwip",
    "time": "22:32",
    "date": "2026-10-23",
    "dateLabel": "23 October 2026",
    "text": "ok",
    "type": "text",
    "milestone": "October 23 Breakdown"
  },
  {
    "id": "m_2509",
    "sender": "Ankita",
    "time": "22:32",
    "date": "2026-10-23",
    "dateLabel": "23 October 2026",
    "text": "Hobe na",
    "type": "text",
    "milestone": "October 23 Breakdown"
  },
  {
    "id": "m_2510",
    "sender": "Ratnadwip",
    "time": "22:33",
    "date": "2026-10-23",
    "dateLabel": "23 October 2026",
    "text": "bruh",
    "type": "text",
    "milestone": "October 23 Breakdown"
  },
  {
    "id": "m_2511",
    "sender": "Ankita",
    "time": "22:33",
    "date": "2026-10-23",
    "dateLabel": "23 October 2026",
    "text": "Jabo na kal amr sorir bhlo nei",
    "type": "text",
    "milestone": "October 23 Breakdown"
  },
  {
    "id": "m_2512",
    "sender": "Ratnadwip",
    "time": "22:33",
    "date": "2026-10-23",
    "dateLabel": "23 October 2026",
    "text": "monday ki college hobe ?",
    "type": "text",
    "milestone": "October 23 Breakdown"
  },
  {
    "id": "m_2513",
    "sender": "Ratnadwip",
    "time": "22:33",
    "date": "2026-10-23",
    "dateLabel": "23 October 2026",
    "text": "tale college ei boste hobe",
    "type": "text",
    "milestone": "October 23 Breakdown"
  },
  {
    "id": "m_2514",
    "sender": "Ankita",
    "time": "22:36",
    "date": "2026-10-23",
    "dateLabel": "23 October 2026",
    "text": "Idk",
    "type": "text",
    "milestone": "October 23 Breakdown"
  },
  {
    "id": "m_2515",
    "sender": "Ankita",
    "time": "22:36",
    "date": "2026-10-23",
    "dateLabel": "23 October 2026",
    "text": "Plz call yur HOD",
    "type": "text",
    "milestone": "October 23 Breakdown"
  }
];
